import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
  Json: any;
  NaiveDateTime: any;
  UUID4: any;
};

export type Account = {
  __typename?: 'Account';
  accountType?: Maybe<AccountType>;
  /** Indicates whether the account has limited address management enabled. When true, addresses for this account must be managed by administrators. This is automatically set to true when the account is invoiced or has specific managed address tags (e.g., ATD). */
  administratorManagedAddresses?: Maybe<Scalars['Boolean']>;
  /** When true, this account may add out-of-stock items to its cart (e.g. to build a scheduled order for a future delivery date). This is a purpose-specific flag; the frontend should gate on it rather than reading the underlying eligibility rule. */
  allowAddOosToCart: Scalars['Boolean'];
  /** Whether this account can use customer PO numbers, derived from invoicing and account-type configuration. */
  allowPoNumber: Scalars['Boolean'];
  appId?: Maybe<Scalars['UUID4']>;
  /** When true, this AFH account can view any partner's product pages, not just its own. */
  canViewAllLicenseVariants: Scalars['Boolean'];
  /** When true, the phone extension field should be collected when entering or editing shipping addresses. The backend derives this from the account type; the frontend should gate on this flag rather than inspecting account identity directly. */
  collectPhoneExtension: Scalars['Boolean'];
  credits: Array<Credit>;
  /** The custom product page key used to redirect users to a custom product listing page after login. */
  frontEndCustomPlpKey?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID4']>;
  invoicing?: Maybe<Invoicing>;
  /** Whether this account is currently paused. */
  isPaused: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  /** When the account was paused. Null if not paused. */
  pausedAt?: Maybe<Scalars['DateTime']>;
  scheduledOrders?: Maybe<ScheduledOrderPayload>;
  submittedOrders?: Maybe<SubmittedOrderPayload>;
  /** @deprecated Account tags are no longer used. This field will always return an empty list. */
  tags?: Maybe<Array<Scalars['String']>>;
  type: Scalars['String'];
};


export type AccountCreditsArgs = {
  search?: InputMaybe<AccountCreditsSearchInput>;
};


export type AccountScheduledOrdersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<ScheduledOrderSearchInput>;
  status?: InputMaybe<ScheduledOrderStatusFilter>;
};


export type AccountSubmittedOrdersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  reorderable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export type AccountActivationInput = {
  acceptedTerms: Scalars['Boolean'];
  emailOptIn: Scalars['Boolean'];
  password: Scalars['String'];
  token: Scalars['String'];
};

export enum AccountCreditStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE'
}

export enum AccountCreditType {
  Allocation = 'ALLOCATION',
  Prepaid = 'PREPAID'
}

export type AccountCreditsSearchInput = {
  frozen?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Array<InputMaybe<AccountCreditStatus>>>;
  type?: InputMaybe<AccountCreditType>;
};

export type AccountType = {
  __typename?: 'AccountType';
  allowPoNumber?: Maybe<Scalars['Boolean']>;
  allowScheduledOrders?: Maybe<Scalars['Boolean']>;
  /** When true, the phone extension field should be collected when entering or editing addresses for accounts of this type. */
  collectPhoneExtension: Scalars['Boolean'];
  forceAcceptsLtl?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID4'];
  /** The unique key identifier for this account type within a tenant. Use with care — this is intended for programmatic lookups, not display. */
  key?: Maybe<Scalars['String']>;
  /** How the PDP quantity input should render for accounts of this type. Derived from showQuantityPerPack. */
  quantityDisplay: QuantityDisplay;
  showGtin?: Maybe<Scalars['Boolean']>;
  showQuantityPerPack?: Maybe<Scalars['Boolean']>;
  /** The slug used by the shop when navigating to the storefront for this account type. */
  slug?: Maybe<Scalars['String']>;
  subStore?: Maybe<SubStore>;
  supportEmail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AccountVerificationLocalization = {
  __typename?: 'AccountVerificationLocalization';
  body: Scalars['String'];
  buttonText: Scalars['String'];
  contactSupportText: Scalars['String'];
  emailSentText: Scalars['String'];
  heading: Scalars['String'];
  invalidLinkText: Scalars['String'];
  tokenExpiredText: Scalars['String'];
  verifySuccessText: Scalars['String'];
};

export type AccountsConfig = {
  __typename?: 'AccountsConfig';
  /** when activating a platform-admin-created user account, we require accepting terms and conditions. */
  accountActivationAcceptTerms: Scalars['Boolean'];
  /** when activating a platform-admin-created user account, we collect an email marketing opt-in choice. */
  accountActivationCollectEmailOptIn: Scalars['Boolean'];
};

/**
 * Account that the user is currently logged into.
 *
 * This will only exist if the user belongs to an account.
 */
export type ActiveAccount = {
  __typename?: 'ActiveAccount';
  administratorManagedAddresses?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID4'];
  isInvoiced?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type AddCartCustomizationsPayload = {
  __typename?: 'AddCartCustomizationsPayload';
  /** Ordered list of customization IDs for entries that passed validation */
  customizationIds: Array<Scalars['UUID4']>;
  /** Per-entry validation errors. Each error includes the input index so the caller can map failures back to specific spreadsheet rows. */
  errors: Array<CustomizationEntryError>;
};

export type AddCartItemUniqueVariantInput = {
  /** Analytics details for the item (map) */
  analyticsDetails?: InputMaybe<Scalars['Json']>;
  /** Bundle data for dynamic bundle variants */
  bundleData?: InputMaybe<BundleDataInput>;
  /** IDs of customizations already stored on the cart. Use instead of typed_customizations when the FE already has IDs from a previous call. Cannot be combined with typed_customizations. */
  customizationIds?: InputMaybe<Array<Scalars['UUID4']>>;
  /** [DEPRECATED] Customizations for the item (list of maps). Use typed_customizations instead for better type safety. Will be removed after 2026-06-01. */
  customizations?: InputMaybe<Scalars['Json']>;
  /** When true, opts out of the per-customization cart-item expansion even if the tenant has expand_kit_customizations enabled. Intended for GatoradeShop FE migration only. */
  disableKitCustomizationExpansion?: InputMaybe<Scalars['Boolean']>;
  /** HSPP Kit data for hspp_kit variants */
  hsppKitData?: InputMaybe<HsppKitDataInput>;
  /** Kit data for kit variants */
  kitData?: InputMaybe<KitDataInput>;
  /** The quantity to add */
  quantity: Scalars['Int'];
  /** Typed customizations for the item (recommended) */
  typedCustomizations?: InputMaybe<Array<InputMaybe<CustomizationInput>>>;
  /** The GTIN of the variant to add */
  variantGtin: Scalars['String'];
};

export type AddCartItemUniqueVariantSubscriptionInput = {
  /** Analytics details for the item (map) */
  analyticsDetails?: InputMaybe<Scalars['Json']>;
  /** Bundle data for dynamic bundle variants */
  bundleData?: InputMaybe<BundleDataInput>;
  /** IDs of customizations already stored on the cart. Use instead of typed_customizations when the FE already has IDs from a previous call. Cannot be combined with typed_customizations. */
  customizationIds?: InputMaybe<Array<Scalars['UUID4']>>;
  /** [DEPRECATED] Customizations for the item (list of maps). Use typed_customizations instead for better type safety. Will be removed after 2026-06-01. */
  customizations?: InputMaybe<Scalars['Json']>;
  /** Kit data for kit variants */
  kitData?: InputMaybe<KitDataInput>;
  /** The quantity to add */
  quantity: Scalars['Int'];
  /** The subscription interval in days */
  subscriptionIntervalInDays: Scalars['Int'];
  /** Typed customizations for the item (recommended) */
  typedCustomizations?: InputMaybe<Array<InputMaybe<CustomizationInput>>>;
  /** The GTIN of the variant to add */
  variantGtin: Scalars['String'];
};

export type AddOrderSubscriptionItemInput = {
  analyticsDetails?: InputMaybe<Scalars['Json']>;
  customizations?: InputMaybe<Scalars['Json']>;
  itemId: Scalars['UUID4'];
  quantity: Scalars['Int'];
};

export type AddOrderSubscriptionUniqueVariantInput = {
  /** Analytics details for the item (map) */
  analyticsDetails?: InputMaybe<Scalars['Json']>;
  /** Bundle data for dynamic bundle variants */
  bundleData?: InputMaybe<BundleDataInput>;
  /** IDs of customizations already stored on the subscription. Use instead of typed_customizations when the FE already has IDs from a previous call. Cannot be combined with typed_customizations. */
  customizationIds?: InputMaybe<Array<Scalars['UUID4']>>;
  /** [DEPRECATED] Customizations for the item (list of maps). Use typed_customizations instead for better type safety. Will be removed after 2026-06-01. */
  customizations?: InputMaybe<Scalars['Json']>;
  /** Kit data for kit variants */
  kitData?: InputMaybe<KitDataInput>;
  /** The quantity to add */
  quantity: Scalars['Int'];
  /** Typed customizations for the item (recommended) */
  typedCustomizations?: InputMaybe<Array<InputMaybe<CustomizationInput>>>;
  /** The GTIN of the variant to add */
  variantGtin: Scalars['String'];
};

export type AddScheduledOrderUniqueVariantInput = {
  /** Analytics details for the Item. */
  analyticsDetails?: InputMaybe<Scalars['Json']>;
  /** IDs of customizations already stored on the temporary Scheduled Order cart. Cannot be combined with customizations or typedCustomizations. */
  customizationIds?: InputMaybe<Array<Scalars['UUID4']>>;
  /** [DEPRECATED] Customizations for the Item (list of maps). Use typedCustomizations instead for better type safety. */
  customizations?: InputMaybe<Scalars['Json']>;
  /** The quantity to add. */
  quantity: Scalars['Int'];
  /** The temporary Scheduled Order ID returned by createTempScheduledOrder. */
  scheduledOrderId: Scalars['UUID4'];
  /** Typed customizations for the Item. */
  typedCustomizations?: InputMaybe<Array<InputMaybe<CustomizationInput>>>;
  /** The GTIN of the Item variant to add. */
  variantGtin: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  /** This field indicates whether this address has a loading dock and accepts LTL (less than truckload) shipments. */
  acceptsLtl: Scalars['Boolean'];
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['UUID4'];
  isDefault?: Maybe<Scalars['Boolean']>;
  isRemovable?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  phoneExtension?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  user: User;
  zip: Scalars['String'];
};

export type AddressConfig = {
  __typename?: 'AddressConfig';
  addressNickname?: Maybe<Scalars['Boolean']>;
  addressSpecialInstructions?: Maybe<Scalars['Boolean']>;
  companyName?: Maybe<Scalars['Boolean']>;
  countriesAllowed: Array<CountriesAllowed>;
  isStateRequired?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  phoneNumberCountryCodesAllowed?: Maybe<Array<Maybe<PhoneNumberCountryCodesAllowed>>>;
  requireValidation: ValidationRequirement;
  statesConfig: Array<StatesConfig>;
  taxId?: Maybe<Scalars['Boolean']>;
};

export type AddressVerificationLocalization = {
  __typename?: 'AddressVerificationLocalization';
  addressErrorBoldText: Scalars['String'];
  addressErrorText: Scalars['String'];
  editManuallyText: Scalars['String'];
  editOnlyText: Scalars['String'];
  editOrSuggestionText: Scalars['String'];
  enteredAddressText: Scalars['String'];
  invalidZipCodeText: Scalars['String'];
  keepEnteredButtonText: Scalars['String'];
  reviewAddressText: Scalars['String'];
  suggestedAddressText: Scalars['String'];
  titleText: Scalars['String'];
  useSuggestedButtonText: Scalars['String'];
  zipErrorBoldText: Scalars['String'];
  zipErrorText: Scalars['String'];
};

export type AdjustCartItemUniqueVariantInput = {
  /** The ID of the cart item to adjust */
  cartItemId: Scalars['UUID4'];
  /** The quantity to set (0 to remove) */
  quantity: Scalars['Int'];
};

export type AdjustCartItemVariantInput = {
  /** The quantity to set (0 to remove) */
  quantity: Scalars['Int'];
  /** The GTIN of the variant to adjust */
  variantGtin: Scalars['String'];
};

export type AdjustCartItemVariantSubscriptionInput = {
  /** The quantity to set (0 to remove) */
  quantity: Scalars['Int'];
  /** The subscription interval in days */
  subscriptionIntervalInDays: Scalars['Int'];
  /** The GTIN of the variant to adjust */
  variantGtin: Scalars['String'];
};

export type AdjustOrderSubscriptionUniqueVariantInput = {
  /** The quantity to set (0 to remove) */
  quantity: Scalars['Int'];
  /** The ID of the subscription variant to adjust */
  subscriptionVariantId: Scalars['UUID4'];
};

export type AdjustScheduledOrderUniqueVariantInput = {
  /** The ID of the Item or HSPP kit Line Item to adjust in the temporary Scheduled Order. */
  lineItemId: Scalars['UUID4'];
  /** The quantity to set. Use 0 to remove the Line Item. */
  quantity: Scalars['Int'];
  /** The temporary Scheduled Order ID returned by createTempScheduledOrder. */
  scheduledOrderId: Scalars['UUID4'];
};

export type AdvancedVariantSearchResult = {
  __typename?: 'AdvancedVariantSearchResult';
  hit: Scalars['Json'];
  variant: Variant;
};

export type AllocatedCreditInput = {
  /** allocated credit line ID */
  id: Scalars['UUID4'];
};

/** Allocated credit payment data for split payment entries */
export type AllocatedCreditPaymentData = {
  __typename?: 'AllocatedCreditPaymentData';
  id?: Maybe<Scalars['String']>;
};

/** List of allowed payment methods. */
export enum AllowedPaymentMethod {
  AllocatedCredit = 'ALLOCATED_CREDIT',
  ApplePay = 'APPLE_PAY',
  Blik = 'BLIK',
  CreditCard = 'CREDIT_CARD',
  FreeOfCharge = 'FREE_OF_CHARGE',
  Invoice = 'INVOICE',
  Link = 'LINK',
  P24 = 'P24',
  PaymentIntent = 'PAYMENT_INTENT',
  Paypal = 'PAYPAL',
  SplitPayment = 'SPLIT_PAYMENT'
}

export type AllowedState = {
  __typename?: 'AllowedState';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AnalyticsConfig = {
  __typename?: 'AnalyticsConfig';
  gtm?: Maybe<GtmConfig>;
  projectId?: Maybe<Scalars['String']>;
  writeKey?: Maybe<Scalars['String']>;
};

export type ApplePayCard = {
  __typename?: 'ApplePayCard';
  billingAddress?: Maybe<BraintreeAddress>;
  bin: Scalars['String'];
  cardType: Scalars['String'];
  cardholderName: Scalars['String'];
  countryOfIssuance: Scalars['String'];
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  default: Scalars['Boolean'];
  expirationMonth: Scalars['String'];
  expirationYear: Scalars['String'];
  expired: Scalars['Boolean'];
  imageUrl: Scalars['String'];
  issuingBank: Scalars['String'];
  last4: Scalars['String'];
  paymentInstrumentName: Scalars['String'];
  productId: Scalars['String'];
  sourceDescription: Scalars['String'];
  subscriptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  token: Scalars['String'];
  updatedAt: Scalars['String'];
};

/** Input for mutation to save apple pay payment information */
export type ApplePayInput = {
  unused?: InputMaybe<Scalars['Boolean']>;
};

export type ArchivedItemsInCartData = {
  __typename?: 'ArchivedItemsInCartData';
  cartItemId: Scalars['UUID4'];
};

export type ArchivedItemsInCartValidationError = ValidationError & {
  __typename?: 'ArchivedItemsInCartValidationError';
  details: Array<ArchivedItemsInCartData>;
  reason: Scalars['String'];
};

export type AssortmentExclusionData = {
  __typename?: 'AssortmentExclusionData';
  itemId: Scalars['UUID4'];
};

export type AssortmentExclusionValidationError = ValidationError & {
  __typename?: 'AssortmentExclusionValidationError';
  details: Array<AssortmentExclusionData>;
  reason: Scalars['String'];
};

export type AssortmentInclusionData = {
  __typename?: 'AssortmentInclusionData';
  itemId: Scalars['UUID4'];
};

export type AssortmentInclusionValidationError = ValidationError & {
  __typename?: 'AssortmentInclusionValidationError';
  details: Array<AssortmentInclusionData>;
  reason: Scalars['String'];
};

/**
 * The `available_payment_methods` object contains all the payment methods
 * available to the user.
 *
 * The field `allowed_payment_methods` is a list of all the payment methods
 * that the user has available to them. If the user does not have access to
 * a specific payment method then that field will be `null`.
 */
export type AvailablePaymentMethods = {
  __typename?: 'AvailablePaymentMethods';
  allocatedCredit?: Maybe<Credit>;
  allowedPaymentMethods: Array<AllowedPaymentMethod>;
  creditCard?: Maybe<PaymentMethodCreditCard>;
  paypal?: Maybe<PaymentMethodPaypal>;
};

export type BasicBehaviour = {
  __typename?: 'BasicBehaviour';
  name: BehaviourEnum;
};

export type Bazaarvoice = {
  __typename?: 'Bazaarvoice';
  encryptedEmail?: Maybe<Scalars['String']>;
  encryptionKeyId?: Maybe<Scalars['String']>;
};

/** Behaviour which may or may not have attributes */
export type Behaviour = BasicBehaviour | BogoAdvancedBehaviour | BogoBehaviour | DynamicBundlesBehaviour | FocBehaviour | NullBehaviour | StackedDiscountBehavior | TieredBehaviour;

export enum BehaviourEnum {
  /** Basic discount logic, discounts all matching items by configured amount. */
  Basic = 'BASIC',
  /** Buy one (or many) get one (or many) at the specified percent off */
  Bogo = 'BOGO',
  /** Buy one (or many) get one (or many) at the specified percent off */
  BogoAdvanced = 'BOGO_ADVANCED',
  /** Dynamic Bundles discount logic, discounts matching items designated with the campaign_id */
  DynamicBundles = 'DYNAMIC_BUNDLES',
  /** Free of Charge Logic for Customer Service Orders. */
  Foc = 'FOC',
  /** Null discount logic, does nothing. */
  Null = 'NULL',
  /** Secondary discount logic, also known as stacked discounts. This is an additional discount on top of any other discount. */
  StackedDiscount = 'STACKED_DISCOUNT',
  /** Tiered discount logic, discounts matching items according to a tier structure. */
  Tiered = 'TIERED'
}

export type BillingAddress = {
  __typename?: 'BillingAddress';
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type BillingAddressInput = {
  city: Scalars['String'];
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type BogoAdvancedAttributes = {
  __typename?: 'BogoAdvancedAttributes';
  applyAmount: Scalars['Int'];
  applyVariants?: Maybe<Array<Maybe<Variant>>>;
  maxTriggers?: Maybe<Scalars['Int']>;
  orderSubtotalThreshold?: Maybe<Scalars['Int']>;
  triggerPoint: Scalars['Int'];
  triggerVariants?: Maybe<Array<Maybe<Variant>>>;
};

export type BogoAdvancedBehaviour = {
  __typename?: 'BogoAdvancedBehaviour';
  attributes: BogoAdvancedAttributes;
  name: BehaviourEnum;
};

export type BogoAttributes = {
  __typename?: 'BogoAttributes';
  applyAmount: Scalars['Int'];
  triggerPoint: Scalars['Int'];
};

export type BogoBehaviour = {
  __typename?: 'BogoBehaviour';
  attributes: BogoAttributes;
  name: BehaviourEnum;
};

export type BotProtection = {
  __typename?: 'BotProtection';
  active: Scalars['Boolean'];
  provider?: Maybe<BotProtectionProvider>;
  siteKey?: Maybe<BotProtectionSiteKey>;
};

export enum BotProtectionProvider {
  GoogleRecaptcha = 'GOOGLE_RECAPTCHA'
}

export type BotProtectionSiteKey = {
  __typename?: 'BotProtectionSiteKey';
  android: Scalars['String'];
  ios: Scalars['String'];
  web: Scalars['String'];
};

export type BraintreeAddress = {
  __typename?: 'BraintreeAddress';
  company?: Maybe<Scalars['String']>;
  countryCodeAlpha2?: Maybe<Scalars['String']>;
  countryCodeAlpha3?: Maybe<Scalars['String']>;
  countryCodeNumeric?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  extendedAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type BrandConfig = {
  __typename?: 'BrandConfig';
  audience: Scalars['String'];
  cdnHost?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  contactUrl?: Maybe<Scalars['String']>;
  copyright: Scalars['String'];
  customCss?: Maybe<Scalars['String']>;
  customTexts: Array<CustomText>;
  customizations: BrandConfigCustomizations;
  email?: Maybe<Scalars['String']>;
  logoUrl: Scalars['String'];
  optInTextLocalized: Scalars['String'];
  supportEmail?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  trackingFonts?: Maybe<Array<BrandConfigTrackingFonts>>;
  yearsAgeGate?: Maybe<Scalars['Int']>;
};

export type BrandConfigCustomizations = {
  __typename?: 'BrandConfigCustomizations';
  account?: Maybe<BrandConfigCustomizationsAccount>;
  contacts: Array<BrandConfigCustomizationsContact>;
  css: Array<BrandConfigCustomizationsCss>;
  fonts: Array<BrandConfigCustomizationsFont>;
  images: Array<BrandConfigCustomizationsImage>;
  links: Array<BrandConfigCustomizationsLink>;
};

export type BrandConfigCustomizationsAccount = {
  __typename?: 'BrandConfigCustomizationsAccount';
  profilePageTitle?: Maybe<Scalars['String']>;
  signinPageTitle?: Maybe<Scalars['String']>;
  signupPageTitle?: Maybe<Scalars['String']>;
  valueprops: Array<BrandConfigCustomizationsAccountValueprops>;
};

export type BrandConfigCustomizationsAccountValueprops = {
  __typename?: 'BrandConfigCustomizationsAccountValueprops';
  imgUrl?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type BrandConfigCustomizationsContact = {
  __typename?: 'BrandConfigCustomizationsContact';
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  showCountry?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  zip?: Maybe<Scalars['String']>;
};

export type BrandConfigCustomizationsCss = {
  __typename?: 'BrandConfigCustomizationsCss';
  overrides: Array<BrandConfigCustomizationsCssOverride>;
  selector: Scalars['String'];
};

export type BrandConfigCustomizationsCssOverride = {
  __typename?: 'BrandConfigCustomizationsCssOverride';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type BrandConfigCustomizationsFont = {
  __typename?: 'BrandConfigCustomizationsFont';
  meta?: Maybe<Array<BrandConfigCustomizationsFontMeta>>;
  name: Scalars['String'];
  style?: Maybe<Scalars['String']>;
  urls: Array<BrandConfigCustomizationsFontSources>;
  weight?: Maybe<Scalars['String']>;
};

export type BrandConfigCustomizationsFontMeta = {
  __typename?: 'BrandConfigCustomizationsFontMeta';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type BrandConfigCustomizationsFontSources = {
  __typename?: 'BrandConfigCustomizationsFontSources';
  format?: Maybe<Scalars['String']>;
  local?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type BrandConfigCustomizationsImage = {
  __typename?: 'BrandConfigCustomizationsImage';
  alt?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  src: Scalars['String'];
};

export type BrandConfigCustomizationsLink = {
  __typename?: 'BrandConfigCustomizationsLink';
  features?: Maybe<Array<Scalars['String']>>;
  location: Scalars['String'];
  newTab: Scalars['Boolean'];
  position: Scalars['Int'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type BrandConfigTrackingFonts = {
  __typename?: 'BrandConfigTrackingFonts';
  font: Scalars['String'];
  isTrackingRequired: Scalars['Boolean'];
  resource: Scalars['String'];
};

export type BulkOrderInquiryInput = {
  email: Scalars['String'];
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  firstName: Scalars['String'];
  itemsToPurchase: Scalars['String'];
  lastName: Scalars['String'];
  organizationType: Scalars['String'];
  organizationTypeOtherDescription?: InputMaybe<Scalars['String']>;
  quantityRange: Scalars['String'];
};

export type BundleComponent = {
  __typename?: 'BundleComponent';
  componentPriceItems?: Maybe<Array<Maybe<DynamicBundleItem>>>;
  imgUrl?: Maybe<Scalars['String']>;
  maxQty?: Maybe<Scalars['Int']>;
  minQty: Scalars['Int'];
  name: Scalars['String'];
  /** Deprecated: Use min_qty/max_qty instead */
  qtyType: Scalars['String'];
  /** Deprecated: Use min_qty/max_qty instead */
  requiredQty: Scalars['Int'];
  subscriptionOption?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type BundleComponentInput = {
  /** The ID of the bundle component (deprecated, use component_key) */
  componentId?: InputMaybe<Scalars['UUID4']>;
  /** The key of the bundle component */
  componentKey?: InputMaybe<Scalars['String']>;
  /** Items within this bundle component */
  items?: InputMaybe<Array<InputMaybe<BundleComponentItemInput>>>;
};

export type BundleComponentItemInput = {
  /** Analytics details for this bundle component item (map) */
  analyticsDetails?: InputMaybe<Scalars['Json']>;
  /** IDs of customizations already stored on the cart. Use instead of typed_customizations when the FE already has IDs from a previous call. Cannot be combined with typed_customizations. */
  customizationIds?: InputMaybe<Array<Scalars['UUID4']>>;
  /** DEPRECATED: Use typed_customizations instead. Customizations for this bundle component item (map) */
  customizations?: InputMaybe<Scalars['Json']>;
  /** The GTIN of the bundle component item */
  gtin: Scalars['String'];
  /** The quantity of this item in the bundle component */
  quantity: Scalars['Int'];
  /** Typed customizations for this bundle component item */
  typedCustomizations?: InputMaybe<Array<InputMaybe<CustomizationInput>>>;
};

export type BundleDataInput = {
  /** Bundle components for dynamic bundle variants */
  bundleComponents?: InputMaybe<Array<InputMaybe<BundleComponentInput>>>;
};

export type BundleItem = {
  __typename?: 'BundleItem';
  imgUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type BundleItemWithoutBundleData = {
  __typename?: 'BundleItemWithoutBundleData';
  cartItemId: Scalars['UUID4'];
};

export type BundleItemWithoutBundleValidationError = ValidationError & {
  __typename?: 'BundleItemWithoutBundleValidationError';
  details: Array<BundleItemWithoutBundleData>;
  reason: Scalars['String'];
};

/**
 * OBSOLETE — never returned. Bundles are now variants of type `bundle`; read bundle
 * membership from `variant_items`. This type is retained only so already-shipped clients
 * that select `... on BundleLineItem` keep validating, and will be deleted once that usage
 * drops to zero. Do not add new selections on it.
 */
export type BundleLineItem = {
  __typename?: 'BundleLineItem';
  /** components of the bundle other than the primary component */
  bundleComponents: Array<Maybe<BundleComponent>>;
  /** The id of the DynamicBundle */
  bundleId: Scalars['UUID4'];
  /** The cart reference of the DynamicBundle */
  cartBundleReference: Scalars['Int'];
  /** Will contain information of the discount for the DynamicBundle */
  discounts: Array<LineItemDiscount>;
  /** The DynamicBundle the items belong to */
  dynamicBundle: DynamicBundle;
  /** A list of items that are NOT associated with the primary component */
  dynamicBundleItems?: Maybe<Array<DynamicBundleItem>>;
  /** This is the image from the primary component */
  imgUrl?: Maybe<Scalars['String']>;
  /** aggregated gtin item notifications */
  itemNotifications: Array<Scalars['String']>;
  /** This will always the same as subtotal because DynamicBundles are quantity of 1 */
  perUnitPrice: Scalars['Int'];
  /** A list of items that are associated with the primary component */
  primaryBundleItems?: Maybe<Array<DynamicBundleItem>>;
  /** The primary component of the DynamicBundle */
  primaryComponent: BundleComponent;
  /** This is the quantity of all the items that are part of the DynamicBundle */
  quantity: Scalars['Int'];
  /** This is the cumulative strikethrough price of all the items in the DynamicBundle */
  strikethroughUnitPrice?: Maybe<Scalars['Int']>;
  /** This is the total of the items after the discount for the DynamicBundle is applied */
  subtotal: Scalars['Int'];
  /** The title of the primary component for the DynamicBundle */
  title: Scalars['String'];
};

export type BundleNotFoundValidationError = ValidationError & {
  __typename?: 'BundleNotFoundValidationError';
  bundleIds: Array<Scalars['String']>;
  reason: Scalars['String'];
};

export type BundleRequirementsNotSatisfiedValidationError = ValidationError & {
  __typename?: 'BundleRequirementsNotSatisfiedValidationError';
  bundleIds: Array<Scalars['String']>;
  reason: Scalars['String'];
};

export enum CampaignType {
  /** The discount is specific to a bundle */
  DynamicBundle = 'DYNAMIC_BUNDLE',
  /** The discount is specific to the campaign's targets */
  ItemSet = 'ITEM_SET',
  /** The discount is specific to a subscription */
  Subscription = 'SUBSCRIPTION',
  /** The discount is specific to an entire tenant */
  Tenant = 'TENANT',
  /** The discount is specific to a tier variant price */
  TierVariant = 'TIER_VARIANT'
}

export type CancelOrderInput = {
  /** Optional additional details about the cancellation. */
  statusReason?: InputMaybe<Scalars['String']>;
  /** The customer's reason for cancelling the order. */
  statusReasonValue: OrderCancellationReasonValue;
};

export type CancelScheduledOrderInput = {
  /** Optional free-text reason; required when status_reason_value is OTHER. */
  statusReason?: InputMaybe<Scalars['String']>;
  /** The reason code for cancellation. */
  statusReasonValue: ScheduledOrderStatusReasonValues;
};

export type CanceledOrder = {
  __typename?: 'CanceledOrder';
  cancellationReason?: Maybe<Scalars['String']>;
  customerPo?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  fulfillmentCount: Scalars['Int'];
  id: Scalars['UUID4'];
  isExternal: Scalars['Boolean'];
  isSubscription: Scalars['Boolean'];
  managedCustomerData?: Maybe<ManagedCustomerData>;
  placedBy?: Maybe<Scalars['String']>;
  requestedDeliveryDate?: Maybe<Scalars['Date']>;
  shippingAddress?: Maybe<ShippingAddress>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  total: Scalars['Int'];
  type: CanceledOrderType;
};

export type CanceledOrderPayload = {
  __typename?: 'CanceledOrderPayload';
  canceledOrders: Array<CanceledOrder>;
  pagination: PaginationData;
};

export enum CanceledOrderType {
  Scheduled = 'SCHEDULED',
  Submitted = 'SUBMITTED'
}

export type Capabilities = {
  __typename?: 'Capabilities';
  signUp: CapabilitiesSignUp;
  termsAndConditions?: Maybe<CapabilitiesTermsAndConditions>;
};

/**
 * The sign up capability informs consumers of the API if the Tenant
 * allows users to sign up via the Secure Portal.
 */
export type CapabilitiesSignUp = {
  __typename?: 'CapabilitiesSignUp';
  enabled: Scalars['Boolean'];
};

/** The capability to request accepting most recent version of T&C by user. */
export type CapabilitiesTermsAndConditions = {
  __typename?: 'CapabilitiesTermsAndConditions';
  lastVersionUpdatedAt?: Maybe<Scalars['DateTime']>;
};

/** A list of valid credit card types. */
export type CardType = {
  __typename?: 'CardType';
  brandImgUrl: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type Cart = {
  __typename?: 'Cart';
  appId: Scalars['UUID4'];
  /** All customizations stored on this cart. Use these to reference customization_ids when adding items. */
  customizations: Array<CustomizationOutput>;
  /**
   * OBSOLETE — always returns null. Bundles are now represented as variants of type
   * `bundle`. The underlying `carts.dynamic_bundles` field has been removed. Read bundle
   * membership from `variant_items` instead. This field will be deleted once usage drops
   * to zero.
   */
  dynamicBundles?: Maybe<Scalars['Json']>;
  /** Earliest selectable requested delivery date that qualifies as a scheduled order. Uses the managed customer's default address when present and is null when scheduled orders are unavailable. */
  earliestScheduledOrderDeliveryDate?: Maybe<Scalars['Date']>;
  id: Scalars['UUID4'];
  items?: Maybe<Array<Maybe<CartItemsAndBundleItems>>>;
  loyaltyData?: Maybe<LoyaltyData>;
  /** list of loyalty rewards the user has applied to their cart. Update via applyLoyaltyRewardToCart mutation. */
  loyaltyRewards?: Maybe<Array<Maybe<LoyaltyReward>>>;
  /** The managed customer associated with this cart */
  managedCustomer?: Maybe<ManagedCustomer>;
  orderMessages: Array<OrderMessage>;
  /** the calculated shipping (most tenants have a threshold after which shipping is free) */
  shipping: Scalars['Int'];
  /** SubTotal of the order calculated by adding all line item subtotals. */
  subtotal: Scalars['Int'];
  tenantId: Scalars['UUID4'];
  /** Total of the order calculated by adding all line item totals and shipping. This does NOT include tax calculations */
  total: Scalars['Int'];
  user?: Maybe<User>;
  validationErrors?: Maybe<Array<ValidationError>>;
  variantItems?: Maybe<Array<CartVariantItem>>;
};

/** This will contain CartItems */
export type CartItem = {
  __typename?: 'CartItem';
  analyticsDetails?: Maybe<Scalars['Json']>;
  customizations?: Maybe<Array<Customization>>;
  discounts: Array<LineItemDiscount>;
  /**
   * OBSOLETE — always returns null. Bundles are now represented as variants of type
   * `bundle`. The underlying `cart_items.dynamic_bundle` field has been removed. This
   * field will be deleted once usage drops to zero.
   */
  dynamicBundle?: Maybe<Scalars['Json']>;
  id: Scalars['UUID4'];
  item: Item;
  /** The discounted price of the item as an individual unit (rounded up, except for promo-code discounts, which are not adjusted). */
  perUnitPrice: Scalars['Int'];
  quantity: Scalars['Int'];
  /** The original price of the item as an individual unit (either the compare_at_price or or non-discounted price). */
  strikethroughUnitPrice?: Maybe<Scalars['Int']>;
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
  /** calculated by subtracting the discount_total from the items base_price * quantity (except for promo-code discounts, which are not included) */
  subtotal: Scalars['Int'];
};

export type CartItemsAndBundleItems = BundleLineItem | CartItem;

export type CartVariantItem = {
  __typename?: 'CartVariantItem';
  /** Analytics details for the variant - This is a map which applies to each quantity of the variant */
  analyticsDetails?: Maybe<Scalars['Json']>;
  /** IDs of the customizations applied to this variant. Pass these as customization_ids in a future addCartItemUniqueVariant call to skip re-uploading customization data. */
  customizationIds: Array<Scalars['UUID4']>;
  /** [DEPRECATED] Customizations for the variant as a raw JSON map. Will be removed after 2026-09-01. Use typed_customizations instead. */
  customizations?: Maybe<Scalars['Json']>;
  /** The discounts that will be applied to the Variant Item */
  discounts?: Maybe<Array<LineItemDiscount>>;
  /** The customer-facing title of the variant */
  displayTitle: Scalars['String'];
  gtin: Scalars['String'];
  id: Scalars['UUID4'];
  /** The image urls of the variant. The first item is the primary image. */
  imgUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The inventory quantity of the variant - This might be different from the variant's inventory_qty if the variant is a dynamic bundle */
  inventoryQty: Scalars['Int'];
  /** Whether the variant is out of stock - This might be different from the variant's inventory_qty if the variant is a dynamic bundle */
  isOutOfStock: Scalars['Boolean'];
  /** [DEPRECATED] Legacy customizations as a list of raw JSON maps, built from typed_customizations. List counterpart to the singular `customizations` field. Will be removed after 2026-06-01. */
  legacyCustomizations: Array<Scalars['Json']>;
  /** [DEPRECATED] Legacy typed customizations built from typed_customizations. Returns the first legacy customization record in the old union format. Will be removed after 2026-06-01. */
  legacyTypedCustomizations?: Maybe<Array<Customization>>;
  /** The discounted price of the item as an individual unit (rounded up, except for promo-code discounts, which are not adjusted). */
  perUnitPrice: Scalars['Int'];
  quantity: Scalars['Int'];
  /** How many more units of this variant can still be added across the cart before hitting the variant's maximum_purchase_quantity, accounting for quantity already committed to this variant on other cart lines. `null` when the variant has no maximum_purchase_quantity. This is independent of inventory_qty/is_out_of_stock, which reflect physical stock only - a line can be in stock but unable to accept more units under this limit, or vice versa. */
  remainingPurchaseQuantity?: Maybe<Scalars['Int']>;
  /** The original price of the item as an individual unit (either the compare_at_price or non-discounted price). */
  strikethroughUnitPrice?: Maybe<Scalars['Int']>;
  /** Sub-groups for the variant */
  subGroups?: Maybe<Array<Maybe<CartVariantItemSubGroup>>>;
  /** indicates FE must use 'Subscription' APIs */
  subscription: Scalars['Boolean'];
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
  /** Calculated by subtracting the discount_total from the items base_price * quantity (except for promo-code discounts, which are not included) */
  subtotal: Scalars['Int'];
  /** The title of the variant */
  title: Scalars['String'];
  /** [DEPRECATED] Typed customization for the variant. Same as customizations, but as a GQL type. Use typed_customizations (plural) instead. This field uses the old union-based system. Will be removed after 2026-06-01. */
  typedCustomization?: Maybe<Customization>;
  /**
   * Typed customizations for the variant.
   * Returns a list of customization_output objects.
   */
  typedCustomizations?: Maybe<Array<Maybe<CustomizationOutput>>>;
  /** indicates FE must use 'Unique' APIs */
  unique: Scalars['Boolean'];
  variant: Variant;
};

export type CartVariantItemSubGroup = {
  __typename?: 'CartVariantItemSubGroup';
  /** Whether any item in this component cannot cover the units this line requires. Resolved from live inventory as of this request. */
  hasInsufficientStock: Scalars['Boolean'];
  items?: Maybe<Array<Maybe<CartVariantItemSubGroupItem>>>;
  /** Identifies this component within the variant. Matches the corresponding `PriceVariantItemSubGroup.key`, so a caller rendering from `price` can line these up. */
  key?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CartVariantItemSubGroupItem = {
  __typename?: 'CartVariantItemSubGroupItem';
  analyticsDetails?: Maybe<Scalars['Json']>;
  /** IDs of the customizations applied to this sub-group item. */
  customizationIds: Array<Scalars['UUID4']>;
  /** [DEPRECATED] Customizations for this sub-group item as a raw JSON map. Will be removed after 2026-09-01. Use typed_customizations instead. */
  customizations?: Maybe<Scalars['Json']>;
  gtin: Scalars['String'];
  imgUrl?: Maybe<Scalars['String']>;
  /** [DEPRECATED] Legacy customizations as a list of raw JSON maps, built from typed_customizations. List counterpart to the singular `customizations` field. Will be removed after 2026-06-01. */
  legacyCustomizations: Array<Scalars['Json']>;
  /** [DEPRECATED] Legacy typed customizations built from typed_customizations. Returns the first legacy customization record in the old union format. Will be removed after 2026-06-01. */
  legacyTypedCustomizations?: Maybe<Array<Customization>>;
  quantity: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  typedCustomization?: Maybe<Customization>;
  /** List of typed customizations for this sub-group item */
  typedCustomizations?: Maybe<Array<Maybe<CustomizationOutput>>>;
};

export type ChangeUserPasswordInput = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
};

/** Retrieve Order Processing Status */
export type CheckOrderStatus = {
  __typename?: 'CheckOrderStatus';
  orderId?: Maybe<Scalars['UUID4']>;
  orderStatus: OrderProcessingStatus;
};

export type Checkout = {
  __typename?: 'Checkout';
  /** Indicates if multi-payment (split payment) is enabled for this tenant */
  allowMultiPayment?: Maybe<Scalars['Boolean']>;
  /**
   * configuration for determing if a user will always have to select
   *   the checkbox to accept terms and conditions
   */
  alwaysRequireTermsCheckboxes: Scalars['Boolean'];
  /**
   * configuration to determine if Stripe's Express Checkout component is
   *   enabled and should be loaded during checkout
   */
  expressCheckoutEnabled?: Maybe<Scalars['Boolean']>;
  paymentOptions?: Maybe<TenantPaymentOptions>;
  shippingOptions?: Maybe<TenantShippingOptions>;
  showCouponCodeCta?: Maybe<Scalars['Boolean']>;
  vatInclusivePricing?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['String']>;
};

export type CheckoutBreadcrumbsLocalization = {
  __typename?: 'CheckoutBreadcrumbsLocalization';
  address: Scalars['String'];
  payment: Scalars['String'];
  review: Scalars['String'];
  shipping: Scalars['String'];
};

export type CheckoutCouponCodeLocalizations = {
  __typename?: 'CheckoutCouponCodeLocalizations';
  addCouponButtonText: Scalars['String'];
  applyCouponButtonText: Scalars['String'];
  cancelCouponButtonText: Scalars['String'];
  couponCodeLabel: Scalars['String'];
  couponLabel: Scalars['String'];
  couponPlaceholderText: Scalars['String'];
  editCouponButtonText: Scalars['String'];
  removeCouponButtonText: Scalars['String'];
};

export type CheckoutErrorsLocalizations = {
  __typename?: 'CheckoutErrorsLocalizations';
  discount?: Maybe<DiscountLocalizations>;
  genericErrorMsg: Scalars['String'];
  guestCartContainsSubscription?: Maybe<GuestCartContainsSubscriptionLocalizations>;
  insufficientLoyaltyBalance?: Maybe<InsufficientLoyaltyBalanceLocalizations>;
  invalidBillingAddressText: Scalars['String'];
  invalidGiftCard?: Maybe<InvalidGiftCardLocalizations>;
  invalidLoyaltyReward?: Maybe<InvalidLoyaltyRewardLocalizations>;
  itemUnavailable?: Maybe<ItemUnavailableLocalizations>;
  lowStock?: Maybe<LowStockLocalizations>;
  minimumPurchaseAmount: Scalars['String'];
  minimumPurchaseQuantity: Scalars['String'];
  outOfStock?: Maybe<OutOfStockLocalizations>;
  paymentFailureErrorText: Scalars['String'];
  paymentNotAccepted: Scalars['String'];
  purchaseQtyLimit?: Maybe<PurchaseQtyLimitLocalizations>;
  scheduledOrderOutOfStock?: Maybe<ScheduledOrderOutOfStockLocalizations>;
  subscriptionsNotAllowed?: Maybe<SubscriptionsNotAllowedLocalizations>;
  unableToUsePoBox: Scalars['String'];
  unverifiedEmail: Scalars['String'];
  variantSubscriptionsNotAllowed?: Maybe<SubscriptionsNotAllowedLocalizations>;
  zipCodeRestriction?: Maybe<ZipCodeRestrictionLocalizations>;
};

export type CheckoutGiftCardLocalizations = {
  __typename?: 'CheckoutGiftCardLocalizations';
  addCouponGiftButtonText: Scalars['String'];
  addGiftButtonText: Scalars['String'];
  giftCardEndingIn: Scalars['String'];
  giftNumberLabel: Scalars['String'];
  giftNumberPlaceholderText: Scalars['String'];
  giftPinLabel: Scalars['String'];
  giftPinPlaceholderText: Scalars['String'];
};

export type CheckoutGiftFormLocalizations = {
  __typename?: 'CheckoutGiftFormLocalizations';
  emailFieldLabel: Scalars['String'];
  gifteeFieldLabel: Scalars['String'];
  infoText: Scalars['String'];
  messageFieldLabel: Scalars['String'];
  sendAsGiftText: Scalars['String'];
  shippingAddressHeadingText: Scalars['String'];
};

/**
 * Returns a map of all checkout elements and their translations.
 *
 * Example:
 *     ```
 *     query {
 *       localization {
 *         checkout {
 *           breadcrumbs {
 *             shipping
 *           }
 *         }
 *       }
 *     }
 *     ```
 */
export type CheckoutLocalization = {
  __typename?: 'CheckoutLocalization';
  breadcrumbs?: Maybe<CheckoutBreadcrumbsLocalization>;
  couponCode?: Maybe<CheckoutCouponCodeLocalizations>;
  errors?: Maybe<CheckoutErrorsLocalizations>;
  giftCard?: Maybe<CheckoutGiftCardLocalizations>;
  giftForm?: Maybe<CheckoutGiftFormLocalizations>;
  orderDetails?: Maybe<CheckoutOrderDetailsLocalizations>;
  orderStatusPage?: Maybe<CheckoutOrderStatusPageLocalizations>;
  orderSummary?: Maybe<CheckoutOrderSummaryLocalizations>;
  pageTitlesInHead?: Maybe<CheckoutPageTitlesLocalization>;
  paymentStep?: Maybe<CheckoutPaymentStepLocalizations>;
  rdd?: Maybe<CheckoutRddLocalizations>;
  reviewStep?: Maybe<CheckoutReviewStepLocalizations>;
  shippingMethodStep?: Maybe<CheckoutShippingMethodStepLocalizations>;
  shippingStep?: Maybe<CheckoutShippingStepLocalizations>;
};

export type CheckoutOrderDetailsLocalizations = {
  __typename?: 'CheckoutOrderDetailsLocalizations';
  billingSameAsShippingText: Scalars['String'];
  cardholderNameText: Scalars['String'];
  expiresText: Scalars['String'];
  invoiceTermsText: Scalars['String'];
  invoiceText: Scalars['String'];
  poNumberText: Scalars['String'];
  shippingMethodText: Scalars['String'];
};

export type CheckoutOrderStatusPageLocalizations = {
  __typename?: 'CheckoutOrderStatusPageLocalizations';
  continueShoppingButtonText: Scalars['String'];
  headingText: Scalars['String'];
  notFoundMsg: Scalars['String'];
  orderConfirmationShipmentText: Scalars['String'];
  orderDateText: Scalars['String'];
  orderDetailsHeadingText: Scalars['String'];
  orderDetailsNote: Scalars['String'];
  orderDetailsText: Scalars['String'];
  paymentHeadingText: Scalars['String'];
  printButtonText: Scalars['String'];
  shippingHeadingText: Scalars['String'];
};

export type CheckoutOrderSummaryLocalizations = {
  __typename?: 'CheckoutOrderSummaryLocalizations';
  bulkDiscountText: Scalars['String'];
  bundleDiscountText: Scalars['String'];
  bundleItemDefaultText: Scalars['String'];
  cartHeadingText: Scalars['String'];
  freeShipLabel: Scalars['String'];
  itemPlural: Scalars['String'];
  itemSingular: Scalars['String'];
  regulatoryTaxLabel: Scalars['String'];
  salesTaxLabel: Scalars['String'];
  shippingLabel: Scalars['String'];
  subtotalLabel: Scalars['String'];
  totalLabel: Scalars['String'];
  whatsIncludedText: Scalars['String'];
  yourOrderText: Scalars['String'];
};

export type CheckoutPageTitlesLocalization = {
  __typename?: 'CheckoutPageTitlesLocalization';
  checkout: Scalars['String'];
  status: Scalars['String'];
};

export type CheckoutPaymentStepLocalizations = {
  __typename?: 'CheckoutPaymentStepLocalizations';
  addCardHeadingText: Scalars['String'];
  addPaymentButtonText: Scalars['String'];
  addPaymentHeadingText: Scalars['String'];
  billingAddressHeadingText: Scalars['String'];
  billingSameAsShippingText: Scalars['String'];
  continueToReviewButtonText: Scalars['String'];
  giftCardCoversFullAmountDescription: Scalars['String'];
  giftCardCoversFullAmountTitle: Scalars['String'];
  headingText: Scalars['String'];
  sectionHeadingText: Scalars['String'];
  shippingAddressHeadingText: Scalars['String'];
};

export type CheckoutRddLocalizations = {
  __typename?: 'CheckoutRddLocalizations';
  changeDateText: Scalars['String'];
  customizationWarningText: Scalars['String'];
  headingText: Scalars['String'];
  needOrderSoonerText: Scalars['String'];
  noteText: Scalars['String'];
  selectDateText: Scalars['String'];
  yourRequestedDateText: Scalars['String'];
};

export type CheckoutReviewStepLocalizations = {
  __typename?: 'CheckoutReviewStepLocalizations';
  agreeToTermsText: Scalars['String'];
  editButtonText: Scalars['String'];
  emailNote: Scalars['String'];
  giftEmailNote: Scalars['String'];
  giftMessageNote: Scalars['String'];
  giftShippingHeadingText: Scalars['String'];
  headingText: Scalars['String'];
  paymentHeadingText: Scalars['String'];
  shippingHeadingText: Scalars['String'];
  submitOrderButtonText: Scalars['String'];
};

export type CheckoutSession = {
  __typename?: 'CheckoutSession';
  activeAccount?: Maybe<ActiveAccount>;
  allowSubscriptions: Scalars['Boolean'];
  /** temporary field while we transition to stripe for all payments except paypal */
  allowedPaymentProcessors?: Maybe<Array<Maybe<PaymentProcessor>>>;
  appId: Scalars['UUID4'];
  availablePaymentMethods: AvailablePaymentMethods;
  availableShippingMethods?: Maybe<Array<ShippingMethod>>;
  cart: Cart;
  /** This field indicates if checkout should collect a requested delivery date for the order. */
  collectRequestedDeliveryDate: Scalars['Boolean'];
  contactInfo?: Maybe<ContactInfo>;
  customerPo?: Maybe<Scalars['String']>;
  /** Maximum delivery offset in business days. Computed based on tenant configuration for managed customers in AK/HI, tenant max otherwise. */
  deliveryMaxOffsetInDays: Scalars['Int'];
  /** Minimum delivery offset in business days. Computed based on tenant configuration for managed customers in AK/HI, tenant min otherwise. */
  deliveryMinOffsetInDays: Scalars['Int'];
  /** Earliest selectable requested delivery date that qualifies as a scheduled order. Uses the checkout shipping destination and is null when scheduled orders are unavailable. */
  earliestScheduledOrderDeliveryDate?: Maybe<Scalars['Date']>;
  expressCheckoutEnabled?: Maybe<Scalars['Boolean']>;
  formConfig: CheckoutSessionFormConfig;
  giftCards?: Maybe<Array<Maybe<EmbeddedGiftCard>>>;
  giftInfo?: Maybe<GiftInfo>;
  hasGasExchangeItems: Scalars['Boolean'];
  hasIneligibleAllocationVariants?: Maybe<Scalars['Boolean']>;
  hasSubscriptionItems: Scalars['Boolean'];
  id: Scalars['UUID4'];
  /** Whether checkout should submit via scheduleOrder instead of submitOrder. */
  isScheduledOrder: Scalars['Boolean'];
  /** Indicates the customization status of items in the cart: no customizations, some customizations, or all customizations. */
  itemCustomizationsStatus: ItemCustomizationsStatus;
  managedCustomer?: Maybe<ManagedCustomer>;
  managedCustomerData?: Maybe<ManagedCustomerData>;
  /** Maximum allowed requested delivery date for a scheduled order. Dec 31 of the current year for a high school managed customer with an HSPP kit; approximately one year out otherwise; null when scheduled orders are not allowed. */
  maxRequestedDeliveryDate?: Maybe<Scalars['Date']>;
  orderId?: Maybe<Scalars['String']>;
  orderMessages: Array<OrderMessage>;
  orderTerms: Array<OrderTerm>;
  payment?: Maybe<Payment>;
  price: Price;
  requestedDeliveryDate?: Maybe<Scalars['String']>;
  salesRepInfo?: Maybe<SalesRepInfo>;
  shippingAddresses: Array<SavedShippingAddress>;
  shippingMethodCode?: Maybe<Scalars['String']>;
  shippingMethodConfig?: Maybe<ShippingMethodConfig>;
  shippingMethodTitle?: Maybe<Scalars['String']>;
  /** Whether checkout should display the NFL data-sharing consent checkboxes. */
  showNflConsent: Scalars['Boolean'];
  stage: SessionStage;
  submissionUid: Scalars['UUID4'];
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['UUID4'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID4']>;
  validationErrors?: Maybe<Array<ValidationError>>;
};

export type CheckoutSessionFormConfig = {
  __typename?: 'CheckoutSessionFormConfig';
  /** Whether coupon codes are allowed for this account type */
  allowCouponCodes: Scalars['Boolean'];
  /** Whether gift cards are allowed for this account type */
  allowGiftCards: Scalars['Boolean'];
  /** Whether gifting is allowed (false if the user has any primary account) */
  allowGifting: Scalars['Boolean'];
  /** Whether a PO number input should be shown at checkout for the active account */
  allowPoNumber: Scalars['Boolean'];
};

export type CheckoutShippingMethodStepLocalizations = {
  __typename?: 'CheckoutShippingMethodStepLocalizations';
  freeText: Scalars['String'];
  headingText: Scalars['String'];
  selectShippingMethodText: Scalars['String'];
};

export type CheckoutShippingStepLocalizations = {
  __typename?: 'CheckoutShippingStepLocalizations';
  addAddressButtonText: Scalars['String'];
  addAddressHeadingText: Scalars['String'];
  additionalPhoneNumberLabel: Scalars['String'];
  addressHeadingText: Scalars['String'];
  contactNoteText: Scalars['String'];
  continueToPaymentButtonText: Scalars['String'];
  continueToShippingMethodButtonText: Scalars['String'];
  haveAnAccountLinkText: Scalars['String'];
  haveAnAccountText: Scalars['String'];
  savedAddressHeadingText: Scalars['String'];
  shipAlertText: Scalars['String'];
  shippingHeadingText: Scalars['String'];
};

export type CollectionSummary = {
  __typename?: 'CollectionSummary';
  name: Scalars['String'];
};

export type Component = {
  __typename?: 'Component';
  /** @deprecated Use promoCode instead */
  discount?: Maybe<Discount>;
  id: Scalars['UUID4'];
  items?: Maybe<Array<Item>>;
  maxQty?: Maybe<Scalars['Int']>;
  minQty: Scalars['Int'];
  name: Scalars['String'];
  promoCode?: Maybe<Discount>;
  /** Deprecated: Use min_qty/max_qty instead */
  qtyType: Scalars['String'];
  /** Deprecated: Use min_qty/max_qty instead */
  requiredQty: Scalars['Int'];
  subscriptionOption: SubscriptionOption;
  subscriptionPromoCode?: Maybe<Discount>;
};

export type ComponentsLocalization = {
  __typename?: 'ComponentsLocalization';
  addressVerification?: Maybe<AddressVerificationLocalization>;
  customNotFound?: Maybe<CustomNotFoundLocalization>;
  errorModal?: Maybe<ErrorModalLocalization>;
  exchangeReturnByDate?: Maybe<ExchangeReturnByDateLocalization>;
  footer?: Maybe<FooterLocalization>;
  nextError?: Maybe<NextErrorLocalization>;
  orderProcessing?: Maybe<OrderProcessing>;
  price?: Maybe<PriceLocalization>;
};

export type ContactConfig = {
  __typename?: 'ContactConfig';
  shippingAddressConfig: AddressConfig;
};

/** User's contact info needed during checkout. */
export type ContactInfo = {
  __typename?: 'ContactInfo';
  bazaarvoice?: Maybe<Bazaarvoice>;
  email?: Maybe<Scalars['String']>;
  emailOptIn?: Maybe<Scalars['Boolean']>;
  managedCustomerContactInfo?: Maybe<ManagedCustomerContactInfo>;
  nflDataSharingConsent?: Maybe<Scalars['Boolean']>;
  nflMarketingConsent?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  phoneExtension?: Maybe<Scalars['String']>;
  shippingAddress?: Maybe<ShippingAddress>;
  shippingMethod?: Maybe<ShippingMethod>;
  specialInstructions?: Maybe<Scalars['String']>;
};

export type CountriesAllowed = {
  __typename?: 'CountriesAllowed';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CreateManagedCustomerCartInput = {
  managedCustomerId: Scalars['UUID4'];
};

export type CreatePaymentMethodInput = {
  default?: InputMaybe<Scalars['Boolean']>;
  nonce: Scalars['String'];
};

export type CreateRegistrationRecordInput = {
  customData?: InputMaybe<Scalars['Json']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  gtin: Scalars['String'];
  purchaseDate: Scalars['Date'];
  purchaseLocation?: InputMaybe<Scalars['String']>;
  utmData?: InputMaybe<UtmDataInput>;
};

/** Input for creating a tax exemption */
export type CreateTaxExemptionInput = {
  company: Scalars['String'];
  /** List of document urls that were alreaedy uploaded to s3 - will make non_null once it is implemented */
  document?: InputMaybe<DocumentInfoInput>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  specialConsiderations?: InputMaybe<Scalars['String']>;
  taxExemptExpirationDate?: InputMaybe<Scalars['String']>;
  taxExemptionRequestAddress: TaxExemptionRequestAddressInput;
};

/**
 * The `Credit` object is used to represent a credit line on an account.
 *
 * This could apply to an Allocation or Invoice credit line depending on the
 * credit type.
 */
export type Credit = {
  __typename?: 'Credit';
  activeFrom: Scalars['Date'];
  activeUntil?: Maybe<Scalars['Date']>;
  availableAmount: Scalars['Int'];
  id: Scalars['UUID4'];
  spentAmount: Scalars['Int'];
  status: Scalars['String'];
  type: Scalars['String'];
};

/** Credit card saved by the user. */
export type CreditCard = {
  __typename?: 'CreditCard';
  billingAddress: CreditCardBillingAddress;
  cardType: CreditCardType;
  cardholderName: Scalars['String'];
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  isRemovable?: Maybe<Scalars['Boolean']>;
  lastFour: Scalars['String'];
  /** Token representing payment method. */
  token: Scalars['String'];
};

/** Billing address associated with a Credit Card. */
export type CreditCardBillingAddress = {
  __typename?: 'CreditCardBillingAddress';
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

/** Input for mutation to save credit card payment information */
export type CreditCardInput = {
  billingAddress?: InputMaybe<BillingAddressInput>;
  isBillingEqualShipping: Scalars['Boolean'];
  saveCardForLater: Scalars['Boolean'];
};

export type CreditCardTooltipLocalization = {
  __typename?: 'CreditCardTooltipLocalization';
  cardsWith3DigitsNote: Scalars['String'];
  cardsWith3DigitsText: Scalars['String'];
  cardsWith4DigitsNote: Scalars['String'];
  cardsWith4DigitsText: Scalars['String'];
  cvv3DigitAlt: Scalars['String'];
  cvv4DigitAlt: Scalars['String'];
  headingText: Scalars['String'];
};

/** Enum for the different types of payment methods. */
export enum CreditCardType {
  AmericanExpress = 'AMERICAN_EXPRESS',
  Amex = 'AMEX',
  Discover = 'DISCOVER',
  Jcb = 'JCB',
  Mastercard = 'MASTERCARD',
  Unionpay = 'UNIONPAY',
  Visa = 'VISA'
}

export type CustomNotFoundLocalization = {
  __typename?: 'CustomNotFoundLocalization';
  cartButtonText: Scalars['String'];
  featuredProductsText: Scalars['String'];
  headingText: Scalars['String'];
  homeButtonText: Scalars['String'];
  subHeadingShopText: Scalars['String'];
  subHeadingText: Scalars['String'];
};

export type CustomText = {
  __typename?: 'CustomText';
  body: Array<Scalars['String']>;
  links: Array<CustomTextLink>;
  location: Scalars['String'];
  position?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
};

export type CustomTextLink = {
  __typename?: 'CustomTextLink';
  displayValue: Scalars['String'];
  key: Scalars['String'];
  linkValue: Scalars['String'];
  type: Scalars['String'];
};

export type CustomerInfo = {
  __typename?: 'CustomerInfo';
  returningCustomer?: Maybe<Scalars['Boolean']>;
};

/**
 * Used for item customizations maps.
 *
 * DEPRECATED: This union-based approach is being replaced with a cleaner object-based system.
 * Use the typed_customizations field on cart_variant_item instead, which returns customization_output objects.
 * This union and the fields that use it (typed_customization, all_typed_customizations) will be removed after 2026-06-01.
 */
export type Customization = GatoradeIdBottle | GatoradeTowel | LegacyCustomization;

export type CustomizationEntryError = {
  __typename?: 'CustomizationEntryError';
  /** The field that failed validation, or "base" for structural errors */
  field?: Maybe<Scalars['String']>;
  /** Zero-based position of the failed entry in the input list */
  index: Scalars['Int'];
  /** Human-readable error reason */
  message: Scalars['String'];
};

/**
 * Typed customization input for cart items.
 * Exactly one customization type field should be populated.
 */
export type CustomizationInput = {
  /** Gatorade Bottle customization */
  gatoradeBottle?: InputMaybe<GatoradeBottleCustomizationInput>;
  /** Gatorade Squeeze bottle customization */
  gatoradeSqueezeBottle?: InputMaybe<GatoradeSqueezeBottleCustomizationInput>;
  /** Gatorade Stainless Steel bottle customization */
  gatoradeStainlessSteel?: InputMaybe<GatoradeStainlessSteelCustomizationInput>;
  /** Gatorade towel customization */
  gatoradeTowel?: InputMaybe<GatoradeTowelCustomizationInput>;
  /** Legacy customization - arbitrary key-value pairs for maximum flexibility (e.g., {"color": "red", "bottle_code": "123", "gaVariant": "ABC"}) */
  legacy?: InputMaybe<Scalars['Json']>;
};

/**
 * Used for item customizations.
 * Returns typed customization data based on the customization type.
 */
export type CustomizationOutput = GatoradeBottleCustomizationOutput | GatoradeIdBottleCustomizationOutput | GatoradeSqueezeBottleCustomizationOutput | GatoradeStainlessSteelCustomizationOutput | GatoradeTowelCustomizationOutput | LegacyCustomizationOutput;

export type DeleteCreditCardInput = {
  token: Scalars['String'];
};

export type Discount = {
  __typename?: 'Discount';
  activeFrom: Scalars['DateTime'];
  activeUntil?: Maybe<Scalars['DateTime']>;
  amount?: Maybe<Scalars['Int']>;
  appId?: Maybe<Scalars['UUID4']>;
  behaviour: Behaviour;
  campaignId?: Maybe<Scalars['UUID4']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID4'];
  isPercent?: Maybe<Scalars['Boolean']>;
  isPromoCodeRequired?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  promoCode?: Maybe<Scalars['String']>;
  type?: Maybe<CampaignType>;
  typeDependentValue?: Maybe<Scalars['String']>;
  usage?: Maybe<Scalars['Int']>;
  variants?: Maybe<Array<Maybe<Variant>>>;
};

export enum DiscountCategory {
  Basic = 'BASIC',
  BasicPromoCode = 'BASIC_PROMO_CODE',
  DynamicBundle = 'DYNAMIC_BUNDLE',
  FreeOfCharge = 'FREE_OF_CHARGE',
  HiddenPromoItem = 'HIDDEN_PROMO_ITEM',
  Subscription = 'SUBSCRIPTION',
  Tiered = 'TIERED',
  TieredPromoCode = 'TIERED_PROMO_CODE'
}

export type DiscountInput = {
  promoCode?: InputMaybe<Scalars['String']>;
};

export type DiscountLocalizations = {
  __typename?: 'DiscountLocalizations';
  discountCannotApplyToSubscription: Scalars['String'];
  discountExceedsSubtotal: Scalars['String'];
  discountHeadingText: Scalars['String'];
  discountNotFound: Scalars['String'];
  discountNoteText: Scalars['String'];
  discountPromoCodeRequiresEmail: Scalars['String'];
  discountPromoCodeRequiresEmailOrLogin: Scalars['String'];
  discountTooLarge: Scalars['String'];
};

export enum DiscountType {
  Flat = 'FLAT',
  Percent = 'PERCENT'
}

export enum DisplayType {
  Dropdown = 'DROPDOWN',
  Hidden = 'HIDDEN',
  Radio = 'RADIO'
}

/** Document information for tax exemption requests */
export type DocumentInfoInput = {
  documentUrl: Scalars['String'];
  fileName: Scalars['String'];
};

/** presigned url content-type */
export enum DocumentType {
  Doc = 'DOC',
  Docx = 'DOCX',
  Pdf = 'PDF'
}

export type DocumentUploadUrls = {
  __typename?: 'DocumentUploadUrls';
  signedUrls?: Maybe<Array<Maybe<SignedUrl>>>;
};

export type DynamicBundle = {
  __typename?: 'DynamicBundle';
  appId: Scalars['UUID4'];
  components?: Maybe<Array<Component>>;
  /** @deprecated Use promoCode instead */
  discount?: Maybe<Discount>;
  discountPrice: Scalars['Int'];
  id: Scalars['UUID4'];
  inventoryQty?: Maybe<Scalars['Int']>;
  isOutOfStock?: Maybe<Scalars['Boolean']>;
  minRetailPrice: Scalars['Int'];
  name: Scalars['String'];
  primaryComponent: Component;
  promoCode?: Maybe<Discount>;
  tag: Scalars['String'];
};

export type DynamicBundleItem = {
  __typename?: 'DynamicBundleItem';
  analyticsDetails?: Maybe<Scalars['Json']>;
  /** A list of customizations the item associated contains */
  customizations?: Maybe<Array<Customization>>;
  discounts?: Maybe<Array<LineItemDiscount>>;
  item: Item;
  itemId: Scalars['UUID4'];
  quantity: Scalars['Int'];
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
};

export type DynamicBundlesBehaviour = {
  __typename?: 'DynamicBundlesBehaviour';
  name: BehaviourEnum;
};

export type EmailOptInLocalization = {
  __typename?: 'EmailOptInLocalization';
  body: Scalars['String'];
  defaultLabelText: Scalars['String'];
  privacyPolicyLinkText: Scalars['String'];
  termsOfUseLinkText: Scalars['String'];
};

export type EmbeddedCategory = {
  __typename?: 'EmbeddedCategory';
  level1?: Maybe<Scalars['String']>;
  level2?: Maybe<Scalars['String']>;
  level3?: Maybe<Scalars['String']>;
};

export type EmbeddedDiscount = {
  __typename?: 'EmbeddedDiscount';
  amount?: Maybe<Scalars['Int']>;
  isPercent?: Maybe<Scalars['Boolean']>;
};

export type EmbeddedGiftCard = {
  __typename?: 'EmbeddedGiftCard';
  amount: Scalars['Int'];
  appliedAmount: Scalars['Int'];
  giftCardId: Scalars['String'];
  last4: Scalars['String'];
  requestReference: Scalars['String'];
  transactionId: Scalars['String'];
  type: Scalars['String'];
};

export type EmbeddedItem = {
  __typename?: 'EmbeddedItem';
  awaitingImportCorrection?: Maybe<Scalars['Boolean']>;
  /** @deprecated Unsupported */
  brandName?: Maybe<Scalars['String']>;
  /** @deprecated Unsupported */
  categories?: Maybe<EmbeddedCategory>;
  /** @deprecated Unsupported */
  color?: Maybe<Scalars['String']>;
  compareAtPrice?: Maybe<Scalars['Int']>;
  /** @deprecated replaced with item_tax_info.container_type */
  containerType?: Maybe<Scalars['String']>;
  countryCity?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** @deprecated Unsupported */
  designerBio?: Maybe<Scalars['String']>;
  dimensionUnits?: Maybe<Scalars['String']>;
  /** @deprecated Unsupported */
  dimensions?: Maybe<Scalars['String']>;
  /** @deprecated replaced with item_tax_info.volume_per_ea_fl_oz */
  fluidOzPerPack?: Maybe<Scalars['Decimal']>;
  gasExchangeInfo?: Maybe<EmbeddedItemGasExchangeInfo>;
  height?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID4']>;
  imgUrl?: Maybe<Scalars['String']>;
  importId?: Maybe<Scalars['UUID4']>;
  inventoryQty?: Maybe<Scalars['Int']>;
  /** @deprecated Unsupported */
  isApproved?: Maybe<Scalars['Boolean']>;
  isDairyFree?: Maybe<Scalars['Boolean']>;
  isFairTrade?: Maybe<Scalars['Boolean']>;
  isGlutenFree?: Maybe<Scalars['Boolean']>;
  isGmoFree?: Maybe<Scalars['Boolean']>;
  isKosher?: Maybe<Scalars['Boolean']>;
  isOrganic?: Maybe<Scalars['String']>;
  isOutOfStock?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  isVegan?: Maybe<Scalars['Boolean']>;
  isWheatFree?: Maybe<Scalars['Boolean']>;
  isYeastFree?: Maybe<Scalars['Boolean']>;
  isbn?: Maybe<Scalars['String']>;
  itemTaxInfo?: Maybe<ItemTaxInfo>;
  length?: Maybe<Scalars['String']>;
  /** @deprecated Unsupported */
  material?: Maybe<Scalars['String']>;
  meltRisk?: Maybe<Scalars['Boolean']>;
  minOrderQty?: Maybe<Scalars['Int']>;
  onMarketplace?: Maybe<Scalars['Boolean']>;
  pointsPrice?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  /** @deprecated Unsupported */
  primaryCategoryPriority?: Maybe<Scalars['Int']>;
  productPacks?: Maybe<Scalars['Int']>;
  /** @deprecated replaced with item_tax_info.quantity_of_ea_per_pak */
  productsPerPack?: Maybe<Scalars['Int']>;
  /** @deprecated Unsupported */
  returnsPolicy?: Maybe<Scalars['String']>;
  /** @deprecated Unsupported */
  secondaryCategoryPriority?: Maybe<Scalars['Int']>;
  /** @deprecated Unsupported */
  shippingInfo?: Maybe<Scalars['String']>;
  /** @deprecated Unsupported */
  slug?: Maybe<Scalars['String']>;
  /** @deprecated Unsupported */
  slugHash?: Maybe<Scalars['String']>;
  /** OBSOLETE — always returns null. subscription_metadata is no longer supported */
  subscriptionMetadata?: Maybe<EmbeddedItemSubscriptionMetadata>;
  tags?: Maybe<Scalars['String']>;
  /** @deprecated replaced with item_tax_info.tax_code_id */
  taxCodeId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  upc?: Maybe<Scalars['String']>;
  /** @deprecated Unsupported */
  vendorId?: Maybe<Scalars['UUID4']>;
  virtual?: Maybe<Scalars['Boolean']>;
  weightOz?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
};

export type EmbeddedItemGasExchangeInfo = {
  __typename?: 'EmbeddedItemGasExchangeInfo';
  enabled: Scalars['Boolean'];
  missingCylinder?: Maybe<Item>;
  missingCylinderId?: Maybe<Scalars['UUID4']>;
};

export type EmbeddedItemSubscriptionMetadata = {
  __typename?: 'EmbeddedItemSubscriptionMetadata';
  /** OBSOLETE — always returns null. subscription_metadata is no longer supported */
  discount?: Maybe<EmbeddedDiscount>;
  /** OBSOLETE — always returns null. subscription_metadata is no longer supported */
  isSubscribable: Scalars['Boolean'];
  /** OBSOLETE — always returns null. subscription_metadata is no longer supported */
  promoCode?: Maybe<EmbeddedDiscount>;
  /** OBSOLETE — always returns null. subscription_metadata is no longer supported */
  subscriptionPrice?: Maybe<Scalars['Int']>;
};

export type ErrorModalLocalization = {
  __typename?: 'ErrorModalLocalization';
  errorHeadingText: Scalars['String'];
  okText: Scalars['String'];
  visitOurLinkForAssistanceText: Scalars['String'];
};

export type ExchangeReturnByDateLocalization = {
  __typename?: 'ExchangeReturnByDateLocalization';
  exchangeText: Scalars['String'];
  returnByText: Scalars['String'];
};

/** Input for mutation to calculate the draft price during express checkout (partially filled address). */
export type ExpressCheckoutAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type ExtendDueDateInput = {
  id: Scalars['UUID4'];
};

export type FacetPayload = {
  __typename?: 'FacetPayload';
  name: Scalars['String'];
  values: Array<FacetPayloadValue>;
};

export type FacetPayloadValue = {
  __typename?: 'FacetPayloadValue';
  count: Scalars['Int'];
  value: Scalars['String'];
};

export type FindAddressInput = {
  container?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};

export type FocBehaviour = {
  __typename?: 'FocBehaviour';
  name: BehaviourEnum;
};

export type FooterLocalization = {
  __typename?: 'FooterLocalization';
  allRightsReserved: Scalars['String'];
};

export type FormsAccountLocalization = {
  __typename?: 'FormsAccountLocalization';
  firstNameLabel: Scalars['String'];
  lastNameLabel: Scalars['String'];
};

export type FormsAddressLocalization = {
  __typename?: 'FormsAddressLocalization';
  autocompletePlaceholderText: Scalars['String'];
  cardholderNameLabel: Scalars['String'];
  cityLabel: Scalars['String'];
  companyLabel: Scalars['String'];
  countryLabel: Scalars['String'];
  emailLabel: Scalars['String'];
  firstNameLabel: Scalars['String'];
  isDefaultLabel: Scalars['String'];
  lastNameLabel: Scalars['String'];
  line1Label: Scalars['String'];
  line2Label: Scalars['String'];
  loadingDockLabel: Scalars['String'];
  manuallyEnterAddressText: Scalars['String'];
  nicknameLabel: Scalars['String'];
  phoneLabel: Scalars['String'];
  phoneNumberLabel: Scalars['String'];
  regionText: Scalars['String'];
  requiredFieldsText: Scalars['String'];
  requiredText: Scalars['String'];
  saveForUserAccountLabel: Scalars['String'];
  specialInstructionsHelperText: Scalars['String'];
  specialInstructionsLabel: Scalars['String'];
  stateLabel: Scalars['String'];
  taxIdLabel: Scalars['String'];
  zipLabel: Scalars['String'];
};

export type FormsCreditCardLocalization = {
  __typename?: 'FormsCreditCardLocalization';
  cardNumberLabel: Scalars['String'];
  cardSavedForGasExchangeNote: Scalars['String'];
  cardSavedForSubsNote: Scalars['String'];
  cardholderNameLabel: Scalars['String'];
  cvvLabel: Scalars['String'];
  cvvTooltip?: Maybe<CreditCardTooltipLocalization>;
  expirationDateLabel: Scalars['String'];
  saveCardForLaterText: Scalars['String'];
  securityNote: Scalars['String'];
};

export type FormsForgotPasswordLocalization = {
  __typename?: 'FormsForgotPasswordLocalization';
  backToLoginText: Scalars['String'];
  contactLinkContentText: Scalars['String'];
  contactLinkText: Scalars['String'];
  emailLabelText: Scalars['String'];
  formDescriptionText: Scalars['String'];
  headingText: Scalars['String'];
  submitButtonText: Scalars['String'];
  submittedText: Scalars['String'];
};

export type FormsLocalization = {
  __typename?: 'FormsLocalization';
  account?: Maybe<FormsAccountLocalization>;
  address?: Maybe<FormsAddressLocalization>;
  creditCard?: Maybe<FormsCreditCardLocalization>;
  forgotPassword?: Maybe<FormsForgotPasswordLocalization>;
  requestNewLink?: Maybe<FormsRequestNewLinkLocalization>;
  resetPassword?: Maybe<FormsResetPasswordLocalization>;
  signIn?: Maybe<FormsSignInLocalization>;
  signup?: Maybe<FormsSignupLocalization>;
  tos?: Maybe<FormsTosLocalization>;
  validation?: Maybe<FormsValidationLocalization>;
};

export type FormsRequestNewLinkLocalization = {
  __typename?: 'FormsRequestNewLinkLocalization';
  buttonText: Scalars['String'];
  emailLabelText: Scalars['String'];
  emailResentBodyText: Scalars['String'];
  emailResentDidntReceiveText: Scalars['String'];
  emailResentHeadingText: Scalars['String'];
  expiredBodyText: Scalars['String'];
  expiredHeadingText: Scalars['String'];
  invalidBodyText: Scalars['String'];
  invalidHeadingText: Scalars['String'];
  submittedText: Scalars['String'];
  tokenExpiredBodyText: Scalars['String'];
  tokenExpiredButtonText: Scalars['String'];
  tokenExpiredHeadingText: Scalars['String'];
};

export type FormsResetPasswordLocalization = {
  __typename?: 'FormsResetPasswordLocalization';
  headingText: Scalars['String'];
  passwordInputLabelText: Scalars['String'];
  submitText: Scalars['String'];
};

export type FormsSignInLocalization = {
  __typename?: 'FormsSignInLocalization';
  accountLockedErrorText: Scalars['String'];
  emailInputPlaceholderText: Scalars['String'];
  forgotPasswordButtonText: Scalars['String'];
  genericErrorText: Scalars['String'];
  headingDefaultText: Scalars['String'];
  headingText: Scalars['String'];
  loginButtonText: Scalars['String'];
  passwordInputPlaceholderText: Scalars['String'];
  signUpButtonText: Scalars['String'];
  signUpDefaultHeadingText: Scalars['String'];
  signUpHeadingText: Scalars['String'];
};

export type FormsSignupLocalization = {
  __typename?: 'FormsSignupLocalization';
  accountLogoAltText: Scalars['String'];
  ageRequirementErrorText: Scalars['String'];
  birthdayLabelText: Scalars['String'];
  createAccountPageHeadingText: Scalars['String'];
  dayLabelText: Scalars['String'];
  emailLabelText: Scalars['String'];
  emailOptIn?: Maybe<EmailOptInLocalization>;
  emailPlaceholderText: Scalars['String'];
  errorResetPasswordLinkText: Scalars['String'];
  errorText: Scalars['String'];
  firstNameLabelText: Scalars['String'];
  firstNamePlaceholderText: Scalars['String'];
  headingText: Scalars['String'];
  lastNameLabelText: Scalars['String'];
  lastNamePlaceholderText: Scalars['String'];
  monthLabelText: Scalars['String'];
  passwordLabelText: Scalars['String'];
  passwordPlaceholderText: Scalars['String'];
  submitText: Scalars['String'];
  yearLabelText: Scalars['String'];
};

export type FormsTosLocalization = {
  __typename?: 'FormsTosLocalization';
  body: Scalars['String'];
  errorText: Scalars['String'];
  tosLinkText: Scalars['String'];
};

export type FormsValidationLocalization = {
  __typename?: 'FormsValidationLocalization';
  companyRequiredWithTaxIdErrorText: Scalars['String'];
  dayRequiredErrorText: Scalars['String'];
  emailRequiredErrorText: Scalars['String'];
  fieldRequiredErrorText: Scalars['String'];
  invalidDateErrorText: Scalars['String'];
  invalidPasswordErrorText: Scalars['String'];
  invalidPhoneErrorText: Scalars['String'];
  invalidTaxIdErrorText: Scalars['String'];
  invalidTaxIdLengthErrorText: Scalars['String'];
  monthRequiredErrorText: Scalars['String'];
  newPasswordRequiredErrorText: Scalars['String'];
  passwordRequiredErrorText: Scalars['String'];
  requiredErrorText: Scalars['String'];
  signupPasswordRequiredErrorText: Scalars['String'];
  taxIdRequiredWithCompanyErrorText: Scalars['String'];
  wrongEmailErrorText: Scalars['String'];
  yearRequiredErrorText: Scalars['String'];
};

export type FoundAddress = {
  __typename?: 'FoundAddress';
  description?: Maybe<Scalars['String']>;
  highlight?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FoundItems = {
  __typename?: 'FoundItems';
  items?: Maybe<Array<FoundAddress>>;
};

export type FreeOfChargeInput = {
  unused?: InputMaybe<Scalars['Boolean']>;
};

export type Fulfillment = {
  __typename?: 'Fulfillment';
  externalFulfillmentId?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  insertedAt?: Maybe<Scalars['DateTime']>;
  items: Array<FulfillmentItem>;
  orderId?: Maybe<Scalars['UUID4']>;
  status?: Maybe<StatusLabels>;
  statusCompleteAt?: Maybe<Scalars['DateTime']>;
  taxServiceUpdatedAt?: Maybe<Scalars['NaiveDateTime']>;
  tracking?: Maybe<TrackingNumber>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  warehouseCode?: Maybe<Scalars['String']>;
};

export type FulfillmentItem = {
  __typename?: 'FulfillmentItem';
  insertedAt: Scalars['DateTime'];
  item?: Maybe<Item>;
  quantity?: Maybe<Scalars['Int']>;
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type GasExchangeRecord = {
  __typename?: 'GasExchangeRecord';
  deadlineIsExtendable?: Maybe<Scalars['Boolean']>;
  dueDate?: Maybe<Scalars['Date']>;
  gasExchangeReturns: Array<GasExchangeReturn>;
  holdCharge?: Maybe<Scalars['Boolean']>;
  holdChargeReason?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  initialDueDate?: Maybe<Scalars['Date']>;
  lastChargeAttemptAt?: Maybe<Scalars['Date']>;
  lastGasExchangeReturn?: Maybe<GasExchangeReturn>;
  lineItem: LineItem;
  missingOrder?: Maybe<SubmittedOrder>;
  noOfDaysTillDueDate?: Maybe<Scalars['Int']>;
  order: SubmittedOrder;
  priceItem: PriceItem;
  qty?: Maybe<Scalars['Int']>;
  returnedQty?: Maybe<Scalars['Int']>;
  status?: Maybe<GasExchangeRecordStatusType>;
  warnUserAboutDepositFees?: Maybe<Scalars['Boolean']>;
};

export type GasExchangeRecordPayload = {
  __typename?: 'GasExchangeRecordPayload';
  gasExchangeRecords: Array<GasExchangeRecord>;
  pagination: PaginationData;
};

export enum GasExchangeRecordStatusType {
  Active = 'ACTIVE',
  Closed = 'CLOSED'
}

export enum GasExchangeRecordsStatus {
  Active = 'ACTIVE',
  All = 'ALL',
  Closed = 'CLOSED'
}

export type GasExchangeReturn = {
  __typename?: 'GasExchangeReturn';
  appliedQuantity?: Maybe<Scalars['Int']>;
  returnDate?: Maybe<Scalars['Date']>;
  returnedQuantity?: Maybe<Scalars['Int']>;
};

/** Gatorade Bottle customization input. */
export type GatoradeBottleCustomizationInput = {
  bottleCode?: InputMaybe<Scalars['String']>;
  bottleLidThumbnailImage?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fontCode?: InputMaybe<Scalars['String']>;
  gaVariant?: InputMaybe<Scalars['String']>;
  /** Flexible field for frontend usage only. NEVER sent to schip or used for business logic. */
  metadata?: InputMaybe<Scalars['Json']>;
  number?: InputMaybe<Scalars['String']>;
  patternCode?: InputMaybe<Scalars['String']>;
  patternId?: InputMaybe<Scalars['String']>;
  ringCode?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

/** Gatorade Bottle customization output. */
export type GatoradeBottleCustomizationOutput = {
  __typename?: 'GatoradeBottleCustomizationOutput';
  bottleCode?: Maybe<Scalars['String']>;
  bottleLidThumbnailImage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fontCode?: Maybe<Scalars['String']>;
  gaVariant?: Maybe<Scalars['String']>;
  /** Flexible field for frontend usage only. NEVER sent to schip or used for business logic. */
  metadata?: Maybe<Scalars['Json']>;
  number?: Maybe<Scalars['String']>;
  patternCode?: Maybe<Scalars['String']>;
  patternId?: Maybe<Scalars['String']>;
  ringCode?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

/** (Deprecated) Gatorade id bottle customization output. */
export type GatoradeIdBottle = {
  __typename?: 'GatoradeIdBottle';
  bottleLidFeatureText?: Maybe<Scalars['String']>;
  /** Values: 'blank', 'diy_strip', or 'text' */
  bottleLidFeatureType?: Maybe<Scalars['String']>;
  bottleLidFontColor?: Maybe<Scalars['String']>;
  bottleLidFontColorValue?: Maybe<Scalars['String']>;
  bottleLidFontType?: Maybe<Scalars['String']>;
  bottleLidLogo?: Maybe<Scalars['String']>;
  bottleLidLogoImage?: Maybe<Scalars['String']>;
  bottleLidNumber?: Maybe<Scalars['String']>;
  /** Values: 'logo' or 'number' */
  bottleLidNumberType?: Maybe<Scalars['String']>;
  bottleLidPattern?: Maybe<Scalars['String']>;
  bottleLidPrimaryColor?: Maybe<Scalars['String']>;
  bottleLidPrintFileUrl?: Maybe<Scalars['String']>;
  bottleLidSecondaryColor?: Maybe<Scalars['String']>;
  bottleLidStrokeColor?: Maybe<Scalars['String']>;
  bottleLidStrokeColorValue?: Maybe<Scalars['String']>;
  bottleLidStrokeWeight?: Maybe<Scalars['String']>;
  bottleLidThumbnailImage?: Maybe<Scalars['String']>;
  bottleSideFeatureLogo?: Maybe<Scalars['String']>;
  bottleSideFeatureText?: Maybe<Scalars['String']>;
  /** Values: 'text' or 'logo' */
  bottleSideFeatureType?: Maybe<Scalars['String']>;
  bottleSideFontColor?: Maybe<Scalars['String']>;
  bottleSideFontColorValue?: Maybe<Scalars['String']>;
  bottleSideFontType?: Maybe<Scalars['String']>;
  bottleSideLogoUrl?: Maybe<Scalars['String']>;
  bottleSideMascotAccentColor?: Maybe<Scalars['String']>;
  bottleSideMascotAccentColorValue?: Maybe<Scalars['String']>;
  bottleSideMascotBaseColor?: Maybe<Scalars['String']>;
  bottleSideMascotBaseColorValue?: Maybe<Scalars['String']>;
  bottleSideMascotName?: Maybe<Scalars['String']>;
  bottleSideMascotNonCustomColor?: Maybe<Scalars['String']>;
  bottleSideMascotNonCustomColorValue?: Maybe<Scalars['String']>;
  bottleSidePattern?: Maybe<Scalars['String']>;
  bottleSidePatternImage?: Maybe<Scalars['String']>;
  bottleSidePrimaryColor?: Maybe<Scalars['String']>;
  bottleSidePrimaryColorValue?: Maybe<Scalars['String']>;
  bottleSidePrintFileUrl?: Maybe<Scalars['String']>;
  bottleSideSecondaryColor?: Maybe<Scalars['String']>;
  bottleSideSecondaryColorValue?: Maybe<Scalars['String']>;
  bottleSideStrokeColor?: Maybe<Scalars['String']>;
  bottleSideStrokeColorValue?: Maybe<Scalars['String']>;
  bottleSideStrokeWeight?: Maybe<Scalars['String']>;
  bottleSideThumbnailImage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  enhancerVariantGtin?: Maybe<Scalars['String']>;
};

export type GatoradeIdBottleCustomizationOutput = {
  __typename?: 'GatoradeIdBottleCustomizationOutput';
  bottleLidThumbnailImage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  number?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type GatoradeProductCategoryProperties = {
  __typename?: 'GatoradeProductCategoryProperties';
  hideFormatFromVariantSlugs: Scalars['Boolean'];
  showPricePerUnit: Scalars['Boolean'];
};

/** Gatorade Squeeze Bottle customization input. */
export type GatoradeSqueezeBottleCustomizationInput = {
  applyUpcLabel?: InputMaybe<Scalars['String']>;
  bottleAiDesignId?: InputMaybe<Scalars['String']>;
  bottleBackPrintFileUrl?: InputMaybe<Scalars['String']>;
  bottleFrontPrintFileUrl?: InputMaybe<Scalars['String']>;
  bottleLidBoltColor?: InputMaybe<Scalars['String']>;
  bottleLidFeatureText?: InputMaybe<Scalars['String']>;
  bottleLidFeatureType?: InputMaybe<Scalars['String']>;
  bottleLidFontColor?: InputMaybe<Scalars['String']>;
  bottleLidNumber?: InputMaybe<Scalars['String']>;
  bottleLidNumberType?: InputMaybe<Scalars['String']>;
  bottleLidPrimaryColor?: InputMaybe<Scalars['String']>;
  bottleLidPrintFileUrl?: InputMaybe<Scalars['String']>;
  bottleLidSecondaryColor?: InputMaybe<Scalars['String']>;
  bottleLidThumbnailImage?: InputMaybe<Scalars['String']>;
  bottleSideBoltColor?: InputMaybe<Scalars['String']>;
  bottleSideFeatureText?: InputMaybe<Scalars['String']>;
  bottleSideFeatureTextColor?: InputMaybe<Scalars['String']>;
  bottleSideFeatureType?: InputMaybe<Scalars['String']>;
  bottleSideFontType?: InputMaybe<Scalars['String']>;
  bottleSideLogoUrl?: InputMaybe<Scalars['String']>;
  bottleSidePattern?: InputMaybe<Scalars['String']>;
  bottleSidePrimaryColor?: InputMaybe<Scalars['String']>;
  bottleSidePrimaryColorValue?: InputMaybe<Scalars['String']>;
  bottleSideSecondaryColor?: InputMaybe<Scalars['String']>;
  bottleSideSecondaryColorValue?: InputMaybe<Scalars['String']>;
  bottleSideTertiaryColor?: InputMaybe<Scalars['String']>;
  bottleSideTertiaryColorValue?: InputMaybe<Scalars['String']>;
  bottleSideTextColorValue?: InputMaybe<Scalars['String']>;
  bottleSideThumbnailImage?: InputMaybe<Scalars['String']>;
  bottleTeam?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  /** Flexible field for frontend usage only. NEVER sent to schip or used for business logic. */
  metadata?: InputMaybe<Scalars['Json']>;
  qty?: InputMaybe<Scalars['Int']>;
  royaltyId?: InputMaybe<Scalars['String']>;
  vendor?: InputMaybe<Scalars['String']>;
};

/** Gatorade Squeeze Bottle customization output. */
export type GatoradeSqueezeBottleCustomizationOutput = {
  __typename?: 'GatoradeSqueezeBottleCustomizationOutput';
  applyUpcLabel?: Maybe<Scalars['String']>;
  bottleAiDesignId?: Maybe<Scalars['String']>;
  bottleBackPrintFileUrl?: Maybe<Scalars['String']>;
  bottleFrontPrintFileUrl?: Maybe<Scalars['String']>;
  bottleLidBoltColor?: Maybe<Scalars['String']>;
  bottleLidFeatureText?: Maybe<Scalars['String']>;
  bottleLidFeatureType?: Maybe<Scalars['String']>;
  bottleLidFontColor?: Maybe<Scalars['String']>;
  bottleLidNumber?: Maybe<Scalars['String']>;
  bottleLidNumberType?: Maybe<Scalars['String']>;
  bottleLidPrimaryColor?: Maybe<Scalars['String']>;
  bottleLidPrintFileUrl?: Maybe<Scalars['String']>;
  bottleLidSecondaryColor?: Maybe<Scalars['String']>;
  bottleLidThumbnailImage?: Maybe<Scalars['String']>;
  bottleSideBoltColor?: Maybe<Scalars['String']>;
  bottleSideFeatureText?: Maybe<Scalars['String']>;
  bottleSideFeatureTextColor?: Maybe<Scalars['String']>;
  bottleSideFeatureType?: Maybe<Scalars['String']>;
  bottleSideFontType?: Maybe<Scalars['String']>;
  bottleSideLogoUrl?: Maybe<Scalars['String']>;
  bottleSidePattern?: Maybe<Scalars['String']>;
  bottleSidePrimaryColor?: Maybe<Scalars['String']>;
  bottleSidePrimaryColorValue?: Maybe<Scalars['String']>;
  bottleSideSecondaryColor?: Maybe<Scalars['String']>;
  bottleSideSecondaryColorValue?: Maybe<Scalars['String']>;
  bottleSideTertiaryColor?: Maybe<Scalars['String']>;
  bottleSideTertiaryColorValue?: Maybe<Scalars['String']>;
  bottleSideTextColorValue?: Maybe<Scalars['String']>;
  bottleSideThumbnailImage?: Maybe<Scalars['String']>;
  bottleTeam?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  /** Flexible field for frontend usage only. NEVER sent to schip or used for business logic. */
  metadata?: Maybe<Scalars['Json']>;
  qty?: Maybe<Scalars['Int']>;
  royaltyId?: Maybe<Scalars['String']>;
  vendor?: Maybe<Scalars['String']>;
};

/** Gatorade Stainless Steel bottle customization input. */
export type GatoradeStainlessSteelCustomizationInput = {
  applyUpcLabel?: InputMaybe<Scalars['String']>;
  bottleImageFile?: InputMaybe<Scalars['String']>;
  bottleImageUrl?: InputMaybe<Scalars['String']>;
  bottleLidColor?: InputMaybe<Scalars['String']>;
  bottleLidColorValue?: InputMaybe<Scalars['String']>;
  bottleLidFeatureText?: InputMaybe<Scalars['String']>;
  bottleLidFeatureType?: InputMaybe<Scalars['String']>;
  bottleLidFormat?: InputMaybe<Scalars['String']>;
  bottleLidNumber?: InputMaybe<Scalars['String']>;
  bottleLidNumberType?: InputMaybe<Scalars['String']>;
  bottleLidThumbnailImage?: InputMaybe<Scalars['String']>;
  bottleSideBoltColor?: InputMaybe<Scalars['String']>;
  bottleSideFeatureText?: InputMaybe<Scalars['String']>;
  bottleSideFeatureType?: InputMaybe<Scalars['String']>;
  bottleSideFontType?: InputMaybe<Scalars['String']>;
  bottleSideLogoUrl?: InputMaybe<Scalars['String']>;
  bottleSideMaterialColor?: InputMaybe<Scalars['String']>;
  bottleSideMaterialColorValue?: InputMaybe<Scalars['String']>;
  bottleSidePattern?: InputMaybe<Scalars['String']>;
  bottleSidePrimaryColor?: InputMaybe<Scalars['String']>;
  bottleSidePrimaryColorValue?: InputMaybe<Scalars['String']>;
  bottleSideSecondaryColor?: InputMaybe<Scalars['String']>;
  bottleSideSecondaryColorValue?: InputMaybe<Scalars['String']>;
  bottleSideTextColor?: InputMaybe<Scalars['String']>;
  bottleSideTextColorValue?: InputMaybe<Scalars['String']>;
  bottleSideTextDirection?: InputMaybe<Scalars['String']>;
  bottleSideThumbnailImage?: InputMaybe<Scalars['String']>;
  bottleTeam?: InputMaybe<Scalars['String']>;
  idRingImageFile?: InputMaybe<Scalars['String']>;
  idRingImageUrl?: InputMaybe<Scalars['String']>;
  /** Flexible field for frontend usage only. NEVER sent to schip or used for business logic. */
  metadata?: InputMaybe<Scalars['Json']>;
  qty?: InputMaybe<Scalars['Int']>;
  royaltyId?: InputMaybe<Scalars['String']>;
  vendor?: InputMaybe<Scalars['String']>;
};

/** Gatorade Stainless Steel bottle customization output. */
export type GatoradeStainlessSteelCustomizationOutput = {
  __typename?: 'GatoradeStainlessSteelCustomizationOutput';
  applyUpcLabel?: Maybe<Scalars['String']>;
  bottleImageFile?: Maybe<Scalars['String']>;
  bottleImageUrl?: Maybe<Scalars['String']>;
  bottleLidColor?: Maybe<Scalars['String']>;
  bottleLidColorValue?: Maybe<Scalars['String']>;
  bottleLidFeatureText?: Maybe<Scalars['String']>;
  bottleLidFeatureType?: Maybe<Scalars['String']>;
  bottleLidFormat?: Maybe<Scalars['String']>;
  bottleLidNumber?: Maybe<Scalars['String']>;
  bottleLidNumberType?: Maybe<Scalars['String']>;
  bottleLidThumbnailImage?: Maybe<Scalars['String']>;
  bottleSideBoltColor?: Maybe<Scalars['String']>;
  bottleSideFeatureText?: Maybe<Scalars['String']>;
  bottleSideFeatureType?: Maybe<Scalars['String']>;
  bottleSideFontType?: Maybe<Scalars['String']>;
  bottleSideLogoUrl?: Maybe<Scalars['String']>;
  bottleSideMaterialColor?: Maybe<Scalars['String']>;
  bottleSideMaterialColorValue?: Maybe<Scalars['String']>;
  bottleSidePattern?: Maybe<Scalars['String']>;
  bottleSidePrimaryColor?: Maybe<Scalars['String']>;
  bottleSidePrimaryColorValue?: Maybe<Scalars['String']>;
  bottleSideSecondaryColor?: Maybe<Scalars['String']>;
  bottleSideSecondaryColorValue?: Maybe<Scalars['String']>;
  bottleSideTextColor?: Maybe<Scalars['String']>;
  bottleSideTextColorValue?: Maybe<Scalars['String']>;
  bottleSideTextDirection?: Maybe<Scalars['String']>;
  bottleSideThumbnailImage?: Maybe<Scalars['String']>;
  bottleTeam?: Maybe<Scalars['String']>;
  idRingImageFile?: Maybe<Scalars['String']>;
  idRingImageUrl?: Maybe<Scalars['String']>;
  /** Flexible field for frontend usage only. NEVER sent to schip or used for business logic. */
  metadata?: Maybe<Scalars['Json']>;
  qty?: Maybe<Scalars['Int']>;
  royaltyId?: Maybe<Scalars['String']>;
  vendor?: Maybe<Scalars['String']>;
};

/** (Deprecated) Gatorade towel customization output. */
export type GatoradeTowel = {
  __typename?: 'GatoradeTowel';
  text?: Maybe<Scalars['String']>;
  towelFeatureLogo?: Maybe<Scalars['String']>;
  towelFeatureText?: Maybe<Scalars['String']>;
  /** Values: 'text' or 'logo' */
  towelFeatureType?: Maybe<Scalars['String']>;
  towelFontColor?: Maybe<Scalars['String']>;
  towelFontColorValue?: Maybe<Scalars['String']>;
  towelFontType?: Maybe<Scalars['String']>;
  towelLogoUrl?: Maybe<Scalars['String']>;
  towelMascotAccentColor?: Maybe<Scalars['String']>;
  towelMascotAccentColorValue?: Maybe<Scalars['String']>;
  towelMascotBaseColor?: Maybe<Scalars['String']>;
  towelMascotBaseColorValue?: Maybe<Scalars['String']>;
  towelMascotName?: Maybe<Scalars['String']>;
  towelMascotNonCustomColor?: Maybe<Scalars['String']>;
  towelMascotNonCustomColorValue?: Maybe<Scalars['String']>;
  towelPattern?: Maybe<Scalars['String']>;
  towelPatternImage?: Maybe<Scalars['String']>;
  towelPrimaryColor?: Maybe<Scalars['String']>;
  towelPrimaryColorValue?: Maybe<Scalars['String']>;
  towelPrintFileUrl?: Maybe<Scalars['String']>;
  towelSecondaryColor?: Maybe<Scalars['String']>;
  towelSecondaryColorValue?: Maybe<Scalars['String']>;
  towelStrokeColor?: Maybe<Scalars['String']>;
  towelStrokeColorValue?: Maybe<Scalars['String']>;
  towelStrokeWeight?: Maybe<Scalars['String']>;
  towelTextLogoState?: Maybe<Scalars['String']>;
  towelThumbnailImage?: Maybe<Scalars['String']>;
};

/**
 * Gatorade towel customization input.
 * Used for GraphQL inputs when creating/updating cart items with towel customizations.
 */
export type GatoradeTowelCustomizationInput = {
  family?: InputMaybe<Scalars['String']>;
  /** Flexible field for frontend usage only. NEVER sent to schip or used for business logic. */
  metadata?: InputMaybe<Scalars['Json']>;
  qty?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  towelFeatureText?: InputMaybe<Scalars['String']>;
  towelFeatureType?: InputMaybe<Scalars['String']>;
  towelFontColor?: InputMaybe<Scalars['String']>;
  towelFontColorValue?: InputMaybe<Scalars['String']>;
  towelFontType?: InputMaybe<Scalars['String']>;
  towelLogoUrl?: InputMaybe<Scalars['String']>;
  towelPattern?: InputMaybe<Scalars['String']>;
  towelPrimaryColor?: InputMaybe<Scalars['String']>;
  towelPrimaryColorValue?: InputMaybe<Scalars['String']>;
  towelPrintFileUrl?: InputMaybe<Scalars['String']>;
  towelSecondaryColor?: InputMaybe<Scalars['String']>;
  towelSecondaryColorValue?: InputMaybe<Scalars['String']>;
  towelStrokeColorValue?: InputMaybe<Scalars['String']>;
  towelTertiaryColor?: InputMaybe<Scalars['String']>;
  towelTertiaryColorValue?: InputMaybe<Scalars['String']>;
  towelTextLogoState?: InputMaybe<Scalars['String']>;
  towelThumbnailImage?: InputMaybe<Scalars['String']>;
  variation?: InputMaybe<Scalars['Int']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Gatorade towel customization output. */
export type GatoradeTowelCustomizationOutput = {
  __typename?: 'GatoradeTowelCustomizationOutput';
  family?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  /** Flexible field for frontend usage only. NEVER sent to schip or used for business logic. */
  metadata?: Maybe<Scalars['Json']>;
  qty?: Maybe<Scalars['Int']>;
  template?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  towelFeatureText?: Maybe<Scalars['String']>;
  towelFeatureType?: Maybe<Scalars['String']>;
  towelFontColor?: Maybe<Scalars['String']>;
  towelFontColorValue?: Maybe<Scalars['String']>;
  towelFontType?: Maybe<Scalars['String']>;
  towelLogoUrl?: Maybe<Scalars['String']>;
  towelPattern?: Maybe<Scalars['String']>;
  towelPrimaryColor?: Maybe<Scalars['String']>;
  towelPrimaryColorValue?: Maybe<Scalars['String']>;
  towelPrintFileUrl?: Maybe<Scalars['String']>;
  towelSecondaryColor?: Maybe<Scalars['String']>;
  towelSecondaryColorValue?: Maybe<Scalars['String']>;
  towelStrokeColorValue?: Maybe<Scalars['String']>;
  towelTertiaryColor?: Maybe<Scalars['String']>;
  towelTertiaryColorValue?: Maybe<Scalars['String']>;
  towelTextLogoState?: Maybe<Scalars['String']>;
  towelThumbnailImage?: Maybe<Scalars['String']>;
  variation?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

export type GeneralConfig = {
  __typename?: 'GeneralConfig';
  inventorySyncSunsetAt?: Maybe<Scalars['DateTime']>;
  /** the tenant will become read only on this date */
  readOnlyAt?: Maybe<Scalars['DateTime']>;
  /** URL of the successor storefront when this tenant is sunset or read-only */
  tenantSuccessorUrl?: Maybe<Scalars['String']>;
  tenantSunsetAt?: Maybe<Scalars['DateTime']>;
};

export type GiftCardConfig = {
  __typename?: 'GiftCardConfig';
  giftCardsEnabled?: Maybe<Scalars['Boolean']>;
};

export type GiftCardInput = {
  cardNumber: Scalars['String'];
  pin: Scalars['String'];
};

export type GiftConfig = {
  __typename?: 'GiftConfig';
  giftEmailConfig?: Maybe<GiftEmailConfig>;
  giftingEnabled?: Maybe<Scalars['Boolean']>;
};

export type GiftEmailConfig = {
  __typename?: 'GiftEmailConfig';
  centralImageUrl?: Maybe<Scalars['String']>;
  footerCopy?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
};

export type GiftInfo = {
  __typename?: 'GiftInfo';
  gifteeEmail?: Maybe<Scalars['String']>;
  gifteeMessage?: Maybe<Scalars['String']>;
  giftorName?: Maybe<Scalars['String']>;
};

/** Input for mutation to update the shipping address on the checkout session.  Address fields required for an address are all required */
export type GiftInfoInput = {
  gifteeEmail?: InputMaybe<Scalars['String']>;
  gifteeMessage?: InputMaybe<Scalars['String']>;
  giftorName?: InputMaybe<Scalars['String']>;
};

export type GtmConfig = {
  __typename?: 'GtmConfig';
  auth?: Maybe<Scalars['String']>;
  containerId?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['String']>;
};

export type GuestCartContainsSubscriptionData = {
  __typename?: 'GuestCartContainsSubscriptionData';
  itemId: Scalars['UUID4'];
};

export type GuestCartContainsSubscriptionLocalizations = {
  __typename?: 'GuestCartContainsSubscriptionLocalizations';
  cartText: Scalars['String'];
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type GuestCartContainsSubscriptionValidationError = ValidationError & {
  __typename?: 'GuestCartContainsSubscriptionValidationError';
  details: Array<GuestCartContainsSubscriptionData>;
  reason: Scalars['String'];
};

export type HsppKit = {
  __typename?: 'HsppKit';
  hsppKitComponents?: Maybe<Array<Maybe<HsppKitComponent>>>;
  id: Scalars['UUID4'];
  insertedAt: Scalars['DateTime'];
  key: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  variant?: Maybe<Variant>;
};

export type HsppKitComponent = {
  __typename?: 'HsppKitComponent';
  hsppKit?: Maybe<HsppKit>;
  id: Scalars['UUID4'];
  insertedAt: Scalars['DateTime'];
  itemMaxQty: Scalars['Int'];
  itemMinQty: Scalars['Int'];
  items?: Maybe<Array<Maybe<Item>>>;
  key: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type HsppKitComponentInput = {
  /** The key of the HSPP Kit Component */
  componentKey: Scalars['String'];
  /** Items within this HSPP Kit Component */
  items: Array<InputMaybe<HsppKitComponentItemInput>>;
};

export type HsppKitComponentItemInput = {
  /** Analytics details for this HSPP Kit Component Item (map) */
  analyticsDetails?: InputMaybe<Scalars['Json']>;
  /** IDs of customizations already stored on the cart. Use instead of typed_customizations when the FE already has IDs from a previous call. Cannot be combined with typed_customizations. */
  customizationIds?: InputMaybe<Array<Scalars['UUID4']>>;
  /** Customizations for this HSPP Kit Component Item (list of maps) */
  customizations?: InputMaybe<Scalars['Json']>;
  /** The GTIN of the HSPP Kit Component Item */
  gtin: Scalars['String'];
  /** The quantity of this Item in the HSPP Kit Component */
  quantity: Scalars['Int'];
  /** Typed customizations for this HSPP Kit Component Item */
  typedCustomizations?: InputMaybe<Array<InputMaybe<CustomizationInput>>>;
};

export type HsppKitDataInput = {
  /** HSPP Kit Components for hspp_kit variants */
  hsppKitComponents: Array<InputMaybe<HsppKitComponentInput>>;
};

export type HsppKitRequiresManagedCustomerValidationError = ValidationError & {
  __typename?: 'HsppKitRequiresManagedCustomerValidationError';
  reason: Scalars['String'];
};

export type HsppKitYearlyMaximumReachedValidationError = ValidationError & {
  __typename?: 'HsppKitYearlyMaximumReachedValidationError';
  quantity: Scalars['Int'];
  reason: Scalars['String'];
  yearlyLimit: Scalars['Int'];
  yearlyUsage: Scalars['Int'];
};

export type HsppPurchaseWindowClosedValidationError = ValidationError & {
  __typename?: 'HsppPurchaseWindowClosedValidationError';
  cutoffDate: Scalars['Date'];
  reason: Scalars['String'];
};

export type IncompleteShippingAddressValidationError = ValidationError & {
  __typename?: 'IncompleteShippingAddressValidationError';
  reason: Scalars['String'];
};

export type InsufficientLoyaltyBalanceLocalizations = {
  __typename?: 'InsufficientLoyaltyBalanceLocalizations';
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type InvalidGiftCardLocalizations = {
  __typename?: 'InvalidGiftCardLocalizations';
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type InvalidLoyaltyItemsValidationError = ValidationError & {
  __typename?: 'InvalidLoyaltyItemsValidationError';
  reason: Scalars['String'];
};

export type InvalidLoyaltyRewardLocalizations = {
  __typename?: 'InvalidLoyaltyRewardLocalizations';
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type InventoryLowStockData = {
  __typename?: 'InventoryLowStockData';
  inventoryQty: Scalars['Int'];
  itemId: Scalars['UUID4'];
};

export type InventoryOutOfStockData = {
  __typename?: 'InventoryOutOfStockData';
  itemId: Scalars['UUID4'];
};

export type InventoryValidationError = ValidationError & {
  __typename?: 'InventoryValidationError';
  lowStockDetails: Array<InventoryLowStockData>;
  outOfStockDetails: Array<InventoryOutOfStockData>;
  reason: Scalars['String'];
};

export type InvoiceInput = {
  unused?: InputMaybe<Scalars['Boolean']>;
};

export type InvoicedAddress = {
  __typename?: 'InvoicedAddress';
  /** This field indicates whether this address has a loading dock and accepts LTL (less than truckload) shipments. */
  acceptsLtl: Scalars['Boolean'];
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  /** Indicates if this is the default bill-to address for the account. */
  defaultBillTo?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  lastName?: Maybe<Scalars['String']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  /** Phone extension for this address. Up to 10 digits. */
  phoneExtension?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  specialInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type Invoicing = {
  __typename?: 'Invoicing';
  addresses: Array<InvoicedAddress>;
  /** The default bill-to address for the account. */
  defaultBillToAddress?: Maybe<InvoicedAddress>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type IsAddressValidForTaxInput = {
  city: Scalars['String'];
  countryCode: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type IsAddressValidForTaxPayload = {
  __typename?: 'IsAddressValidForTaxPayload';
  isValid?: Maybe<Scalars['Boolean']>;
};

export type Item = {
  __typename?: 'Item';
  /** @deprecated Unsupported */
  brandName?: Maybe<Scalars['String']>;
  compareAtPrice: Scalars['Int'];
  discounts?: Maybe<Array<Maybe<Discount>>>;
  gasExchangeInfo?: Maybe<ItemGasExchangeInfo>;
  gtin: Scalars['String'];
  id: Scalars['UUID4'];
  imgUrl?: Maybe<Scalars['String']>;
  inventoryQty?: Maybe<Scalars['Int']>;
  isOutOfStock?: Maybe<Scalars['Boolean']>;
  itemLinks?: Maybe<Array<Maybe<ItemLink>>>;
  itemNotifications: Array<Scalars['String']>;
  itemTaxInfo?: Maybe<ItemTaxInfo>;
  minOrderQty?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  pricePerUnit?: Maybe<Scalars['Int']>;
  purchaseQtyLimit?: Maybe<Scalars['Int']>;
  registrationInfo?: Maybe<RegistrationInfo>;
  /** @deprecated Unsupported */
  slug?: Maybe<Scalars['String']>;
  /** @deprecated This field will no longer return any sub_items */
  subItems?: Maybe<Array<Maybe<BundleItem>>>;
  title?: Maybe<Scalars['String']>;
  virtual?: Maybe<Scalars['Boolean']>;
};

/** The customization status of items in the checkout session's cart. */
export enum ItemCustomizationsStatus {
  /** All items in the cart are customized */
  AllCustomizations = 'ALL_CUSTOMIZATIONS',
  /** No items in the cart are customized */
  NoCustomizations = 'NO_CUSTOMIZATIONS',
  /** Some items in the cart are customized */
  SomeCustomizations = 'SOME_CUSTOMIZATIONS'
}

export type ItemGasExchangeInfo = {
  __typename?: 'ItemGasExchangeInfo';
  enabled: Scalars['Boolean'];
  missingCylinder?: Maybe<Item>;
  missingCylinderId?: Maybe<Scalars['UUID4']>;
};

export type ItemLink = {
  __typename?: 'ItemLink';
  type: ItemLinkType;
  url: Scalars['String'];
};

export enum ItemLinkType {
  CylinderPdp = 'CYLINDER_PDP',
  UserManual = 'USER_MANUAL'
}

export type ItemTaxInfo = {
  __typename?: 'ItemTaxInfo';
  beverageType?: Maybe<Scalars['String']>;
  caloriesPerEa?: Maybe<Scalars['Decimal']>;
  containerType?: Maybe<Scalars['String']>;
  grossWeightPerPackOz?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['UUID4']>;
  isCarbonatedOrIntendedToBe?: Maybe<Scalars['Boolean']>;
  isMilkPrimary?: Maybe<Scalars['Boolean']>;
  itemId?: Maybe<Scalars['UUID4']>;
  netWeightPerEaOz?: Maybe<Scalars['Decimal']>;
  percentJuicePerEa?: Maybe<Scalars['Decimal']>;
  productiveOutputPerEaFlOz?: Maybe<Scalars['Decimal']>;
  quantityOfEaPerPak?: Maybe<Scalars['Int']>;
  sugarPerEaG?: Maybe<Scalars['Decimal']>;
  taxCodeId?: Maybe<Scalars['String']>;
  unsweetened?: Maybe<Scalars['Boolean']>;
  volumePerEaFlOz?: Maybe<Scalars['Decimal']>;
};

export type ItemUnavailableLocalizations = {
  __typename?: 'ItemUnavailableLocalizations';
  cartText: Scalars['String'];
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type Kit = {
  __typename?: 'Kit';
  archived: Scalars['Boolean'];
  id: Scalars['UUID4'];
  insertedAt: Scalars['DateTime'];
  key?: Maybe<Scalars['String']>;
  kitItems?: Maybe<Array<Maybe<KitItem>>>;
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  variants?: Maybe<Array<Maybe<Variant>>>;
};

export type KitDataInput = {
  /** Kit items for kit variants */
  kitItems?: InputMaybe<Array<InputMaybe<KitItemDataInput>>>;
};

export type KitItem = {
  __typename?: 'KitItem';
  id: Scalars['UUID4'];
  insertedAt: Scalars['DateTime'];
  item?: Maybe<Item>;
  kit?: Maybe<Kit>;
  qty?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type KitItemDataInput = {
  /** Analytics details for this kit item (map) */
  analyticsDetails?: InputMaybe<Scalars['Json']>;
  /** IDs of customizations already stored on the cart. Use instead of typed_customizations when the FE already has IDs from a previous call. Cannot be combined with typed_customizations. */
  customizationIds?: InputMaybe<Array<Scalars['UUID4']>>;
  /** DEPRECATED: Use typed_customizations instead. Customizations for this kit item (map) */
  customizations?: InputMaybe<Scalars['Json']>;
  /** The GTIN of the kit item */
  gtin: Scalars['String'];
  /** Typed customizations for this kit item */
  typedCustomizations?: InputMaybe<Array<InputMaybe<CustomizationInput>>>;
};

/** (Deprecated) Legacy customization output. */
export type LegacyCustomization = {
  __typename?: 'LegacyCustomization';
  bottleCode?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  patternId?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  thumbnailImage?: Maybe<Scalars['String']>;
};

/** Legacy customization data - returns the raw data map for maximum flexibility. */
export type LegacyCustomizationOutput = {
  __typename?: 'LegacyCustomizationOutput';
  data?: Maybe<Scalars['Json']>;
  id: Scalars['UUID4'];
};

/** All price information related to an individual item. */
export type LineItem = {
  __typename?: 'LineItem';
  /** Item in it's current state (may differ from the embedded item) */
  currentItem?: Maybe<Item>;
  /** Any customizations made to the item. */
  customizations?: Maybe<Array<Customization>>;
  discounts: Array<LineItemDiscount>;
  gtin: Scalars['String'];
  /** image url */
  imgUrl?: Maybe<Scalars['String']>;
  /** Item as it was when purchased */
  item?: Maybe<EmbeddedItem>;
  /** ID of the item. */
  itemId: Scalars['UUID4'];
  /** field populated with existing notifications for a gtin */
  itemNotifications: Array<Scalars['String']>;
  /** The discounted price of the item as an individual unit (rounded up, except for promo-code discounts, which are not adjusted). */
  perUnitPrice: Scalars['Int'];
  /** The quantity of the item in the order. */
  quantity: Scalars['Int'];
  /** The original price of the item as an individual unit (either the compare_at_price or or non-discounted price). */
  strikethroughUnitPrice?: Maybe<Scalars['Int']>;
  subscription?: Maybe<SubscriptionMetadata>;
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
  /** calculated by subtracting the discount_total from the items base_price * quantity (except for promo-code discounts, which are not included) */
  subtotal: Scalars['Int'];
  title: Scalars['String'];
};

/** Discount information as it applies to the individual line item */
export type LineItemDiscount = {
  __typename?: 'LineItemDiscount';
  amount: Scalars['Int'];
  category: DiscountCategory;
  discountId: Scalars['UUID4'];
  name?: Maybe<Scalars['String']>;
  type: DiscountType;
};

export type Localization = {
  __typename?: 'Localization';
  checkout?: Maybe<CheckoutLocalization>;
  components?: Maybe<ComponentsLocalization>;
  currentLocale: Scalars['String'];
  defaultLocale: Scalars['String'];
  forms?: Maybe<FormsLocalization>;
  /** @deprecated `locale` has been deprecated in favor of `defaultLocale` */
  locale: Scalars['String'];
  portal?: Maybe<PortalLocalization>;
};

export type LoginUserInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LoginUserWithAuthorizationCodeInput = {
  authorizationCode: Scalars['String'];
  redirectUri: Scalars['String'];
};

export type LoginUserWithJwtInput = {
  oktaJwt: Scalars['String'];
};

/**
 * Payload returned by the `lookupPromoCode` query.
 *
 * Contains the promo code's redemption status.
 */
export type LookupPromoCodePayload = {
  __typename?: 'LookupPromoCodePayload';
  /**
   * Whether the promo code has been fully redeemed. `true` when the code's
   * usage has reached its limit; always `false` for unlimited codes.
   */
  fullyRedeemed: Scalars['Boolean'];
};

export type LowStockLocalizations = {
  __typename?: 'LowStockLocalizations';
  cartText: Scalars['String'];
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type LoyaltyConfig = {
  __typename?: 'LoyaltyConfig';
  loyaltyProgramActive: Scalars['Boolean'];
  loyaltyProgramActiveUntil?: Maybe<Scalars['DateTime']>;
  pointsEarningDisabledAfter?: Maybe<Scalars['DateTime']>;
  pointsEarningEnabled: Scalars['Boolean'];
};

/** loyalty data aggregation at Cart and Price level. Will contain total points redeemed, total amount of dollars, and points earned */
export type LoyaltyData = {
  __typename?: 'LoyaltyData';
  totalAmount: Scalars['Int'];
  totalEarnedPoints: Scalars['Int'];
  totalPoints: Scalars['Int'];
};

/** loyalty reward the user has applied to their cart. */
export type LoyaltyReward = {
  __typename?: 'LoyaltyReward';
  code: Scalars['String'];
  quantity: Scalars['Int'];
  totalAmount: Scalars['Int'];
  totalPoints: Scalars['Int'];
};

export type ManagedCustomer = {
  __typename?: 'ManagedCustomer';
  acceptsLtl: Scalars['Boolean'];
  /**
   * Whether the managed customer has been retired. Archived customers are hidden
   * from `searchManagedCustomers` unless `includeArchived: true` is passed, but
   * remain resolvable so past orders and carts still reference them.
   */
  archived: Scalars['Boolean'];
  city?: Maybe<Scalars['String']>;
  currentYearRemainingPerformancePacks: Scalars['Int'];
  id: Scalars['ID'];
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  specialInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** Contact information for managed customer orders */
export type ManagedCustomerContactInfo = {
  __typename?: 'ManagedCustomerContactInfo';
  additionalEmails?: Maybe<Array<Scalars['String']>>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phoneExtension?: Maybe<Scalars['String']>;
  title?: Maybe<ManagedCustomerTitle>;
};

/** Consolidated managed customer data for checkout sessions and orders */
export type ManagedCustomerData = {
  __typename?: 'ManagedCustomerData';
  contactInfo?: Maybe<ManagedCustomerContactInfo>;
  managedCustomerId?: Maybe<Scalars['UUID4']>;
  managedCustomerPo?: Maybe<Scalars['String']>;
  season?: Maybe<ManagedCustomerSeason>;
  sportKey?: Maybe<Scalars['String']>;
  /** Sport display name (e.g., 'Boys Football', 'General Purpose') resolved from sport_key */
  sportName?: Maybe<Scalars['String']>;
  /** Available sports for selection (sorted by sport_name) */
  sports?: Maybe<Array<Maybe<Sport>>>;
};

export type ManagedCustomerRequiresHsppKitValidationError = ValidationError & {
  __typename?: 'ManagedCustomerRequiresHsppKitValidationError';
  reason: Scalars['String'];
};

export type ManagedCustomerSearchInput = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  nameAndCity?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  sorting?: InputMaybe<ManagedCustomerSortingInput>;
  type: Scalars['String'];
};

/** Season for managed customer purchase */
export enum ManagedCustomerSeason {
  /** Fall season */
  Fall = 'FALL',
  /** Not applicable */
  Na = 'NA',
  /** Spring season */
  Spring = 'SPRING',
  /** Summer season */
  Summer = 'SUMMER',
  /** Winter season */
  Winter = 'WINTER'
}

export enum ManagedCustomerSortField {
  Name = 'NAME'
}

export type ManagedCustomerSortingInput = {
  sortBy: ManagedCustomerSortField;
  sortOrder: SortOrder;
};

/** Title/role for managed customer contact */
export enum ManagedCustomerTitle {
  /** Athletic director */
  AthleticDirector = 'ATHLETIC_DIRECTOR',
  /** Athletic trainer */
  AthleticTrainer = 'ATHLETIC_TRAINER',
  /** Head coach */
  HeadCoach = 'HEAD_COACH',
  /** Other */
  Other = 'OTHER'
}

export type ManagedCustomersPayload = {
  __typename?: 'ManagedCustomersPayload';
  managedCustomers: Array<ManagedCustomer>;
  pagination: PaginationData;
};

export type MinimumAllocationEligibleQuantityValidationError = ValidationError & {
  __typename?: 'MinimumAllocationEligibleQuantityValidationError';
  quantity: Scalars['Int'];
  reason: Scalars['String'];
};

export type MinimumPurchaseAmountValidationError = ValidationError & {
  __typename?: 'MinimumPurchaseAmountValidationError';
  amount: Scalars['Int'];
  reason: Scalars['String'];
};

export type MinimumPurchaseQuantityValidationError = ValidationError & {
  __typename?: 'MinimumPurchaseQuantityValidationError';
  quantity: Scalars['Int'];
  reason: Scalars['String'];
};

export type MissingItemTaxInfoValidationError = ValidationError & {
  __typename?: 'MissingItemTaxInfoValidationError';
  itemId: Scalars['UUID4'];
  itemTitle: Scalars['String'];
  missingFields: Array<Scalars['String']>;
  reason: Scalars['String'];
};

export type NewsletterBasicSignupInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type NewsletterFullSignupInput = {
  dateOfBirth: Scalars['Date'];
  email: Scalars['String'];
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  smsOptIn?: InputMaybe<Scalars['Boolean']>;
  sourceId?: InputMaybe<Scalars['String']>;
};

export type NextErrorLocalization = {
  __typename?: 'NextErrorLocalization';
  pageNotFound: Scalars['String'];
};

export type NullBehaviour = {
  __typename?: 'NullBehaviour';
  name: BehaviourEnum;
};

export type OktaConfig = {
  __typename?: 'OktaConfig';
  groupId: Scalars['String'];
};

export type OptsInput = {
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<SearchInput>;
};

export type OrangeTheoryInquiryInput = {
  city: Scalars['String'];
  comments?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  marketingSupportType: Scalars['String'];
  state: Scalars['String'];
  streetAddressOne: Scalars['String'];
  streetAddressTwo?: InputMaybe<Scalars['String']>;
  studioName: Scalars['String'];
  zip: Scalars['String'];
};

/**
 * The customer-facing category for a canceled order. Internal cancellation details are
 * intentionally grouped under OTHER.
 */
export enum OrderCancellationCategory {
  /** The order was canceled because a customization was rejected */
  CustomizationRejected = 'CUSTOMIZATION_REJECTED',
  /** The order was canceled for another reason */
  Other = 'OTHER'
}

export enum OrderCancellationReasonValue {
  BudgetChange = 'BUDGET_CHANGE',
  DuplicateOrder = 'DUPLICATE_ORDER',
  EventCancelledOrPostponed = 'EVENT_CANCELLED_OR_POSTPONED',
  NoLongerNeeded = 'NO_LONGER_NEEDED',
  Other = 'OTHER',
  SwitchingSuppliers = 'SWITCHING_SUPPLIERS'
}

export type OrderMessage = {
  __typename?: 'OrderMessage';
  body?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<OrderMessageLink>>>;
  location: Scalars['String'];
  severity: OrderMessageSeverity;
  type: Scalars['String'];
};

export type OrderMessageLink = {
  __typename?: 'OrderMessageLink';
  displayValue: Scalars['String'];
  key: Scalars['String'];
  linkValue: Scalars['String'];
  type: Scalars['String'];
};

export enum OrderMessageSeverity {
  Info = 'INFO'
}

/** Order payment entry from the ledger showing individual payment method charges */
export type OrderPaymentEntry = {
  __typename?: 'OrderPaymentEntry';
  amount?: Maybe<Scalars['Int']>;
  billingAddress?: Maybe<BillingAddress>;
  externalTransactionId?: Maybe<Scalars['String']>;
  isBillingEqualShipping?: Maybe<Scalars['Boolean']>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentMethodType?: Maybe<AllowedPaymentMethod>;
  processorType?: Maybe<Scalars['String']>;
};

export type OrderProcessing = {
  __typename?: 'OrderProcessing';
  headingText: Scalars['String'];
  subHeadingText: Scalars['String'];
};

export enum OrderProcessingStatus {
  OrderCancelled = 'ORDER_CANCELLED',
  OrderNotFound = 'ORDER_NOT_FOUND',
  OrderProcessed = 'ORDER_PROCESSED',
  PaymentProcessing = 'PAYMENT_PROCESSING'
}

export type OrderSubscription = {
  __typename?: 'OrderSubscription';
  address: Address;
  id: Scalars['UUID4'];
  initialOrderDate?: Maybe<Scalars['DateTime']>;
  insertedAt: Scalars['DateTime'];
  intervalInDays: Scalars['Int'];
  isTemporary?: Maybe<Scalars['Boolean']>;
  lastOrderAttempt?: Maybe<Scalars['DateTime']>;
  lastSuccessfulOrderDate: Scalars['Date'];
  nextOrderCreationDates: Array<Maybe<Scalars['Date']>>;
  orderSubscriptionItems: Array<OrderSubscriptionItem>;
  orderSubscriptionVariants: Array<OrderSubscriptionVariant>;
  originatingOrder?: Maybe<SubmittedOrder>;
  paymentInfo?: Maybe<PaymentInfo>;
  price: Price;
  sourceSubscriptionId?: Maybe<Scalars['UUID4']>;
  status: OrderSubscriptionStatusNames;
  statusReason?: Maybe<Scalars['String']>;
  statusReasonValue: OrderSubscriptionStatusReasonValues;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  tenant: Tenant;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
};

export type OrderSubscriptionItem = {
  __typename?: 'OrderSubscriptionItem';
  analyticsDetails?: Maybe<Scalars['Json']>;
  /** Item in its current state */
  currentItem?: Maybe<Item>;
  customizations?: Maybe<Scalars['Json']>;
  id: Scalars['UUID4'];
  /** Item as it was when purchased */
  item?: Maybe<EmbeddedItem>;
  orderSubscription: OrderSubscription;
  price: Scalars['Int'];
  quantity: Scalars['Int'];
  sourceSubscriptionItemId?: Maybe<Scalars['UUID4']>;
};

export enum OrderSubscriptionRelationshipNames {
  /** Order that was a direct result of a subscription execution */
  Child = 'CHILD',
  /** Order with no relationship to any subscriptions */
  None = 'NONE',
  /** Order that resulted in subscriptions being made (priceItem had > 0 subscription_interval_in_days values) */
  Parent = 'PARENT'
}

export enum OrderSubscriptionStatusNames {
  /** Subscription is active and in valid state to fulfill */
  Active = 'ACTIVE',
  /** Subscription is canceled for reason stated in `status_reason_value` */
  Canceled = 'CANCELED',
  /** Subscription is paused for reason stated in `status_reason_value` */
  Paused = 'PAUSED'
}

export type OrderSubscriptionStatusReasonValueWithKey = {
  __typename?: 'OrderSubscriptionStatusReasonValueWithKey';
  label: Scalars['String'];
  value: OrderSubscriptionStatusReasonValues;
};

export enum OrderSubscriptionStatusReasonValues {
  /** DONT_NEED_ANYMORE */
  DontNeedAnymore = 'DONT_NEED_ANYMORE',
  /** FRAUD_DECLINED */
  FraudDeclined = 'FRAUD_DECLINED',
  /** NEED_TO_START_A_NEW_SUBSCRIPTION */
  NeedToStartANewSubscription = 'NEED_TO_START_A_NEW_SUBSCRIPTION',
  /** NOT_FINISHED_WITH_MY_LAST_SHIPMENT */
  NotFinishedWithMyLastShipment = 'NOT_FINISHED_WITH_MY_LAST_SHIPMENT',
  /** OTHER */
  Other = 'OTHER',
  /** PAYMENT_METHOD_NOT_FOUND */
  PaymentMethodNotFound = 'PAYMENT_METHOD_NOT_FOUND',
  /** PAYMENT_NOT_ACCEPTED */
  PaymentNotAccepted = 'PAYMENT_NOT_ACCEPTED',
  /** PREFER_TO_BUY_IN_STORE */
  PreferToBuyInStore = 'PREFER_TO_BUY_IN_STORE',
  /** SHIPPING_OR_DELIVERY_ISSUE */
  ShippingOrDeliveryIssue = 'SHIPPING_OR_DELIVERY_ISSUE',
  /** UPDATED_PAYMENT */
  UpdatedPayment = 'UPDATED_PAYMENT',
  /** USER_INITIATED_CANCEL */
  UserInitiatedCancel = 'USER_INITIATED_CANCEL'
}

export type OrderSubscriptionVariant = {
  __typename?: 'OrderSubscriptionVariant';
  id: Scalars['UUID4'];
  orderSubscription: OrderSubscription;
  quantity: Scalars['Int'];
  sourceSubscriptionVariantId?: Maybe<Scalars['UUID4']>;
  variant?: Maybe<Variant>;
  variantPriceItemId?: Maybe<Scalars['UUID4']>;
};

/**
 * A user-blocking term that must be acknowledged before submitting the order.
 * Distinct from order_messages — terms gate submission, messages do not.
 */
export type OrderTerm = {
  __typename?: 'OrderTerm';
  displayText: Scalars['String'];
  errorText: Scalars['String'];
  hasCheckbox: Scalars['Boolean'];
  isRequired: Scalars['Boolean'];
  type: Scalars['String'];
};

export type OutOfStockLocalizations = {
  __typename?: 'OutOfStockLocalizations';
  cartText: Scalars['String'];
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
  scheduledOrderCartText: Scalars['String'];
};

export type PaginationData = {
  __typename?: 'PaginationData';
  count: Scalars['Int'];
  page: Scalars['Int'];
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PaginationInput = {
  /** Number of items per page. Must be between 1 and 200 inclusive. */
  limit: Scalars['Int'];
  page: Scalars['Int'];
};

/**
 * Takes advantage of the oneOf custom directive that
 * enforces fields based on the base key for the input
 * type.
 */
export type PartnerInquiryInput = {
  bulkOrder?: InputMaybe<BulkOrderInquiryInput>;
  orangeTheory?: InputMaybe<OrangeTheoryInquiryInput>;
};

export type PasswordRequirement = {
  __typename?: 'PasswordRequirement';
  msg: Scalars['String'];
  satisfied: Scalars['Boolean'];
};

export type PasswordRequirementDoubleCondition = {
  __typename?: 'PasswordRequirementDoubleCondition';
  bodyText: Scalars['String'];
  boldText1: Scalars['String'];
  boldText2: Scalars['String'];
};

export type PasswordRequirementSingleCondition = {
  __typename?: 'PasswordRequirementSingleCondition';
  bodyText: Scalars['String'];
  boldText: Scalars['String'];
};

/** User's payment details needed during checkout. */
export type Payment = {
  __typename?: 'Payment';
  billingAddress?: Maybe<BillingAddress>;
  clientConfirmationToken?: Maybe<Scalars['String']>;
  isBillingEqualShipping?: Maybe<Scalars['Boolean']>;
  lastErrorCode?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<AllowedPaymentMethod>;
  paymentMethodId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<Scalars['String']>;
  /** Split payment entries showing breakdown by payment method for split payments */
  splitEntries?: Maybe<Array<Maybe<SplitEntry>>>;
  token?: Maybe<Scalars['String']>;
};

export type PaymentClientTokenPayload = {
  __typename?: 'PaymentClientTokenPayload';
  token: Scalars['String'];
};

export type PaymentConfig = {
  __typename?: 'PaymentConfig';
  availablePaymentMethods?: Maybe<Array<Scalars['String']>>;
  billingAddressConfig: AddressConfig;
  descriptor?: Maybe<Scalars['String']>;
  paymentTypes: Array<PaymentType>;
  processor?: Maybe<PaymentProcessor>;
  processors?: Maybe<Array<Maybe<PaymentProcessor>>>;
  publicPaymentToken?: Maybe<Scalars['String']>;
  /**
   * Determines whether the frontend should set up a payment intent that
   *   should not be modified once created instead of the backend both setting
   *   up and confirming it. Certain payment methods like Blik which require
   *   that a fixed payment intent is set up before the stripe element is
   *   loaded.
   */
  stripeFixedPaymentIntent?: Maybe<Scalars['Boolean']>;
};

export type PaymentInfo = {
  __typename?: 'PaymentInfo';
  cardExpirationDate?: Maybe<Scalars['String']>;
  cardExpiryMonth?: Maybe<Scalars['String']>;
  cardExpiryYear?: Maybe<Scalars['String']>;
  cardType?: Maybe<PaymentInfoCardType>;
  cardholderName?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  /** Order payment entries from ledger for submitted orders */
  paymentEntries?: Maybe<Array<Maybe<OrderPaymentEntry>>>;
  paymentMethod?: Maybe<PaymentInfoPaymentMethod>;
  paymentToken?: Maybe<Scalars['String']>;
  /** Split payment entries showing breakdown by payment method for review step */
  splitEntries?: Maybe<Array<Maybe<SplitEntry>>>;
  uniqueNumberIdentifier?: Maybe<Scalars['String']>;
};

/** Enum for the different types of cards in the payment_info */
export enum PaymentInfoCardType {
  AmericanExpress = 'AMERICAN_EXPRESS',
  Discover = 'DISCOVER',
  Jcb = 'JCB',
  Mastercard = 'MASTERCARD',
  Visa = 'VISA'
}

/** List of payment methods on PaymentInfo. */
export enum PaymentInfoPaymentMethod {
  AllocatedCredit = 'ALLOCATED_CREDIT',
  ApplePayCard = 'APPLE_PAY_CARD',
  Blik = 'BLIK',
  CreditCard = 'CREDIT_CARD',
  FreeOfCharge = 'FREE_OF_CHARGE',
  Invoice = 'INVOICE',
  P24 = 'P24',
  PaypalAccount = 'PAYPAL_ACCOUNT',
  SplitPayment = 'SPLIT_PAYMENT'
}

/** object for holding a single default payment method */
export type PaymentMethod = ApplePayCard | CreditCard | PaypalAccount;

/** A list of credit cards saved by the user and a list of valid credit card types. */
export type PaymentMethodCreditCard = {
  __typename?: 'PaymentMethodCreditCard';
  savedCards: Array<CreditCard>;
  validCardTypes: Array<CardType>;
};

export enum PaymentMethodEnum {
  CreditCard = 'CREDIT_CARD',
  Paypal = 'PAYPAL'
}

/** A list of paypal accounts saved by the user. */
export type PaymentMethodPaypal = {
  __typename?: 'PaymentMethodPaypal';
  savedAccounts: Array<PaypalAccount>;
  validCardTypes: Array<CardType>;
};

/** object defined to hold the different payment methods */
export type PaymentMethods = {
  __typename?: 'PaymentMethods';
  applePayCards: Array<ApplePayCard>;
  creditCards: Array<CreditCard>;
  default?: Maybe<PaymentMethod>;
  paypalAccounts: Array<PaypalAccount>;
};

/** Payment option breakdown by payment method type */
export type PaymentOption = {
  __typename?: 'PaymentOption';
  discount?: Maybe<Scalars['Int']>;
  shipping?: Maybe<Scalars['Int']>;
  subtotal?: Maybe<Scalars['Int']>;
  taxSalesTotal?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  type: SplitPaymentMethodType;
};

export type PaymentOptionsInput = {
  default?: InputMaybe<Scalars['Boolean']>;
  nonce?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  token?: InputMaybe<Scalars['String']>;
};

export enum PaymentProcessor {
  Braintree = 'braintree',
  SplitProcessor = 'split_processor',
  Stripe = 'stripe'
}

export type PaymentRequest = {
  __typename?: 'PaymentRequest';
  billingAddress?: Maybe<BillingAddress>;
  isBillingEqualShipping?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<AllowedPaymentMethod>;
};

export type PaymentType = {
  __typename?: 'PaymentType';
  brandImgUrl: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** Paypal account saved by the user. */
export type PaypalAccount = {
  __typename?: 'PaypalAccount';
  email: Scalars['String'];
  isDefault: Scalars['Boolean'];
  isRemovable?: Maybe<Scalars['Boolean']>;
  /** Token representing payment method. */
  token: Scalars['String'];
};

/** Input for mutation to save paypal payment information */
export type PaypalInput = {
  token?: InputMaybe<Scalars['String']>;
};

export type PaypalOrderPatchInput = {
  paypalOrderId: Scalars['String'];
  shipping: ExpressCheckoutAddressInput;
};

export type PhoneNumberCountryCodesAllowed = {
  __typename?: 'PhoneNumberCountryCodesAllowed';
  code: Scalars['String'];
  country: Scalars['String'];
  length: Scalars['Int'];
};

export type PortalAccountPageLocalization = {
  __typename?: 'PortalAccountPageLocalization';
  activeAccountHeadingText: Scalars['String'];
  addressesHeadingText: Scalars['String'];
  defaultTitleText: Scalars['String'];
  emailHeadingText: Scalars['String'];
  nameHeadingText: Scalars['String'];
  nameUpdateButtonText: Scalars['String'];
  nameUpdateCancelButtonText: Scalars['String'];
  nameUpdateSubmitButtonText: Scalars['String'];
  passwordChangeButtonText: Scalars['String'];
  passwordHeadingText: Scalars['String'];
  paymentsHeadingText: Scalars['String'];
};

export type PortalAddressLocalization = {
  __typename?: 'PortalAddressLocalization';
  addHeadingText: Scalars['String'];
  addSubmitButtonText: Scalars['String'];
  cancelButtonText: Scalars['String'];
  closeButtonText: Scalars['String'];
  confirmLoadingDockButtonText: Scalars['String'];
  confirmLoadingDockHeaderText: Scalars['String'];
  confirmLoadingDockText: Scalars['String'];
  editHeadingText: Scalars['String'];
  makeDefaultText: Scalars['String'];
  updateSubmitButtonText: Scalars['String'];
};

export type PortalAltsLocalization = {
  __typename?: 'PortalAltsLocalization';
  accountAltText: Scalars['String'];
  shopLogoAltText: Scalars['String'];
};

export type PortalBreadcrumbsLocalization = {
  __typename?: 'PortalBreadcrumbsLocalization';
  account: Scalars['String'];
  accountDetails: Scalars['String'];
  addAddress: Scalars['String'];
  addPayment: Scalars['String'];
  canceledOrders: Scalars['String'];
  changePassword: Scalars['String'];
  editAddress: Scalars['String'];
  exchange: Scalars['String'];
  exchangeDetails: Scalars['String'];
  machines: Scalars['String'];
  notFound: Scalars['String'];
  orders: Scalars['String'];
  scheduledOrders: Scalars['String'];
  shippingAddresses: Scalars['String'];
  subscriptions: Scalars['String'];
};

export type PortalCardLocalization = {
  __typename?: 'PortalCardLocalization';
  addAddressLabel: Scalars['String'];
  addPaymentLabel: Scalars['String'];
  allocationText: Scalars['String'];
  creditCardNumberText: Scalars['String'];
  currentLabel: Scalars['String'];
  defaultAddressLabel: Scalars['String'];
  defaultPaymentLabel: Scalars['String'];
  defaultText: Scalars['String'];
  deleteButtonText: Scalars['String'];
  editButtonText: Scalars['String'];
  loadingDockText: Scalars['String'];
  makeDefaultButtonText: Scalars['String'];
  numRemainingLabel: Scalars['String'];
  selectLabel: Scalars['String'];
  subscriptionAddressButtonText: Scalars['String'];
  viewAllButtonText: Scalars['String'];
};

export type PortalErrorsAddressVerificationLocalization = {
  __typename?: 'PortalErrorsAddressVerificationLocalization';
  checkoutSpecificConfirmSuggestedText: Scalars['String'];
  confirmSuggestedAddressText: Scalars['String'];
  confirmText: Scalars['String'];
  doYouWantToProceedText: Scalars['String'];
  editEnteredAddressText: Scalars['String'];
  editText: Scalars['String'];
  enteredAddressText: Scalars['String'];
  goBackText: Scalars['String'];
  invalidZipCodeText: Scalars['String'];
  keepEnteredAddressText: Scalars['String'];
  notAbleToVerifyShippingAddressText: Scalars['String'];
  recommendChangesText: Scalars['String'];
  shippingAddressText: Scalars['String'];
  suggestedAddressText: Scalars['String'];
  useSuggestedAddressText: Scalars['String'];
  verifyText: Scalars['String'];
};

export type PortalErrorsGeoblockLocalization = {
  __typename?: 'PortalErrorsGeoblockLocalization';
  apiError: Scalars['String'];
  zipBlocked: Scalars['String'];
};

export type PortalErrorsLocalization = {
  __typename?: 'PortalErrorsLocalization';
  addressVerification?: Maybe<PortalErrorsAddressVerificationLocalization>;
  geoBlock?: Maybe<PortalErrorsGeoblockLocalization>;
};

export type PortalExchangeDetailsPageLocalization = {
  __typename?: 'PortalExchangeDetailsPageLocalization';
  avoidDepositFeesWarningTextFractional: Scalars['String'];
  avoidDepositFeesWarningTextMany: Scalars['String'];
  avoidDepositFeesWarningTextPlural: Scalars['String'];
  avoidDepositFeesWarningTextSingular: Scalars['String'];
  daysLeftToReturnHeadingText: Scalars['String'];
  daysLeftToReturnTextPlural: Scalars['String'];
  daysLeftToReturnTextSingular: Scalars['String'];
  depositFeeAddedAlertText: Scalars['String'];
  depositFeeAddedText: Scalars['String'];
  exchangeDetailsText: Scalars['String'];
  expectedReturnDateText: Scalars['String'];
  extendReturnDeadlineText: Scalars['String'];
  missedReturnDateText: Scalars['String'];
  notFoundMsg: Scalars['String'];
  orderDetailsHeadingText: Scalars['String'];
  orderedText: Scalars['String'];
  paymentHeadingText: Scalars['String'];
  returnByText: Scalars['String'];
  returnDateExtendedText: Scalars['String'];
  returnDateText: Scalars['String'];
  returnedOnText: Scalars['String'];
  returnedOutOfTotalText: Scalars['String'];
  returnedText: Scalars['String'];
  shippingHeadingText: Scalars['String'];
  statusText: Scalars['String'];
  yourOrderText: Scalars['String'];
};

export type PortalExchangeListPageLocalization = {
  __typename?: 'PortalExchangeListPageLocalization';
  active: Scalars['String'];
  closed: Scalars['String'];
  cylinderText: Scalars['String'];
  dueInDaysTextPlural: Scalars['String'];
  dueInDaysTextSingular: Scalars['String'];
  gasExchangeListTitle: Scalars['String'];
  gasExchangePageListTitle: Scalars['String'];
  orderDate: Scalars['String'];
  returnByDate: Scalars['String'];
  returnPastDue: Scalars['String'];
  returnedDate: Scalars['String'];
  viewDetails: Scalars['String'];
};

export type PortalHeaderLocalization = {
  __typename?: 'PortalHeaderLocalization';
  signOutLinkText: Scalars['String'];
};

/**
 * Returns a map of all portal (my account) elements and their translations.
 *
 * Example:
 *     ```
 *     query {
 *       localization {
 *         portal {
 *           accountPage {
 *             nameHeadingText
 *           }
 *         }
 *       }
 *     }
 *     ```
 */
export type PortalLocalization = {
  __typename?: 'PortalLocalization';
  accountPage?: Maybe<PortalAccountPageLocalization>;
  accountVerification?: Maybe<AccountVerificationLocalization>;
  address?: Maybe<PortalAddressLocalization>;
  alts?: Maybe<PortalAltsLocalization>;
  breadcrumbs?: Maybe<PortalBreadcrumbsLocalization>;
  card?: Maybe<PortalCardLocalization>;
  errors?: Maybe<PortalErrorsLocalization>;
  exchangeDetailPage?: Maybe<PortalExchangeDetailsPageLocalization>;
  exchangeList?: Maybe<PortalExchangeListPageLocalization>;
  header?: Maybe<PortalHeaderLocalization>;
  machinesPage?: Maybe<PortalMachinesPageLocalization>;
  notAvailable?: Maybe<PortalNotAvailableLocalization>;
  orderDetailPage?: Maybe<PortalOrderDetailPageLocalization>;
  orderSummary?: Maybe<PortalOrderSummaryLocalization>;
  ordersPage?: Maybe<PortalOrdersPageLocalization>;
  pageTitlesInHead?: Maybe<PortalPageTitlesInHeadLocalization>;
  password?: Maybe<PortalPasswordLocalization>;
  payment?: Maybe<PortalPaymentLocalization>;
  subscriptionDetailPage?: Maybe<PortalSubscriptionDetailPageLocalization>;
  subscriptionsPage?: Maybe<PortalSubscriptionsPageLocalization>;
};

export type PortalMachinesPageLocalization = {
  __typename?: 'PortalMachinesPageLocalization';
  addMachinesText: Scalars['String'];
  areYouSureDeleteThisMachineText: Scalars['String'];
  cancelText: Scalars['String'];
  confirmDeletionText: Scalars['String'];
  deleteMachineText: Scalars['String'];
  getGasText: Scalars['String'];
  learnAboutSparklingWaterMakersText: Scalars['String'];
  machineText: Scalars['String'];
  machinesText: Scalars['String'];
  registerYourMachineNowText: Scalars['String'];
  troubleshootingGuideText: Scalars['String'];
  unlockWarrantyText: Scalars['String'];
  userManualText: Scalars['String'];
  warrantyExpiredText: Scalars['String'];
  warrantyExpiresText: Scalars['String'];
  yesDeleteThisMachineText: Scalars['String'];
};

export type PortalNotAvailableLocalization = {
  __typename?: 'PortalNotAvailableLocalization';
  exchanges: Scalars['String'];
  headingText: Scalars['String'];
  linkContentText: Scalars['String'];
  linkText: Scalars['String'];
  naAbbreviationText: Scalars['String'];
  orders: Scalars['String'];
  subscriptions: Scalars['String'];
};

export type PortalOrderDetailPageLocalization = {
  __typename?: 'PortalOrderDetailPageLocalization';
  dateText: Scalars['String'];
  invoiceNote: Scalars['String'];
  notFoundErrorText: Scalars['String'];
  orderIdHeadingText: Scalars['String'];
  orderSummaryHeadingText: Scalars['String'];
  paymentHeadingText: Scalars['String'];
  printButtonText: Scalars['String'];
  questionAboutOrderNumberText: Scalars['String'];
  questionAboutOrderText: Scalars['String'];
  shippingAddressHeadingText: Scalars['String'];
  trackingText: Scalars['String'];
};

export type PortalOrderSummaryLocalization = {
  __typename?: 'PortalOrderSummaryLocalization';
  estimatedFeeLabel: Scalars['String'];
  estimatedTaxLabel: Scalars['String'];
  feeLabel: Scalars['String'];
  freeShipLabel: Scalars['String'];
  shippingLabel: Scalars['String'];
  subtotalLabel: Scalars['String'];
  totalLabel: Scalars['String'];
};

export type PortalOrdersPageLocalization = {
  __typename?: 'PortalOrdersPageLocalization';
  dateHeadingText: Scalars['String'];
  exchangeText: Scalars['String'];
  orderIdHeadingText: Scalars['String'];
  ordersHeadingText: Scalars['String'];
  receiptButtonText: Scalars['String'];
  reorderButtonText: Scalars['String'];
  reorderErrorNote: Scalars['String'];
  shippingAddressHeadingText: Scalars['String'];
  totalHeadingText: Scalars['String'];
};

export type PortalPageTitlesInHeadLocalization = {
  __typename?: 'PortalPageTitlesInHeadLocalization';
  verifyAccount: Scalars['String'];
};

export type PortalPasswordLocalization = {
  __typename?: 'PortalPasswordLocalization';
  backButtonText: Scalars['String'];
  cancelButtonText: Scalars['String'];
  changePasswordCancelButtonText: Scalars['String'];
  changePasswordHeadingText: Scalars['String'];
  changePasswordSubmitButtonText: Scalars['String'];
  checkYourEmailContentText: Scalars['String'];
  checkYourEmailHeadingText: Scalars['String'];
  currentPasswordLabelText: Scalars['String'];
  forgotPasswordHeadingText: Scalars['String'];
  forgotPasswordHeadingWithTenantText: Scalars['String'];
  minCharactersText: PasswordRequirementSingleCondition;
  newPasswordLabelText: Scalars['String'];
  oneSpecialCharText: PasswordRequirementSingleCondition;
  oneUppercaseOneLowercaseAlphaText: PasswordRequirementDoubleCondition;
  passwordUpdatedBannerText: Scalars['String'];
  resetPasswordHeadingText: Scalars['String'];
  resetPasswordHeadingWithTenantText: Scalars['String'];
  twoNumericDigitsText: PasswordRequirementSingleCondition;
  updatePasswordHeadingText: Scalars['String'];
};

export type PortalPaymentLocalization = {
  __typename?: 'PortalPaymentLocalization';
  addHeadingText: Scalars['String'];
  billingSameAsShippingText: Scalars['String'];
  cancelButtonText: Scalars['String'];
  creditCardSelectorText: Scalars['String'];
  makeDefaultText: Scalars['String'];
  paypalSelectorText: Scalars['String'];
  submitButtonText: Scalars['String'];
};

export type PortalSubscriptionDetailPageLocalization = {
  __typename?: 'PortalSubscriptionDetailPageLocalization';
  addNewPaymentMethodText: Scalars['String'];
  addressHeadingText: Scalars['String'];
  backButtonText: Scalars['String'];
  cancelButtonText: Scalars['String'];
  cancelHeadingSubText: Scalars['String'];
  cancelHeadingText: Scalars['String'];
  cancelLabel: Scalars['String'];
  cancelSubscriptionButtonText: Scalars['String'];
  canceledText: Scalars['String'];
  closeButtonText: Scalars['String'];
  editAddressButtonText: Scalars['String'];
  editPaymentButtonText: Scalars['String'];
  existingPaymentMethodText: Scalars['String'];
  intervalHeadingText: Scalars['String'];
  intervalText: Scalars['String'];
  manageSubscriptionLabel: Scalars['String'];
  needToStartNewLabel: Scalars['String'];
  nextDeliveryDateHeadingText: Scalars['String'];
  nextShipmentDateText: Scalars['String'];
  noLongerNeedLabel: Scalars['String'];
  orderNowButtonText: Scalars['String'];
  orderNowLabel: Scalars['String'];
  orderNowLine1Text: Scalars['String'];
  orderNowLine2Text: Scalars['String'];
  orderNowModalHeadingText: Scalars['String'];
  orderNowOrderStatusOutOfStockErrorLineOneText: Scalars['String'];
  orderNowOrderStatusOutOfStockErrorLineTwoText: Scalars['String'];
  orderNowOrderStatusPaymentErrorLineOneText: Scalars['String'];
  orderNowOrderStatusPaymentErrorLineTwoText: Scalars['String'];
  orderNowOrderStatusSuccessText: Scalars['String'];
  orderNowOrderStatusSuccessTitleText: Scalars['String'];
  orderNowOrderStatusUnknownErrorLineOneText: Scalars['String'];
  orderNowOrderStatusUnknownErrorLineTwoText: Scalars['String'];
  orderedAtHeadingText: Scalars['String'];
  otherLabel: Scalars['String'];
  pausedBannerText: Scalars['String'];
  pausedText: Scalars['String'];
  paymentHeadingText: Scalars['String'];
  paymentUpdateButtonText: Scalars['String'];
  paymentUpdateNeededText: Scalars['String'];
  priceNoteText: Scalars['String'];
  reasonCommentPlaceholder: Scalars['String'];
  reasonForCancelingLabel: Scalars['String'];
  reasonForCancelingPlaceholder: Scalars['String'];
  renameLabel: Scalars['String'];
  resumeLabel: Scalars['String'];
  resumedBannerText: Scalars['String'];
  shippingIssueLabel: Scalars['String'];
  skipHeadingText: Scalars['String'];
  skipLabel: Scalars['String'];
  skipNextShipmentButtonText: Scalars['String'];
  skippedBannerText: Scalars['String'];
  skippedShipmentDateText: Scalars['String'];
  subscriptionNotFoundText: Scalars['String'];
  subscriptionText: Scalars['String'];
};

export type PortalSubscriptionsPageLocalization = {
  __typename?: 'PortalSubscriptionsPageLocalization';
  actionRequiredLabel: Scalars['String'];
  canceledLabel: Scalars['String'];
  headingText: Scalars['String'];
  intervalText: Scalars['String'];
  nextDeliveryDateText: Scalars['String'];
  noSubscriptionsFoundText: Scalars['String'];
  pausedLabel: Scalars['String'];
};

/** Contains relevant information about the price of an order. */
export type Price = {
  __typename?: 'Price';
  /** All customizations stored on this price. Available on draft prices and persisted order prices (via submittedOrder { price { customizations } }). */
  customizations: Array<CustomizationOutput>;
  /** Same as the discount_amount in promoCodeDiscount */
  discount: Scalars['Int'];
  discounts: Array<Discount>;
  /**
   * If the Price contains any Dynamic Bundles will hold top level definitions.
   * This will contain an array of maps which contain necessary DynamicBundle
   * information such as the DynamicBundle id and cart_bundle_reference that will
   * help identify which items belong to which bundle.
   */
  dynamicBundles?: Maybe<Scalars['Json']>;
  giftCards?: Maybe<Array<Maybe<EmbeddedGiftCard>>>;
  id?: Maybe<Scalars['UUID4']>;
  /**
   * True when the tax service was successfully called and taxes reflect real calculated amounts.
   * False when the tax service was unavailable (taxes shown as zero) or no items exist.
   * When false, the actual tax amount will be calculated at order processing time.
   * Only set on subscription price previews — always false on persisted order prices.
   */
  includesEstimatedTaxes: Scalars['Boolean'];
  items: Array<PriceItem>;
  /** This will contain LineItems */
  lineItems: Array<PriceItemsAndBundleItems>;
  loyaltyData?: Maybe<LoyaltyData>;
  paymentOptions?: Maybe<Array<Maybe<PaymentOption>>>;
  promoCodeDiscounts: Array<PromoCodeDiscount>;
  regulatoryTaxTypes: Array<RegulatoryTaxType>;
  /** Shipping cost of the order. */
  shipping: Scalars['Int'];
  /**
   * SubTotal of the order calculated by adding all line item base_prices and deducting
   * non promo code discounts
   */
  subtotal: Scalars['Int'];
  /** Total amount of regulatory tax applied to the order. */
  taxRegulatoryTotal: Scalars['Int'];
  /** Total amount of sales tax applied to the order. */
  taxSalesTotal: Scalars['Int'];
  /** Total of the order calculated by adding all line item totals. */
  total: Scalars['Int'];
  /** Total amount to charge via credit/debit card (excludes allocated_credit payment items) */
  totalChargedToUser?: Maybe<Scalars['Int']>;
  variantItems?: Maybe<Array<PriceVariantItem>>;
};

export type PriceItem = {
  __typename?: 'PriceItem';
  basePrice?: Maybe<Scalars['Int']>;
  compareAtPrice?: Maybe<Scalars['Int']>;
  /** Item in it's current state (may differ from embedded item) */
  currentItem?: Maybe<Item>;
  customizations?: Maybe<Scalars['Json']>;
  discountAmount?: Maybe<Scalars['Int']>;
  id: Scalars['UUID4'];
  /** Item as it was when purchased */
  item?: Maybe<EmbeddedItem>;
  itemId?: Maybe<Scalars['UUID4']>;
  price?: Maybe<Price>;
  quantity?: Maybe<Scalars['Int']>;
  /** @deprecated This field should not be used nor relied upon */
  shippingAmount?: Maybe<Scalars['Int']>;
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
  taxAmount?: Maybe<Scalars['Int']>;
  taxItems: Array<TaxItem>;
  unclaimedTaxes?: Maybe<Scalars['Int']>;
};

export type PriceItemsAndBundleItems = BundleLineItem | LineItem;

export type PriceLocalization = {
  __typename?: 'PriceLocalization';
  eachPriceText: Scalars['String'];
  regularPriceText: Scalars['String'];
};

export type PriceVariantItem = {
  __typename?: 'PriceVariantItem';
  /** Analytics details for the variant - This is a map which applies to each quantity of the variant */
  analyticsDetails?: Maybe<Scalars['Json']>;
  cartItemId?: Maybe<Scalars['UUID4']>;
  /** IDs of the customizations applied to this variant. Pass these as customization_ids in a future addCartItemUniqueVariant call to skip re-uploading customization data. */
  customizationIds: Array<Scalars['UUID4']>;
  /** [DEPRECATED] Customizations for the variant as a raw JSON map. Will be removed after 2026-09-01. Use typed_customizations instead. */
  customizations?: Maybe<Scalars['Json']>;
  /** The discounts that will be applied to the Variant Item */
  discounts?: Maybe<Array<LineItemDiscount>>;
  /** The customer-facing title of the variant */
  displayTitle: Scalars['String'];
  gtin: Scalars['String'];
  id: Scalars['UUID4'];
  /** The image urls of the variant. The first item is the primary image. */
  imgUrls?: Maybe<Array<Scalars['String']>>;
  /** Field populated with existing notifications for the variant's underlying price_items. For :bundle-type variants, this returns one notification per component price_item rather than a single deduped notification for the variant, matching the granularity used in order email rendering. */
  itemNotifications: Array<Scalars['String']>;
  /** [DEPRECATED] Legacy customizations as a list of raw JSON maps, built from typed_customizations. List counterpart to the singular `customizations` field. Will be removed after 2026-06-01. */
  legacyCustomizations: Array<Scalars['Json']>;
  /** [DEPRECATED] Legacy typed customizations built from typed_customizations. Returns the first legacy customization record in the old union format. Will be removed after 2026-06-01. */
  legacyTypedCustomizations?: Maybe<Array<Customization>>;
  /** The discounted price of the item as an individual unit (rounded up, except for promo-code discounts, which are not adjusted). */
  perUnitPrice: Scalars['Int'];
  quantity: Scalars['Int'];
  /** The original price of the item as an individual unit (either the compare_at_price or non-discounted price). */
  strikethroughUnitPrice?: Maybe<Scalars['Int']>;
  subGroups?: Maybe<Array<PriceVariantItemSubGroup>>;
  /** indicates FE must use 'Subscription' APIs */
  subscription: Scalars['Boolean'];
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
  /** Calculated by subtracting the discount_total from the items base_price * quantity (except for promo-code discounts, which are not included) */
  subtotal: Scalars['Int'];
  /** The canonical title of the variant */
  title: Scalars['String'];
  /** Typed customization for the variant. Same as customizations, but as a GQL type */
  typedCustomization?: Maybe<Customization>;
  /**
   * Typed customizations for the variant.
   * Returns a list of customization_output objects.
   */
  typedCustomizations?: Maybe<Array<Maybe<CustomizationOutput>>>;
  /** indicates FE must use 'Unique' APIs */
  unique: Scalars['Boolean'];
  variant: Variant;
};

export type PriceVariantItemSubGroup = {
  __typename?: 'PriceVariantItemSubGroup';
  items?: Maybe<Array<PriceVariantItemSubGroupItem>>;
  key?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PriceVariantItemSubGroupItem = {
  __typename?: 'PriceVariantItemSubGroupItem';
  analyticsDetails?: Maybe<Scalars['Json']>;
  /** IDs of the customizations applied to this sub-group item. */
  customizationIds: Array<Scalars['UUID4']>;
  /** [DEPRECATED] Customizations for this sub-group item as a raw JSON map. Will be removed after 2026-09-01. Use typed_customizations instead. */
  customizations?: Maybe<Scalars['Json']>;
  gtin: Scalars['String'];
  imgUrl?: Maybe<Scalars['String']>;
  /** [DEPRECATED] Legacy customizations as a list of raw JSON maps, built from typed_customizations. List counterpart to the singular `customizations` field. Will be removed after 2026-06-01. */
  legacyCustomizations: Array<Scalars['Json']>;
  /** [DEPRECATED] Legacy typed customizations built from typed_customizations. Returns the first legacy customization record in the old union format. Will be removed after 2026-06-01. */
  legacyTypedCustomizations?: Maybe<Array<Customization>>;
  quantity: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  typedCustomization?: Maybe<Customization>;
  /** List of typed customizations for this sub-group item */
  typedCustomizations?: Maybe<Array<Maybe<CustomizationOutput>>>;
};

export type Product = {
  __typename?: 'Product';
  archived: Scalars['Boolean'];
  id: Scalars['UUID4'];
  insertedAt: Scalars['DateTime'];
  key: Scalars['String'];
  primaryVariant?: Maybe<Variant>;
  productAttributes?: Maybe<Array<Maybe<ProductAttribute>>>;
  productCategory?: Maybe<ProductCategory>;
  /**
   * When non-null, every Cart Item for this Product must carry a customization payload or
   * the add is rejected with `customizationRequirementNotMet`. Null means no requirement.
   *
   * Use this to exclude or badge customization-required variants in pickers that cannot
   * collect a customization (e.g. the Scheduled Order Add Item picker), rather than
   * letting the buyer select an item whose add will always fail. Reachable from a variant
   * via `variant { product { requiredCustomizationType } }`.
   */
  requiredCustomizationType?: Maybe<RequiredCustomizationType>;
  slug?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  variants?: Maybe<Array<Maybe<Variant>>>;
};

export type ProductAttribute = {
  __typename?: 'ProductAttribute';
  displayIndex: Scalars['Int'];
  displayType: DisplayType;
  id: Scalars['UUID4'];
  label: Scalars['String'];
  name: Scalars['String'];
  product: Product;
  showOnPlp: Scalars['Boolean'];
  variantAttributes?: Maybe<Array<Maybe<VariantAttribute>>>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  id: Scalars['UUID4'];
  position: Scalars['Int'];
  slug: Scalars['String'];
  tenantSpecificProperties: ProductCategoryTenantSpecificProperties;
  title: Scalars['String'];
};

export type ProductCategoryTenantSpecificProperties = GatoradeProductCategoryProperties | UnstructuredProductCategoryProperties;

/**
 * Search input for products.
 *
 * When multiple `tags` are provided, products matching ANY of the tags will be returned (OR condition).
 * All other fields use AND logic when combined.
 */
export type ProductSearchInput = {
  /** List of product keys to filter by */
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Product slug to filter by */
  slug?: InputMaybe<Scalars['String']>;
  /** List of tags to filter by. Returns products matching ANY of the provided tags (OR condition) */
  tags?: InputMaybe<Array<InputMaybe<TagInput>>>;
};

export type ProductsPayload = {
  __typename?: 'ProductsPayload';
  pagination: PaginationData;
  products: Array<Product>;
};

/** Promo Discount information. */
export type PromoCodeDiscount = {
  __typename?: 'PromoCodeDiscount';
  /** the discount campaign amount (the percent off or the flat amount) */
  amount: Scalars['Int'];
  /** the amount that the promo code has discounted the order */
  discountAmount: Scalars['Int'];
  /** the discount id, which can be used to identify matching line_item_discounts */
  discountId: Scalars['UUID4'];
  /** how many line items this discounts applied to */
  lineItemCount: Scalars['Int'];
  promoCode: Scalars['String'];
  /** indicates if it's a percent or flat discount */
  type: DiscountType;
};

export type PurchaseQtyLimitData = {
  __typename?: 'PurchaseQtyLimitData';
  itemId: Scalars['UUID4'];
  purchaseQtyLimit: Scalars['Int'];
};

export type PurchaseQtyLimitLocalizations = {
  __typename?: 'PurchaseQtyLimitLocalizations';
  cartText: Scalars['String'];
};

export type PurchaseQtyLimitValidationError = ValidationError & {
  __typename?: 'PurchaseQtyLimitValidationError';
  details: Array<PurchaseQtyLimitData>;
  reason: Scalars['String'];
};

export enum QuantityDisplay {
  /** Cases — render a free-form text input for case count. */
  Case = 'CASE',
  /** Units — render a select input for units per pack. */
  Unit = 'UNIT'
}

export enum RegisterableType {
  Machine = 'MACHINE'
}

export type RegistrationInfo = {
  __typename?: 'RegistrationInfo';
  registerableType?: Maybe<RegisterableType>;
  registrable?: Maybe<Scalars['Boolean']>;
};

export type RegistrationRecord = {
  __typename?: 'RegistrationRecord';
  customData?: Maybe<Scalars['Json']>;
  emailOptIn?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID4'];
  insertedAt: Scalars['DateTime'];
  item: Item;
  itemId: Scalars['UUID4'];
  newUser: Scalars['Boolean'];
  order?: Maybe<SubmittedOrder>;
  orderId?: Maybe<Scalars['UUID4']>;
  purchaseDate?: Maybe<Scalars['Date']>;
  purchaseLocation: Scalars['String'];
  registeredAt: Scalars['DateTime'];
  source: Scalars['String'];
  status: StatusType;
  tenant: Tenant;
  tenantId: Scalars['UUID4'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['UUID4'];
  utmData?: Maybe<UtmData>;
  warrantyExpirationDate?: Maybe<Scalars['Date']>;
};

/**
 * Tax information split by sales tax and regulatory fees.
 *
 * This goes through each tax item and splits the taxes by imposition
 * type (sales tax, regulatory fees). The `total` field is the sum of
 * all the taxes for the given imposition type.
 */
export type RegulatoryTaxType = {
  __typename?: 'RegulatoryTaxType';
  /**
   * The imposition value.
   *
   * The is the string representation of the imposition type id. Such as
   * "General Sales Tax" or "Beverage Tax (Alcohol or Soft Drinks)".
   */
  code: Scalars['String'];
  /**
   * The imposition type id.
   *
   * Includes only Regulatory Fees.
   * Two regulator fees we care about specifically are:
   * - `35`: Beverage Tax (Alcohol or Soft Drinks)
   * - `61`: Beverage Container Fee
   */
  id: Scalars['String'];
  /** The total amount of taxes for the given imposition type. */
  total: Scalars['Int'];
};

export type ReplaceScheduledOrderHsppInput = {
  /** The complete component and item selection for the replacement HSPP. */
  hsppKitData: HsppKitDataInput;
  /** The HSPP Line Item to replace on the temporary Scheduled Order. */
  lineItemId: Scalars['UUID4'];
  /** The replacement HSPP quantity. */
  quantity: Scalars['Int'];
  /** The temporary Scheduled Order ID returned by createTempScheduledOrder. */
  scheduledOrderId: Scalars['UUID4'];
  /** The GTIN of the complete replacement HSPP variant. */
  variantGtin: Scalars['String'];
};

/**
 * Inputs for requesting Password Reset for a User.
 *
 * The `state` field is used to pass information back to the browser when
 * as User clicks on the password reset link in their email. The state is
 * included as a query string appended to the URL. The value of `state` can
 * be any string, as long as it is URL safe.
 *
 * The API does not inspect or manipulate the `state`, it is simply passed
 * to the password reset link.
 */
export type RequestPasswordResetForUserInput = {
  email: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};

export type RequestPasswordResetForUserPayload = {
  __typename?: 'RequestPasswordResetForUserPayload';
  email: Scalars['String'];
};

export type RequestUserVerificationInput = {
  email: Scalars['String'];
};

export type RequestUserVerificationPayload = {
  __typename?: 'RequestUserVerificationPayload';
  email?: Maybe<Scalars['String']>;
};

/**
 * The typed customization every Cart Item for a Product must carry. DatoCMS configures
 * the customizer at Product level, so the requirement applies to all of its Variants.
 *
 * `UNSUPPORTED` means DatoCMS configured a customizer this platform cannot map to a known
 * type. Such a Product cannot be carted at all, so clients should treat it the same as a
 * customization-required Product they have no customizer UI for.
 */
export enum RequiredCustomizationType {
  /** Gatorade Gx bottle */
  GatoradeBottle = 'GATORADE_BOTTLE',
  /** Gatorade squeeze bottle */
  GatoradeSqueezeBottle = 'GATORADE_SQUEEZE_BOTTLE',
  /** Gatorade stainless steel bottle */
  GatoradeStainlessSteel = 'GATORADE_STAINLESS_STEEL',
  /** Gatorade towel */
  GatoradeTowel = 'GATORADE_TOWEL',
  /** DatoCMS configured a customizer that could not be mapped to a known type */
  Unsupported = 'UNSUPPORTED'
}

export type ResendAccountActivationInput = {
  token: Scalars['String'];
};

export type ResendAccountActivationPayload = {
  __typename?: 'ResendAccountActivationPayload';
  success: Scalars['Boolean'];
};

export type ResetUserPasswordInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type RestockNotificationInput = {
  email: Scalars['String'];
  emailOptIn: Scalars['Boolean'];
  gtin: Scalars['String'];
};

export type RestrictedItemsByZipCodePayload = {
  __typename?: 'RestrictedItemsByZipCodePayload';
  restrictedItems: Array<Item>;
};

export type RetrievedAddress = {
  __typename?: 'RetrievedAddress';
  adminAreaCode?: Maybe<Scalars['String']>;
  adminAreaName?: Maybe<Scalars['String']>;
  block?: Maybe<Scalars['String']>;
  buildingName?: Maybe<Scalars['String']>;
  buildingNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  dataLevel?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  domesticId?: Maybe<Scalars['String']>;
  field1?: Maybe<Scalars['String']>;
  field2?: Maybe<Scalars['String']>;
  field3?: Maybe<Scalars['String']>;
  field4?: Maybe<Scalars['String']>;
  field5?: Maybe<Scalars['String']>;
  field6?: Maybe<Scalars['String']>;
  field7?: Maybe<Scalars['String']>;
  field8?: Maybe<Scalars['String']>;
  field9?: Maybe<Scalars['String']>;
  field10?: Maybe<Scalars['String']>;
  field11?: Maybe<Scalars['String']>;
  field12?: Maybe<Scalars['String']>;
  field13?: Maybe<Scalars['String']>;
  field14?: Maybe<Scalars['String']>;
  field15?: Maybe<Scalars['String']>;
  field16?: Maybe<Scalars['String']>;
  field17?: Maybe<Scalars['String']>;
  field18?: Maybe<Scalars['String']>;
  field19?: Maybe<Scalars['String']>;
  field20?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  languageAlternatives?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  line3?: Maybe<Scalars['String']>;
  line4?: Maybe<Scalars['String']>;
  line5?: Maybe<Scalars['String']>;
  neighbourhood?: Maybe<Scalars['String']>;
  poBoxNumber?: Maybe<Scalars['String']>;
  secondaryStreet?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  subBuilding?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type RetrievedItems = {
  __typename?: 'RetrievedItems';
  items?: Maybe<Array<RetrievedAddress>>;
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  acceptTermsAndConditions?: Maybe<User>;
  /**
   * Activates an account by resetting the user's password, setting marketing preferences,
   * and accepting terms and conditions.
   *
   * Mutation
   * ```
   * mutation AccountActivation($input: AccountActivationInput!) {
   *   accountActivation(input: $input) {
   *     id
   *     accepted_terms_at
   *   }
   * }
   * ```
   *
   * Variables
   * ```
   * {
   *   "input": {
   *     "token": "PASSWORD_RESET_TOKEN",
   *     "password": "MyNewPassword123!",
   *     "emailOptIn": true,
   *     "acceptedTerms": true
   *   }
   * }
   * ```
   */
  accountActivation: User;
  /**
   * Idempotently adds typed customizations to a cart.
   *
   * Returns an ordered list of customization IDs corresponding 1:1 with the input.
   * Calling with the same input multiple times always returns the same IDs.
   */
  addCartCustomizations?: Maybe<AddCartCustomizationsPayload>;
  /**
   * Add a unique cart item with customizations. This specifically handles items and kits with customizations.
   * Creates a new unique cart item that cannot be combined with other items of the same variant.
   */
  addCartItemUniqueVariant?: Maybe<Cart>;
  /**
   * Add a unique cart item with subscription and customizations.
   * This specifically handles items and kits with subscription and customizations.
   * Creates a new unique cart item that cannot be combined with other items of the same variant.
   */
  addCartItemUniqueVariantSubscription?: Maybe<Cart>;
  /**
   * Authorize and save a Gift Card to the checkout session
   *
   *   Example:
   *   ```
   *   mutation AddGiftCard($id: UUID4! $input: AddGiftCardInput!){
   *     addGiftCard(id: $id, input: $input){
   *       id
   *       giftCards {
   *         amount
   *         appliedAmount
   *         last4
   *         type
   *         giftCardId
   *       }
   *       price {
   *         total
   *       }
   *     }
   *   }
   *
   *   variables:
   *
   *   {
   *     "id": "session_id",
   *     "input": {
   *       "card_number": "5111111111111112345",
   *       "pin": "123456"
   *     }
   *   }
   *   ```
   *   Errors:
   *     giftCardNotFound
   *     noGiftCardBalanceAvailable
   *     giftCardMisMatch
   *     unableToApplyGiftCard
   *     sessionNotFound
   */
  addGiftCard?: Maybe<CheckoutSession>;
  addOrderSubscriptionItem?: Maybe<OrderSubscription>;
  /**
   * Add a unique variant to a subscription. The subscription must be temporary
   * (created via createTempSubscription). The variant must be subscribable.
   */
  addOrderSubscriptionUniqueVariant?: Maybe<OrderSubscription>;
  /**
   * Adds an Item variant to a temporary Scheduled Order edit session and returns the updated
   * temporary Scheduled Order for price refresh. Kit, Bundle, and HSPP variants are unsupported.
   * Pass the temporary Scheduled Order id returned by createTempScheduledOrder.
   */
  addScheduledOrderUniqueVariant?: Maybe<ScheduledOrder>;
  /**
   * Adjust a unique cart item by cart item ID. This specifically handles unique customized items.
   * It will update the quantity of an existing unique cart item based on the provided quantity.
   * If quantity is 0, the cart item will be removed.
   */
  adjustCartItemUniqueVariant?: Maybe<Cart>;
  /**
   * Adjust a cart item by variant GTIN. This specifically handles non-subscription items.
   * It will add a new cart item or update an existing one based on the provided quantity.
   * If quantity is 0, the cart item will be removed.
   */
  adjustCartItemVariant?: Maybe<Cart>;
  /**
   * Adjust a subscription cart item by variant GTIN. This specifically handles subscription items.
   * It will add a new subscription cart item or update an existing one based on the provided quantity and subscription interval.
   * If quantity is 0, the cart item will be removed.
   */
  adjustCartItemVariantSubscription?: Maybe<Cart>;
  /**
   * Adjust a subscription variant by subscription variant ID.
   * It will update the quantity of an existing subscription variant.
   * If quantity is 0, the subscription variant will be removed.
   */
  adjustOrderSubscriptionUniqueVariant?: Maybe<OrderSubscription>;
  /**
   * Adjusts or removes an Item or HSPP kit Line Item in a temporary Scheduled Order edit
   * session and returns the updated temporary Scheduled Order for price refresh. Operates on
   * an HSPP kit as a whole; use replaceScheduledOrderHspp to rebuild kit composition. Kit and
   * Bundle Line Items are unsupported. Use a quantity of 0 to remove the Line Item. Removing
   * the last remaining Line Item is rejected.
   * Pass the temporary Scheduled Order id returned by createTempScheduledOrder.
   */
  adjustScheduledOrderUniqueVariant?: Maybe<ScheduledOrder>;
  /**
   * Applies a discount to cart
   *
   * Example:
   * ```
   * mutation applyDiscount($id: UUID4!, $input: DiscountInput!){
   *   applyDiscount(id: $id, input: $input){
   *     id
   *   }
   * }
   *
   * variables:
   *
   * {"id": "session_id",
   *   "input": {"promo_code": "GATORADE15"}}
   * ```
   *
   * Errors:
   *   unableToSaveDiscount
   *   discountPromoCodeMissing
   *   discountPromoNotFound
   *   discountLimitExceeded
   *   discountPromoCodeRequiresEmail
   *   discountExceedsSubtotal
   *   discountPromoCodeNotApplicable
   */
  applyDiscount?: Maybe<CheckoutSession>;
  /**
   * Save the one of a user's existing saved shipping address to the checkout session
   *
   *   Errors:
   *     sessionNotFound
   *     addressNotFound
   */
  applySavedShippingAddress?: Maybe<CheckoutSession>;
  archiveRegistrationRecord?: Maybe<RegistrationRecord>;
  /**
   * Associates an anonymous Cart (a Cart without a `user_id`) to the current
   * authenticated User.
   */
  associateCartToUser?: Maybe<Cart>;
  /**
   * Cancels an eligible invoice order while it is still in credit review.
   *
   * Errors:
   *   notFound
   *   orderCancellationUnavailable
   */
  cancelOrder?: Maybe<SubmittedOrder>;
  /**
   * Cancels a scheduled order that is currently active or held for review.
   *
   * mutation cancelScheduledOrder($id: UUID4!, $input: CancelScheduledOrderInput!) {
   *   cancelScheduledOrder(id: $id, input: $input) {
   *     id
   *     status
   *     statusReasonValue
   *   }
   * }
   */
  cancelScheduledOrder?: Maybe<ScheduledOrder>;
  changeUserPassword?: Maybe<User>;
  createAccountAndRegistrationRecord?: Maybe<User>;
  /** Creates a new empty cart for the current user or guest. */
  createCart?: Maybe<Cart>;
  createDocumentUploadSignedUrls?: Maybe<DocumentUploadUrls>;
  /** Finds the user's existing cart or creates a new one, then sets the managed customer. */
  createManagedCustomerCart?: Maybe<Cart>;
  createPaymentClientToken: PaymentClientTokenPayload;
  createPaymentMethod: PaymentMethod;
  createRegistrationRecord?: Maybe<RegistrationRecord>;
  createSetupIntent: SetupIntent;
  /**
   * Create a tax exemption request.
   *
   * Example:
   * ```
   * mutation CreateTaxExemption($input: CreateTaxExemptionInput!) {
   *   createTaxExemption(input: $input) {
   *     id
   *   }
   * }
   * ```
   */
  createTaxExemption?: Maybe<TaxExemption>;
  /**
   * Creates an editable temporary copy of an active or held_for_review Scheduled Order.
   * The returned id identifies the temporary Scheduled Order.
   */
  createTempScheduledOrder?: Maybe<ScheduledOrder>;
  createTempSubscription?: Maybe<OrderSubscription>;
  /** create a cart using a submitted user order */
  createTemporaryCartFromOrder?: Maybe<Cart>;
  createUserAddress: Address;
  /** Removes all elements (cart_items) from a cart */
  deleteCart?: Maybe<Scalars['Boolean']>;
  deleteCreditCard: Scalars['String'];
  deleteUserAddress: Address;
  /**
   * This will calculate the price object using a partially filled address.
   * During ExpressCheckout, providers don't share the full address with us, but we can still calculate the price.
   * The FE needs to know the price before moving to the next step - we don't advance the stage to :review yet.
   */
  draftPriceForExpressCheckout?: Maybe<Price>;
  /**
   * Return a single gas exchange record with the due date extended.
   *
   * A default number of days is used
   * Example:
   * ```
   * mutation ExtendDueDate($input: ExtendDueDateInput!) {
   *   extendDueDate(input: $input) {
   *     id
   *     dueDate
   *
   * ```
   * Variables:
   * ```
   * {
   *   "input": {
   *     "id": "456a9e8a-c9ba-4ccb-91bf-420549c32566"
   *   }
   * ```)
   */
  extendDueDate?: Maybe<GasExchangeRecord>;
  /**
   * This will finalize the price object by moving the checkout session from `:checkout`
   * stage to `:review` stage. Once past the `:checkout` stage, the price will include
   * tax calculations.
   *
   *   Errors:
   *     unableToSetStage
   */
  finalizePrice?: Maybe<CheckoutSession>;
  loginUser?: Maybe<User>;
  loginUserWithAuthorizationCode?: Maybe<User>;
  loginUserWithJwt?: Maybe<User>;
  logoutUser?: Maybe<User>;
  /** Merge two carts */
  mergeCarts?: Maybe<Cart>;
  /**
   * Basic newsletter signup with optional first and last name.
   * The source id is static and is in the tenant config.
   */
  newsletterBasicSignup?: Maybe<Scalars['String']>;
  /**
   * Full newsletter signup with optional first and last name.
   * There is a default source id in the tenant config.
   */
  newsletterFullSignup?: Maybe<Scalars['String']>;
  /**
   * Allows for multiple potential inputs using the base
   * key in the input type to determine what they are
   * inquiring about. Follows the same pattern as the
   * engagement_signup mutation.
   */
  partnerInquiry?: Maybe<Scalars['String']>;
  /** Creates a cart from a temporary cart */
  persistTemporaryCart?: Maybe<Cart>;
  processOrderSubscriptionTomorrow?: Maybe<OrderSubscription>;
  processSubscriptionNow?: Maybe<OrderSubscription>;
  /**
   * Updates the price for a PayPal Express checkout order. Returns null
   * for successful calls.
   *
   * Example:
   * ```
   * mutation RecalculatePaypalExpressPrice($id: UUID4!, $input: PaypayPatchOrderInput!) {
   *   recalculatePaypalExpressPrice(id: $id, input: $input)
   * }
   * ```
   *
   * Errors:
   *   paymentGatewayError - if PayPal rejects the update
   */
  recalculatePaypalExpressPrice?: Maybe<Scalars['Json']>;
  /**
   * Retrieve a user's abandoned cart using an email hash string generated in
   *  an email by Salesforce.
   */
  recoverCart?: Maybe<Cart>;
  registerAiDesignByVariant?: Maybe<V3AiDesign>;
  /**
   * removes a discount from session
   *
   * Example:
   * ```
   * mutation removeDiscount($id: UUID4!){
   *   removeDiscount(id: $id){
   *     id
   *   }
   * }
   *
   * variables:
   *
   * {"id": "session_id"}
   * ```
   *
   * Errors:
   *   unableToRemoveDiscount
   */
  removeDiscount?: Maybe<CheckoutSession>;
  /**
   * Remove a Gift Card from a checkout session. This will cancel any authorizations.
   *
   *   Example:
   *   ```
   *   mutation removeGiftCard($id: UUID4!){
   *     removeGiftCard(id: $id){
   *       id
   *       giftCards {
   *         amount
   *         appliedAmount
   *         last4
   *         type
   *         giftCardId
   *       }
   *       price {
   *         total
   *       }
   *     }
   *   }
   *
   *   variables:
   *
   *   {"id": "session_id"}
   *   ```
   *   Errors:
   *     giftCardNotFound
   *     unableToApplyGiftCard
   *     sessionNotFound
   */
  removeGiftCard?: Maybe<CheckoutSession>;
  /**
   * removes gift_info from the session
   *
   * Example:
   * ```
   * mutation removeGiftInfo($id: UUID4!){
   *   removeGiftInfo(id: $id){
   *     id
   *   }
   * }
   *
   * variables:
   *
   * {"id": "session_id"}
   * ```
   *
   * Errors:
   *   giftingDisabled
   */
  removeGiftInfo?: Maybe<CheckoutSession>;
  removeOrderSubscriptionItem?: Maybe<OrderSubscription>;
  /**
   * Atomically replaces a complete HSPP Line Item in a temporary Scheduled Order edit session
   * and returns the updated temporary Scheduled Order for price refresh.
   * Pass the temporary Scheduled Order id returned by createTempScheduledOrder.
   */
  replaceScheduledOrderHspp?: Maybe<ScheduledOrder>;
  /**
   * Requests a Password Reset for a User with the email provided.
   *
   * Mutation
   * ```
   * mutation RequestPasswordResetForUser($input: RequestPasswordResetForUserInput!) {
   *   requestPasswordResetForUser(input: $input) {
   *     email
   *   }
   * }
   * ```
   *
   * Variables
   * ```
   * {
   *   "input": {
   *     "email": "user@example.com"
   *   }
   * }
   * ```
   */
  requestPasswordResetForUser?: Maybe<RequestPasswordResetForUserPayload>;
  requestUserVerification?: Maybe<RequestUserVerificationPayload>;
  resendAccountActivation?: Maybe<ResendAccountActivationPayload>;
  resetUserPassword?: Maybe<User>;
  /**
   * Used to get notified when an item is back in stock.
   * The source id is a combination of a static string in tenant config and the GTIN in the input.
   */
  restockNotification?: Maybe<Scalars['String']>;
  /**
   * Used for Remember Me Feature. Captures fields user enters and can be pre-filled if user
   *   returns to the page after leaving. Also once the user enters an email, we can use that to send
   *   a cart abandonment email if the user leaves and does not
   *   come back within a given time period.
   *
   *   Errors:
   *     unableToSaveEnteredContactInfo
   */
  saveEnteredContactInfo?: Maybe<CheckoutSession>;
  /**
   * Saves gift_info to the session
   *
   * Example:
   * ```
   * mutation saveGiftInfo($id: UUID4!, $input: GiftInfoInput!){
   *   saveGiftInfo(id: $id, input: $input){
   *     id
   *   }
   * }
   *
   * variables:
   *
   * {"id": "session_id",
   *   "input": {"giftee_message": "HELLO"}}
   * ```
   *
   * Errors:
   *   giftingDisabled
   */
  saveGiftInfo?: Maybe<CheckoutSession>;
  /** Save managed customer contact info during checkout */
  saveManagedCustomerContactInfo?: Maybe<CheckoutSession>;
  /** Save managed customer purchase options (sport and season) during checkout */
  saveManagedCustomerPurchaseOptions?: Maybe<CheckoutSession>;
  /**
   * Saves payment information to the checkout session
   *
   * Example:
   * ```
   * mutation savePayment($id: UUID4!, $input: SavePaymentInput!){
   *   savePayment(id: $id, input: $input){
   *     id
   *   }
   * }
   *
   * variables:
   *
   * {"id": "session_id",
   *   "input": {"paypal":
   *     {"paymentMethod": "PAYPAL"}}}
   * ```
   *
   * Errors:
   *   unableToSavePayment
   *   paymentDataError
   *   incompleteShippingAddress
   *   missingBillingAddress
   */
  savePayment?: Maybe<CheckoutSession>;
  /**
   * Save miscellaneous payment options to the checkout session
   *
   * Errors:
   *   sessionNotFound
   *   unableToSavePaymentOptions
   */
  savePaymentOptions?: Maybe<CheckoutSession>;
  /** Save the ATD sales rep name and email during checkout (ATD accounts only) */
  saveSalesRepInfo?: Maybe<CheckoutSession>;
  saveShippingMethod?: Maybe<CheckoutSession>;
  /**
   * Used to save miscellaneous optional entered during checkout process.
   *
   * Errors:
   *   sessionNotFound
   *   unableToSaveShippingOptions
   */
  saveShippingOptions?: Maybe<CheckoutSession>;
  /**
   * Used to save the suggested shipping address from the verifier on the checkout session
   *
   *   Errors:
   *     unableToSaveEnteredContactInfo
   */
  saveSuggestedAddress?: Maybe<CheckoutSession>;
  /**
   * Schedule the order for future processing.
   *
   * Errors:
   *   scheduledOrdersNotAllowed
   */
  scheduleOrder?: Maybe<ScheduledOrder>;
  /**
   * Sets or clears the managed customer on a cart.
   *
   * Pass `null` for managed_customer_id to clear the association.
   */
  setCartManagedCustomer?: Maybe<Cart>;
  /**
   * Create payment transaction for using on FE. On Stripe it's PaymentIntent object that has
   * payment intent secret FE can use for redirect to external system.
   *
   * Example:
   * ```
   * mutation setupTransaction($id: UUID4!){
   *   setupTransaction(id: $id){
   *     id
   *   }
   * }
   *
   * variables:
   *
   * {"id": "session_id"}
   * ```
   */
  setupTransaction?: Maybe<CheckoutSession>;
  /**
   * Transition from store front to checkout session.
   *
   * This will either create an order or return an existing order
   * for the given cart_id. The order will be returned as the
   * draft order in the checkout session.
   * Example:
   *
   * mutation shopToCheckout($cartId: UUID4!){
   *   shopToCheckout(cartId: $cartId){
   *     id
   *   }
   * }
   *
   * variables:
   * {"cartId": "cart_id"}
   *
   * Errors:
   *   sessionNotFound
   *   cartNotFound
   *   emptyCart
   */
  shopToCheckout?: Maybe<CheckoutSession>;
  signupUser?: Maybe<User>;
  skipOrderSubscription?: Maybe<OrderSubscription>;
  /**
   * SMS offer alerts signup.
   * When the user is not logged in, an email hash is required.
   */
  smsOfferAlerts?: Maybe<Scalars['String']>;
  /**
   * Used for product "drop" notifications.
   * The source id is passed in with the GraphQL request.
   */
  stockNotification?: Maybe<Scalars['String']>;
  /** Submit the order in one-shot to match the express checkout workflow. */
  submitExpressOrder?: Maybe<SubmittedOrder>;
  /**
   * Submit the order for processing.
   *
   * This will create a new order and return the order id.
   *
   * Errors:
   *   failedToCalculateTaxes
   *   userWithoutAccount
   *   guestCartContainsSubscription
   */
  submitOrder?: Maybe<SubmittedOrder>;
  /**
   * Applies a temporary Scheduled Order edit session to its source Scheduled Order.
   * Pass the temporary Scheduled Order id returned by createTempScheduledOrder. On success,
   * the temporary session is deleted and the updated source Scheduled Order is returned.
   */
  submitScheduledOrderChanges?: Maybe<ScheduledOrder>;
  submitSubscriptionChanges?: Maybe<OrderSubscription>;
  updateCreditCardDefault: CreditCard;
  /**
   * Update the quantity of an HSPP kit (hspp_kit) cart line item.
   * Quantity must be >= 1. Returns the updated cart with new quantity and updated line subtotal.
   * Use adjustCartItemUniqueVariant with quantity=0 to remove the item.
   * The cart will return a validation error (hspp_kit_yearly_maximum_reached) if the HSPP kit yearly allowance has been exceeded.
   */
  updateHsppCartItemQuantity?: Maybe<Cart>;
  updateOrderSubscription?: Maybe<OrderSubscription>;
  updateOrderSubscriptionAddress?: Maybe<OrderSubscription>;
  updateOrderSubscriptionItem?: Maybe<OrderSubscription>;
  updateOrderSubscriptionPayment?: Maybe<OrderSubscription>;
  updateOrderSubscriptionStatus?: Maybe<OrderSubscription>;
  /**
   * Updates non-item metadata on a temporary Scheduled Order edit session.
   * Pass the temporary Scheduled Order id returned by createTempScheduledOrder.
   */
  updateScheduledOrder?: Maybe<ScheduledOrder>;
  updateUserAddress: Address;
  updateUserAddressIsDefault: Address;
  /**
   * Updates user's first name and last name.
   *
   * Mutation
   * ```
   * mutation UpdateUserFirstLastName($input: UpdateUserFirstLastNameInput!) {
   *   updateUserFirstLastName(input: $input) {
   *     id
   *     first_name
   *     last_name
   *   }
   * }
   * ```
   *
   * Variables
   * ```
   * {
   *   "input": {
   *     "id": "UUID4",
   *     "first_name": "New"
   *     "last_name": "Updated"
   *   }
   * }
   * ```
   */
  updateUserFirstLastName?: Maybe<User>;
  updateUserPreferences: User;
  /**
   * mutation UserAddressVerification {
   *     userAddressVerification(
   *       input: {
   *         first_name: "",
   *         last_name: "",
   *         company: "",
   *         country_code: "",
   *         city: "",
   *         state: "",
   *         zip: "",
   *         line1: "",
   *         line2: ""
   *       }
   *     )
   *     {
   *       first_name,
   *       last_name,
   *       company,
   *       country_code,
   *       city,
   *       state,
   *       zip,
   *       line1,
   *       line2,
   *       success,
   *       errors{
   *         code,
   *         field,
   *         message,
   *         suggestion
   *       }
   *     }
   *   }
   */
  userAddressVerification?: Maybe<VerifyAddressPayload>;
  /**
   * Used to verify the address that has been stored for the checkout session
   *
   *   Errors:
   *     incompleteShippingAddress
   *     addressVerification
   *     checkoutAddressVerificationError
   *     unableToUsePOBox
   *     unableToSaveVerificationOnShippingAddress
   */
  verifyAddress?: Maybe<CheckoutSession>;
  verifyToken?: Maybe<VerifyTokenPayload>;
  verifyUser?: Maybe<User>;
};


export type RootMutationTypeAccountActivationArgs = {
  input: AccountActivationInput;
};


export type RootMutationTypeAddCartCustomizationsArgs = {
  cartId: Scalars['UUID4'];
  customizations: Array<CustomizationInput>;
};


export type RootMutationTypeAddCartItemUniqueVariantArgs = {
  cartId?: InputMaybe<Scalars['UUID4']>;
  input: AddCartItemUniqueVariantInput;
};


export type RootMutationTypeAddCartItemUniqueVariantSubscriptionArgs = {
  cartId?: InputMaybe<Scalars['UUID4']>;
  input: AddCartItemUniqueVariantSubscriptionInput;
};


export type RootMutationTypeAddGiftCardArgs = {
  id: Scalars['UUID4'];
  input: GiftCardInput;
};


export type RootMutationTypeAddOrderSubscriptionItemArgs = {
  id: Scalars['UUID4'];
  input: AddOrderSubscriptionItemInput;
};


export type RootMutationTypeAddOrderSubscriptionUniqueVariantArgs = {
  input: AddOrderSubscriptionUniqueVariantInput;
  subscriptionId: Scalars['UUID4'];
};


export type RootMutationTypeAddScheduledOrderUniqueVariantArgs = {
  input: AddScheduledOrderUniqueVariantInput;
};


export type RootMutationTypeAdjustCartItemUniqueVariantArgs = {
  cartId?: InputMaybe<Scalars['UUID4']>;
  input: AdjustCartItemUniqueVariantInput;
};


export type RootMutationTypeAdjustCartItemVariantArgs = {
  cartId?: InputMaybe<Scalars['UUID4']>;
  input: AdjustCartItemVariantInput;
};


export type RootMutationTypeAdjustCartItemVariantSubscriptionArgs = {
  cartId?: InputMaybe<Scalars['UUID4']>;
  input: AdjustCartItemVariantSubscriptionInput;
};


export type RootMutationTypeAdjustOrderSubscriptionUniqueVariantArgs = {
  input: AdjustOrderSubscriptionUniqueVariantInput;
};


export type RootMutationTypeAdjustScheduledOrderUniqueVariantArgs = {
  input: AdjustScheduledOrderUniqueVariantInput;
};


export type RootMutationTypeApplyDiscountArgs = {
  id: Scalars['UUID4'];
  input: DiscountInput;
};


export type RootMutationTypeApplySavedShippingAddressArgs = {
  additionalPhoneNumber?: InputMaybe<Scalars['String']>;
  addressId: Scalars['UUID4'];
  id: Scalars['UUID4'];
  specialInstructions?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeArchiveRegistrationRecordArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeAssociateCartToUserArgs = {
  cartId: Scalars['UUID4'];
};


export type RootMutationTypeCancelOrderArgs = {
  id: Scalars['UUID4'];
  input?: InputMaybe<CancelOrderInput>;
};


export type RootMutationTypeCancelScheduledOrderArgs = {
  id: Scalars['UUID4'];
  input: CancelScheduledOrderInput;
};


export type RootMutationTypeChangeUserPasswordArgs = {
  input: ChangeUserPasswordInput;
};


export type RootMutationTypeCreateAccountAndRegistrationRecordArgs = {
  registrationRecordInput: CreateRegistrationRecordInput;
  userInput: SignupUserInput;
};


export type RootMutationTypeCreateDocumentUploadSignedUrlsArgs = {
  types?: InputMaybe<Array<DocumentType>>;
};


export type RootMutationTypeCreateManagedCustomerCartArgs = {
  input: CreateManagedCustomerCartInput;
};


export type RootMutationTypeCreatePaymentMethodArgs = {
  input: CreatePaymentMethodInput;
};


export type RootMutationTypeCreateRegistrationRecordArgs = {
  input: CreateRegistrationRecordInput;
};


export type RootMutationTypeCreateTaxExemptionArgs = {
  input: CreateTaxExemptionInput;
};


export type RootMutationTypeCreateTempScheduledOrderArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeCreateTempSubscriptionArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeCreateTemporaryCartFromOrderArgs = {
  orderId: Scalars['UUID4'];
};


export type RootMutationTypeCreateUserAddressArgs = {
  input: UserAddressInput;
};


export type RootMutationTypeDeleteCartArgs = {
  cartId: Scalars['UUID4'];
};


export type RootMutationTypeDeleteCreditCardArgs = {
  input: DeleteCreditCardInput;
};


export type RootMutationTypeDeleteUserAddressArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeDraftPriceForExpressCheckoutArgs = {
  id: Scalars['UUID4'];
  input: ExpressCheckoutAddressInput;
};


export type RootMutationTypeExtendDueDateArgs = {
  input: ExtendDueDateInput;
};


export type RootMutationTypeFinalizePriceArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeLoginUserArgs = {
  input: LoginUserInput;
};


export type RootMutationTypeLoginUserWithAuthorizationCodeArgs = {
  input: LoginUserWithAuthorizationCodeInput;
};


export type RootMutationTypeLoginUserWithJwtArgs = {
  input: LoginUserWithJwtInput;
};


export type RootMutationTypeMergeCartsArgs = {
  destCartId: Scalars['UUID4'];
  srcCartId: Scalars['UUID4'];
};


export type RootMutationTypeNewsletterBasicSignupArgs = {
  input: NewsletterBasicSignupInput;
};


export type RootMutationTypeNewsletterFullSignupArgs = {
  input: NewsletterFullSignupInput;
};


export type RootMutationTypePartnerInquiryArgs = {
  input: PartnerInquiryInput;
};


export type RootMutationTypePersistTemporaryCartArgs = {
  srcCartId: Scalars['UUID4'];
};


export type RootMutationTypeProcessOrderSubscriptionTomorrowArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeProcessSubscriptionNowArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeRecalculatePaypalExpressPriceArgs = {
  id: Scalars['UUID4'];
  input: PaypalOrderPatchInput;
};


export type RootMutationTypeRecoverCartArgs = {
  emailHash: Scalars['String'];
};


export type RootMutationTypeRegisterAiDesignByVariantArgs = {
  colors?: InputMaybe<Array<V3AiDesignColorInput>>;
  featuredWeight?: InputMaybe<Scalars['Int']>;
  generatedByTenant?: InputMaybe<Scalars['Boolean']>;
  imageUrls: Scalars['Json'];
  promptAiEnhanced?: InputMaybe<Scalars['String']>;
  promptUser?: InputMaybe<Scalars['String']>;
  traits?: InputMaybe<Array<V3AiDesignTraitInput>>;
  variantGtin: Scalars['String'];
};


export type RootMutationTypeRemoveDiscountArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeRemoveGiftCardArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeRemoveGiftInfoArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeRemoveOrderSubscriptionItemArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeReplaceScheduledOrderHsppArgs = {
  input: ReplaceScheduledOrderHsppInput;
};


export type RootMutationTypeRequestPasswordResetForUserArgs = {
  input: RequestPasswordResetForUserInput;
};


export type RootMutationTypeRequestUserVerificationArgs = {
  input: RequestUserVerificationInput;
};


export type RootMutationTypeResendAccountActivationArgs = {
  input: ResendAccountActivationInput;
};


export type RootMutationTypeResetUserPasswordArgs = {
  input: ResetUserPasswordInput;
};


export type RootMutationTypeRestockNotificationArgs = {
  input: RestockNotificationInput;
};


export type RootMutationTypeSaveEnteredContactInfoArgs = {
  id: Scalars['UUID4'];
  input: SaveEnteredContactInfoInput;
};


export type RootMutationTypeSaveGiftInfoArgs = {
  id: Scalars['UUID4'];
  input: GiftInfoInput;
};


export type RootMutationTypeSaveManagedCustomerContactInfoArgs = {
  id: Scalars['UUID4'];
  input: SaveManagedCustomerContactInfoInput;
};


export type RootMutationTypeSaveManagedCustomerPurchaseOptionsArgs = {
  id: Scalars['UUID4'];
  input: SaveManagedCustomerPurchaseOptionsInput;
};


export type RootMutationTypeSavePaymentArgs = {
  id: Scalars['UUID4'];
  input: SavePaymentInput;
};


export type RootMutationTypeSavePaymentOptionsArgs = {
  id: Scalars['UUID4'];
  input: SavePaymentOptionsInput;
};


export type RootMutationTypeSaveSalesRepInfoArgs = {
  id: Scalars['UUID4'];
  input: SaveSalesRepInfoInput;
};


export type RootMutationTypeSaveShippingMethodArgs = {
  id: Scalars['UUID4'];
  input: SaveShippingMethodInput;
};


export type RootMutationTypeSaveShippingOptionsArgs = {
  id: Scalars['UUID4'];
  input: SaveShippingOptionsInput;
};


export type RootMutationTypeSaveSuggestedAddressArgs = {
  id: Scalars['UUID4'];
  input: SaveSuggestedAddressInput;
};


export type RootMutationTypeScheduleOrderArgs = {
  id: Scalars['UUID4'];
  input: SubmitOrderInput;
};


export type RootMutationTypeSetCartManagedCustomerArgs = {
  cartId: Scalars['UUID4'];
  input: SetCartManagedCustomerInput;
};


export type RootMutationTypeSetupTransactionArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeShopToCheckoutArgs = {
  cartId: Scalars['UUID4'];
};


export type RootMutationTypeSignupUserArgs = {
  input: SignupUserInput;
};


export type RootMutationTypeSkipOrderSubscriptionArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeSmsOfferAlertsArgs = {
  input: SmsOfferAlertsInput;
};


export type RootMutationTypeStockNotificationArgs = {
  input: StockNotificationInput;
};


export type RootMutationTypeSubmitExpressOrderArgs = {
  id: Scalars['UUID4'];
  input: SubmitExpressOrderInput;
};


export type RootMutationTypeSubmitOrderArgs = {
  id: Scalars['UUID4'];
  input: SubmitOrderInput;
};


export type RootMutationTypeSubmitScheduledOrderChangesArgs = {
  id: Scalars['UUID4'];
  input: SubmitScheduledOrderChangesInput;
};


export type RootMutationTypeSubmitSubscriptionChangesArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeUpdateCreditCardDefaultArgs = {
  input: UpdateCreditCardDefaultInput;
};


export type RootMutationTypeUpdateHsppCartItemQuantityArgs = {
  cartId: Scalars['UUID4'];
  input: UpdateHsppCartItemQuantityInput;
};


export type RootMutationTypeUpdateOrderSubscriptionArgs = {
  id: Scalars['UUID4'];
  input: UpdateOrderSubscriptionInput;
};


export type RootMutationTypeUpdateOrderSubscriptionAddressArgs = {
  id: Scalars['UUID4'];
  input: UpdateOrderSubscriptionAddressInput;
};


export type RootMutationTypeUpdateOrderSubscriptionItemArgs = {
  id: Scalars['UUID4'];
  input: UpdateOrderSubscriptionItemInput;
};


export type RootMutationTypeUpdateOrderSubscriptionPaymentArgs = {
  id: Scalars['UUID4'];
  input: UpdateOrderSubscriptionPaymentInput;
};


export type RootMutationTypeUpdateOrderSubscriptionStatusArgs = {
  id: Scalars['UUID4'];
  input: UpdateOrderSubscriptionStatusInput;
};


export type RootMutationTypeUpdateScheduledOrderArgs = {
  id: Scalars['UUID4'];
  input: UpdateScheduledOrderInput;
};


export type RootMutationTypeUpdateUserAddressArgs = {
  id: Scalars['UUID4'];
  input: UserAddressUpdateInput;
};


export type RootMutationTypeUpdateUserAddressIsDefaultArgs = {
  id: Scalars['UUID4'];
  input: UserAddressIsDefaultInput;
};


export type RootMutationTypeUpdateUserFirstLastNameArgs = {
  input: UpdateUserFirstLastNameInput;
};


export type RootMutationTypeUpdateUserPreferencesArgs = {
  input: UserPreferencesInput;
};


export type RootMutationTypeUserAddressVerificationArgs = {
  input: VerifyAddressInput;
};


export type RootMutationTypeVerifyAddressArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeVerifyTokenArgs = {
  token: Scalars['String'];
  tokenType: TokenType;
};


export type RootMutationTypeVerifyUserArgs = {
  input: VerifyUserInput;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  accountType?: Maybe<AccountType>;
  /**
   * Gets the currently active account
   * Example:
   *   ```
   *   query {
   *     activeAccount {
   *       type
   *       credits {
   *         status
   *         type
   *         availableAmount
   *         spentAmount
   *         activeFrom
   *         activeUntil
   *       }
   *     }
   *   }
   *   ```
   */
  activeAccount?: Maybe<Account>;
  advancedVariantSearch?: Maybe<Array<Maybe<AdvancedVariantSearchResult>>>;
  aiDesigns?: Maybe<V3AiDesignResult>;
  /**
   * Returns canceled submitted and scheduled orders for the active account.
   * Canceled subscriptions are not included.
   */
  canceledOrders: CanceledOrderPayload;
  /** Retrieves a cart given an id */
  cart?: Maybe<Cart>;
  /** Retrieves specific customizations from a cart by their IDs. */
  cartCustomizations: Array<CustomizationOutput>;
  /**
   * Return an info about order processing statuses.
   * We moved finalization part from the job to the async webhooks for Stripe.
   * Before webhooks we used to finalize order in the job.
   * If webhooks called, it must move order to completed state or cancel it (due to payment failure).
   * We'll use this to check if order was processed only for Stripe orders, but even it's called for Braintree orders,
   * it will return the same result. We just don't need to call it for Braintree orders because they are processed synchronously
   * and don't have 2-steps payment process (3DSecure, P24 etc).
   * Example:
   *   ```
   *   query SubmittedOrderQueries {
   *     check_order_status(order_id: order_uuid, session_id: session_uuid) {
   *       order_status
   *       order_id
   *     }
   *   }
   *   ```
   */
  checkOrderStatus?: Maybe<CheckOrderStatus>;
  /** Retrieve Checkout Session */
  checkoutSession?: Maybe<CheckoutSession>;
  collections: Array<CollectionSummary>;
  /**
   * Gets the currently logged in user
   * Example:
   *   ```
   *   query {
   *     currentUser {
   *       emailuser_types
   *       firstName
   *       lastName
   *       creditCards {
   *         cardholderName
   *         billingAddress{
   *           firstName
   *           lastName
   *         }
   *       }
   *       addresses{
   *         line1
   *         line2
   *       }
   *     }
   *   }
   *   ```
   */
  currentUser?: Maybe<User>;
  /** Returns distinct tag values for a given key across all active variants */
  distinctTagValues: Array<Scalars['String']>;
  /**
   * Get address suggestions for easy user input
   * Example
   * ```
   * query FindAddress($input: FindAddressInput!) {
   *   findAddress(input: $input) {
   *     items {
   *       id
   *       value
   *       description
   *       type
   *       highlight
   *     }
   *   }
   * }
   *
   * {"input": {"text": "3110 Pepsi road", "limit": "10"}}
   * ```
   */
  findAddress?: Maybe<FoundItems>;
  /**
   * Return a single gas exchange record filtered by id
   * Example:
   * ```
   * query GasExchangeRecord($id: UUID4!) {
   *   gas_exchange_record(id: $id) {
   *     id
   *   }
   * }
   * ```
   */
  gasExchangeRecord?: Maybe<GasExchangeRecord>;
  /**
   * Return a list of gas exchange records, paginated, for the current user
   * Example:
   * ```
   * query GasExchangeQueries {
   *   gasExchangeRecords(
   *     opts: {
   *     pagination: {
   *       page: 1
   *       limit: 10
   *     },
   *     search: {
   *         status: ACTIVE
   *     }
   *     }) {
   *     gasExchangeRecords {
   *       id
   *       status
   *     }
   *   }
   * }
   * ```
   */
  gasExchangeRecords: GasExchangeRecordPayload;
  isAddressValidForTax?: Maybe<IsAddressValidForTaxPayload>;
  localization?: Maybe<Localization>;
  /**
   * Looks up a promo code and returns its redemption status.
   *
   * Given a valid promo code string, returns whether the code has been
   * `fullyRedeemed`. A code is considered fully redeemed when its usage
   * reaches its limit. Codes with no limit are never fully redeemed.
   *
   * If the code does not exist, returns an `"invalid_code"` error.
   *
   * This query does not require authentication. The tenant is resolved from
   * the request's `Host` header.
   *
   * ## Example
   *
   * **Request:**
   * ```graphql
   * query LookupPromoCode($code: String!) {
   *   lookupPromoCode(code: $code) {
   *     fullyRedeemed
   *   }
   * }
   * ```
   *
   * **Variables:**
   * ```json
   * { "code": "PROMO-ABC123" }
   * ```
   *
   * **Response (available code):**
   * ```json
   * { "data": { "lookupPromoCode": { "fullyRedeemed": false } } }
   * ```
   *
   * **Response (fully redeemed code):**
   * ```json
   * { "data": { "lookupPromoCode": { "fullyRedeemed": true } } }
   * ```
   *
   * **Response (invalid code):**
   * ```json
   * {
   *   "data": { "lookupPromoCode": null },
   *   "errors": [{ "message": "invalid_code", "path": ["lookupPromoCode"] }]
   * }
   * ```
   */
  lookupPromoCode?: Maybe<LookupPromoCodePayload>;
  /**
   * query getOrderSubscriptionForUser($id: UUID4!) {
   *   orderSubscription(id: $id) {
   *     id
   *     title
   *     intervalInDays
   *     orderSubscriptionItems {
   *       currentItem {
   *         id
   *       }
   *     }
   *   }
   * }
   */
  orderSubscription: OrderSubscription;
  /**
   * query getOrderSubscriptionStatusReasonValuesWithKeys {
   *   orderSubscriptionStatusReasonValuesWithKeys {
   *     label
   *     value
   *   }
   * }
   */
  orderSubscriptionStatusReasonValuesWithKeys: Array<OrderSubscriptionStatusReasonValueWithKey>;
  /**
   * query getAllOrderSubscriptionsForUser {
   *   orderSubscriptions {
   *     id
   *     title
   *     intervalInDays
   *     orderSubscriptionItems {
   *       currentItem {
   *         id
   *       }
   *     }
   *   }
   * }
   */
  orderSubscriptions: Array<OrderSubscription>;
  productCategories: Array<ProductCategory>;
  productCategory?: Maybe<ProductCategory>;
  productCategoryBySlug?: Maybe<ProductCategory>;
  /**
   * Returns a list of items forbidden from being sold in the given zip code.
   * If a list of upcs is given, it will check only those items, otherwise will check all items in the store.
   * Example:
   *   ```
   *   query RestrictedItemsByZipCode {
   *     restrictedItemsByZipCode(
   *       zip: "94545",
   *       upcs: ["2141212", "2142145432"]) {
   *       restrictedItems {
   *         id
   *       }
   *     }
   *   }
   *   ```
   */
  restrictedItemsByZipCode?: Maybe<RestrictedItemsByZipCodePayload>;
  /**
   * Retrieve an address with an id.
   *
   * Example
   * ```
   * query RetrieveAddress($id: String!) {
   *   retrieveAddress(id: $id) {
   *     items {
   *       id
   *       line1
   *       line2
   *       city
   *       state
   *       zip
   *       country
   *       subBuilding
   *     }
   *   }
   * }
   *
   * {"id": "id_12345678"}
   * ```
   */
  retrieveAddress?: Maybe<RetrievedItems>;
  /**
   * query getScheduledOrder($id: UUID4!) {
   *   scheduledOrder(id: $id) {
   *     id
   *     status
   *     requestedDeliveryDate
   *     insertedAt
   *   }
   * }
   */
  scheduledOrder?: Maybe<ScheduledOrder>;
  /**
   * Returns the out-of-stock delivery-window policy for a Buyer-owned Scheduled Order Edit
   * Session at the selected requested delivery date. Pass the edit-session id returned by
   * createTempScheduledOrder.
   */
  scheduledOrderEditOutOfStockPolicy?: Maybe<ScheduledOrderEditOutOfStockPolicy>;
  /**
   * query getScheduledOrderStatusReasonValuesWithKeys {
   *   scheduledOrderStatusReasonValuesWithKeys {
   *     label
   *     value
   *   }
   * }
   */
  scheduledOrderStatusReasonValuesWithKeys: Array<ScheduledOrderStatusReasonValueWithKey>;
  scheduledOrders?: Maybe<ScheduledOrderPayload>;
  searchManagedCustomers: ManagedCustomersPayload;
  /**
   * Return a list of paginated products
   *
   * Example:
   * ```
   * query SearchProducts($search: ProductSearchInput!, $pagination: PaginationInput!) {
   *   searchProducts(
   *     pagination: {
   *       page: 1
   *       limit: 10
   *     },
   *     search: {
   *       source_id: DATO_ID
   *       source_type: dato_cms
   *     }
   *   ) {
   *     products {
   *       id
   *     }
   *     pagination {
   *       total
   *       page
   *       count
   *       totalPages
   *     }
   *   }
   * }
   * ```
   */
  searchProducts: ProductsPayload;
  /**
   * Return a list of paginated variants
   *
   * Example:
   * ```
   * query SearchVariants($search: VariantSearchInput!, $pagination: PaginationInput!) {
   *   searchVariants(
   *     pagination: {
   *       page: 1
   *       limit: 10
   *     },
   *     search: {
   *       gtin: GTIN
   *     }
   *   ) {
   *     variants {
   *       id
   *     }
   *     pagination {
   *       total
   *       page
   *       count
   *       totalPages
   *     }
   *   }
   * }
   * ```
   */
  searchVariants: VariantsPayload;
  /**
   * Return a single submitted order filtered by id
   * Example:
   *   ```
   *   query SubmittedOrderQueries {
   *     submitted_order(order_id: order_uuid) {
   *       id
   *     }
   *   }
   *   ```
   */
  submittedOrder?: Maybe<SubmittedOrder>;
  submittedOrders?: Maybe<SubmittedOrderPayload>;
  /**
   * query getSubscribableItems {
   *   subscribableItems {
   *     id
   *     title
   *     description
   *     base_price
   *   }
   * }
   */
  subscribableItems: Array<Item>;
  /**
   * Returns a Buyer-owned temporary Scheduled Order. Unlike scheduledOrder, this can
   * resolve the temporary copy created by createTempScheduledOrder (and mutated by the
   * HSPP Kit Planner), so the editor can re-adopt an in-progress edit instead of
   * rebuilding from the source order. Resolves to null when the temp order has expired.
   *
   * query getTempScheduledOrder($id: UUID4!) {
   *   tempScheduledOrder(id: $id) {
   *     id
   *     status
   *     requestedDeliveryDate
   *   }
   * }
   */
  tempScheduledOrder?: Maybe<ScheduledOrder>;
  /**
   * Return the `Tenant` associated with the domain of the site making the request
   * Example:
   *   ```
   *     query {
   *       tenant {
   *         id
   *         domain
   *         fallbackUrl
   *       }
   *     }
   *   ```
   */
  tenant?: Maybe<Tenant>;
  /**
   * Get all tax exemptions for the current user.
   *
   * Example:
   * ```
   * query {
   *   userTaxExemptions {
   *     id
   *     company
   *     firstName
   *     lastName
   *     email
   *     phone
   *     status
   *     taxExemptExpirationDate
   *     specialConsiderations
   *     taxExemptionRequestAddress {
   *       addressLine1
   *       addressLine2
   *       city
   *       state
   *       zip
   *     }
   *     taxDocuments {
   *       id
   *       fileName
   *       documentUrl
   *       contentType
   *       antivirusStatus
   *       createdAt
   *     }
   *   }
   * }
   * ```
   */
  userTaxExemptions?: Maybe<Array<Maybe<TaxExemption>>>;
  /**
   * Validates if the given password meets the minimum complexity requirements.
   *
   * Example:
   *   ```
   *   query validatePassword($password: String!) {
   *     validatePassword(password: $password) {
   *       msg
   *       satisfied
   *     }
   *   }
   *   ```
   *   Variables:
   *
   *   ```
   *   {"password": "$123ASDsarasa"}
   *   ```
   */
  validatePassword: Array<PasswordRequirement>;
};


export type RootQueryTypeAccountTypeArgs = {
  key: Scalars['String'];
};


export type RootQueryTypeAdvancedVariantSearchArgs = {
  facetFilters?: InputMaybe<Array<Array<Scalars['String']>>>;
  term: Scalars['String'];
};


export type RootQueryTypeAiDesignsArgs = {
  filters?: InputMaybe<V3AiDesignFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sorting?: InputMaybe<V3AiDesignSortingInput>;
};


export type RootQueryTypeCanceledOrdersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeCartArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeCartCustomizationsArgs = {
  cartId: Scalars['UUID4'];
  ids: Array<Scalars['UUID4']>;
};


export type RootQueryTypeCheckOrderStatusArgs = {
  cartId: Scalars['UUID4'];
};


export type RootQueryTypeCheckoutSessionArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeCollectionsArgs = {
  includeEmpty?: InputMaybe<Scalars['Boolean']>;
};


export type RootQueryTypeDistinctTagValuesArgs = {
  key: Scalars['String'];
};


export type RootQueryTypeFindAddressArgs = {
  input: FindAddressInput;
};


export type RootQueryTypeGasExchangeRecordArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeGasExchangeRecordsArgs = {
  opts?: InputMaybe<OptsInput>;
};


export type RootQueryTypeIsAddressValidForTaxArgs = {
  input: IsAddressValidForTaxInput;
};


export type RootQueryTypeLookupPromoCodeArgs = {
  code: Scalars['String'];
};


export type RootQueryTypeOrderSubscriptionArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeProductCategoryArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeProductCategoryBySlugArgs = {
  slug: Scalars['String'];
};


export type RootQueryTypeRestrictedItemsByZipCodeArgs = {
  upcs?: InputMaybe<Array<Scalars['String']>>;
  zip: Scalars['String'];
};


export type RootQueryTypeRetrieveAddressArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeScheduledOrderArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeScheduledOrderEditOutOfStockPolicyArgs = {
  id: Scalars['UUID4'];
  requestedDeliveryDate: Scalars['Date'];
};


export type RootQueryTypeScheduledOrdersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<ScheduledOrderSearchInput>;
  status?: InputMaybe<ScheduledOrderStatusFilter>;
};


export type RootQueryTypeSearchManagedCustomersArgs = {
  input: ManagedCustomerSearchInput;
};


export type RootQueryTypeSearchProductsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<ProductSearchInput>;
};


export type RootQueryTypeSearchVariantsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<VariantSearchInput>;
};


export type RootQueryTypeSubmittedOrderArgs = {
  email?: InputMaybe<Scalars['String']>;
  orderId: Scalars['UUID4'];
};


export type RootQueryTypeSubmittedOrdersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  reorderable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeTempScheduledOrderArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeValidatePasswordArgs = {
  password: Scalars['String'];
};

/** ATD sales rep info captured during checkout (sales rep belongs to the ATD account) */
export type SalesRepInfo = {
  __typename?: 'SalesRepInfo';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type SaveEnteredContactInfoInput = {
  email?: InputMaybe<Scalars['String']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  nflDataSharingConsent?: InputMaybe<Scalars['Boolean']>;
  nflMarketingConsent?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneExtension?: InputMaybe<Scalars['String']>;
  /** please include all shipping inputed fields becauses the shipping update is an overwrite */
  shipping?: InputMaybe<SaveEnteredContactInfoShippingAddressInput>;
};

export type SaveEnteredContactInfoShippingAddressInput = {
  /** This field indicates whether this address has a loading dock and accepts LTL (less than truckload) shipments. */
  acceptsLtl?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  isAddressValidated?: InputMaybe<Scalars['Boolean']>;
  /** When true, marks this address as the default shipping address */
  isDefault?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  /** pseudonym for address */
  nickname?: InputMaybe<Scalars['String']>;
  /** When true, saves this address to the user's account after checkout */
  saveForUserAccount?: InputMaybe<Scalars['Boolean']>;
  /** notes left for the shipper to be able to properly deliver the package */
  specialInstructions?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** Input for saving managed customer contact info during checkout */
export type SaveManagedCustomerContactInfoInput = {
  /** Comma-separated list of additional email addresses */
  additionalEmails?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  /** Optional phone extension (numeric, max 10 digits) */
  phoneExtension?: InputMaybe<Scalars['String']>;
  /** Special delivery instructions for the address */
  specialInstructions?: InputMaybe<Scalars['String']>;
  title: ManagedCustomerTitle;
};

/** Input for saving managed customer purchase options during checkout */
export type SaveManagedCustomerPurchaseOptionsInput = {
  season: ManagedCustomerSeason;
  sportKey: Scalars['String'];
};

/** Uses custom oneOf directive. Input is one of the following fields. */
export type SavePaymentInput = {
  allocatedCredit?: InputMaybe<AllocatedCreditInput>;
  applePay?: InputMaybe<ApplePayInput>;
  creditCard?: InputMaybe<CreditCardInput>;
  freeOfCharge?: InputMaybe<FreeOfChargeInput>;
  invoice?: InputMaybe<InvoiceInput>;
  paypal?: InputMaybe<PaypalInput>;
  savedCreditCard?: InputMaybe<SavedCreditCardInput>;
  splitPayment?: InputMaybe<SplitPaymentInput>;
  stripe?: InputMaybe<StripeInput>;
};

export type SavePaymentOptionsInput = {
  /** Field size should not exceed 25 characters */
  customerPo?: InputMaybe<Scalars['String']>;
  /** Field size should not exceed 25 characters */
  managedCustomerPo?: InputMaybe<Scalars['String']>;
};

/** Input for saving the ATD sales rep name and email during checkout. Both optional. */
export type SaveSalesRepInfoInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type SaveShippingMethodInput = {
  code: Scalars['String'];
  shippingMethodId: Scalars['UUID4'];
  title: Scalars['String'];
};

export type SaveShippingOptionsInput = {
  requestedDeliveryDate?: InputMaybe<Scalars['Date']>;
};

/** Input for mutation to update the shipping address on the checkout session.  Address fields required for an address are all required */
export type SaveSuggestedAddressInput = {
  city: Scalars['String'];
  countryCode: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

/** Input for mutation to save credit card payment information */
export type SavedCreditCardInput = {
  billingAddress: BillingAddressInput;
  token: Scalars['String'];
};

/**
 * An address available for selection as a shipping address.
 *
 * This should be all available shipping addresses for a user
 * or account.
 */
export type SavedShippingAddress = {
  __typename?: 'SavedShippingAddress';
  /** This field indicates whether this address has a loading dock and accepts LTL (less than truckload) shipments. */
  acceptsLtl: Scalars['Boolean'];
  /** this is the id found in the struct apiV1.Addresses.Address */
  addressId: Scalars['UUID4'];
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['String']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  phoneExtension?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  validated: Scalars['Boolean'];
  zip: Scalars['String'];
};

export type ScheduledOrder = {
  __typename?: 'ScheduledOrder';
  appId?: Maybe<Scalars['UUID4']>;
  /** Whether the authenticated Buyer may cancel this scheduled order. True only when the Buyer owns the order and status is active or held_for_review. */
  canCancel: Scalars['Boolean'];
  /** Whether the authenticated Buyer may edit this scheduled order. True only when the Buyer owns the order and status is active or held_for_review. */
  canEdit: Scalars['Boolean'];
  cart?: Maybe<Cart>;
  cartId?: Maybe<Scalars['UUID4']>;
  contactInfo?: Maybe<ContactInfo>;
  customerPo?: Maybe<Scalars['String']>;
  defaultBillToAddress?: Maybe<InvoicedAddress>;
  /** Maximum delivery offset in business days. Always 365 for a scheduled order, since it has already been accepted as one — tenant max delivery window does not apply. */
  deliveryMaxOffsetInDays: Scalars['Int'];
  /** Minimum delivery offset in business days, derived from the tenant's non-contiguous minimum when the scheduled order's shipping address or managed customer is in AK/HI, the tenant's standard minimum otherwise. */
  deliveryMinOffsetInDays: Scalars['Int'];
  /** The out-of-stock delivery-window policy for this Scheduled Order Edit Session's current requested delivery date. Null for a Scheduled Order that is not an Edit Session. */
  editOutOfStockPolicy?: Maybe<ScheduledOrderEditOutOfStockPolicy>;
  id: Scalars['UUID4'];
  insertedAt?: Maybe<Scalars['DateTime']>;
  itemCustomizationStatus: ItemCustomizationsStatus;
  managedCustomer?: Maybe<ManagedCustomer>;
  managedCustomerData?: Maybe<ManagedCustomerData>;
  /** Maximum allowed requested delivery date for this scheduled order's cart. Dec 31 of the current year for a high school managed customer with an HSPP kit; approximately one year out otherwise. */
  maxRequestedDeliveryDate?: Maybe<Scalars['Date']>;
  orderMessages: Array<OrderMessage>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentRequest?: Maybe<PaymentRequest>;
  price: Price;
  requestedDeliveryDate?: Maybe<Scalars['Date']>;
  salesRepInfo?: Maybe<SalesRepInfo>;
  shippingAddress?: Maybe<ShippingAddress>;
  status: Scalars['String'];
  statusReason?: Maybe<Scalars['String']>;
  statusReasonValue?: Maybe<ScheduledOrderStatusReasonValues>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ScheduledOrderContactInfoInput = {
  /** Phone number to store on the temporary Scheduled Order shipping snapshot. */
  phone?: InputMaybe<Scalars['String']>;
  /** Phone extension to store on the temporary Scheduled Order shipping snapshot. */
  phoneExtension?: InputMaybe<Scalars['String']>;
  /** Shipping snapshot fields to update on the temporary Scheduled Order. */
  shippingAddress?: InputMaybe<ScheduledOrderShippingAddressInput>;
};

export type ScheduledOrderEditOutOfStockPolicy = {
  __typename?: 'ScheduledOrderEditOutOfStockPolicy';
  /** Whether the selected requested delivery date falls inside the reminder window, where out-of-stock Line Items would block the edit. This does not read current inventory - the cart may be fully in stock. */
  blocksOutOfStockItems: Scalars['Boolean'];
  /** The earliest selectable requested delivery date on which out-of-stock Line Items do not block the edit. Null when that date is beyond the maximum selectable date. */
  firstNonblockingRequestedDeliveryDate?: Maybe<Scalars['Date']>;
};

export type ScheduledOrderOutOfStockLocalizations = {
  __typename?: 'ScheduledOrderOutOfStockLocalizations';
  cartText: Scalars['String'];
};

/**
 * Informational, non-blocking: the cart contains out-of-stock items, but the
 * requested delivery date makes this a scheduled order, so availability is
 * determined closer to that date and the order can still be placed. Emitted in
 * place of `InventoryValidationError`/`VariantOutOfStockValidationError`, which
 * are skipped for scheduled orders.
 */
export type ScheduledOrderOutOfStockValidationError = ValidationError & {
  __typename?: 'ScheduledOrderOutOfStockValidationError';
  reason: Scalars['String'];
};

export type ScheduledOrderPayload = {
  __typename?: 'ScheduledOrderPayload';
  pagination: PaginationData;
  scheduledOrders: Array<ScheduledOrder>;
};

export type ScheduledOrderSearchInput = {
  /** Filter scheduled orders created on or after this date. */
  dateFrom?: InputMaybe<Scalars['Date']>;
  /** Filter scheduled orders created on or before this date. */
  dateTo?: InputMaybe<Scalars['Date']>;
  /** Filter scheduled orders by managed customer name or city keyword. */
  managedCustomerKeyword?: InputMaybe<Scalars['String']>;
  /** Filter scheduled orders by order ID, ATD or high-school PO number, shipping company, or shipping city. */
  orderKeyword?: InputMaybe<Scalars['String']>;
  /** Filter scheduled orders by ATD or high-school PO number. */
  poNumber?: InputMaybe<Scalars['String']>;
  /** Filter scheduled orders by user email, first name, or last name keyword. */
  userKeyword?: InputMaybe<Scalars['String']>;
};

export type ScheduledOrderShippingAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export enum ScheduledOrderStatusFilter {
  Canceled = 'CANCELED',
  Scheduled = 'SCHEDULED'
}

export type ScheduledOrderStatusReasonValueWithKey = {
  __typename?: 'ScheduledOrderStatusReasonValueWithKey';
  label: Scalars['String'];
  value: ScheduledOrderStatusReasonValues;
};

export enum ScheduledOrderStatusReasonValues {
  AdminInitiatedCancel = 'ADMIN_INITIATED_CANCEL',
  BudgetChange = 'BUDGET_CHANGE',
  DuplicateOrder = 'DUPLICATE_ORDER',
  EventCancelledOrPostponed = 'EVENT_CANCELLED_OR_POSTPONED',
  ItemsUnavailable = 'ITEMS_UNAVAILABLE',
  NoLongerNeeded = 'NO_LONGER_NEEDED',
  Other = 'OTHER',
  SwitchingSuppliers = 'SWITCHING_SUPPLIERS',
  UserInitiatedCancel = 'USER_INITIATED_CANCEL'
}

export type SearchInput = {
  status?: InputMaybe<GasExchangeRecordsStatus>;
};

/**
 * The stage of the session.
 *
 * * `:checkout`
 *   - The session is in the checkout stage. The user is
 *     currently filling out the checkout form and has not
 *     yet reached the review stage.
 * * `:review`
 *   - The session is in the review stage. The user has
 *     completely filled out the checkout form and is currently
 *     reviewing their order before submitting it.
 * * `:submission`
 *   - The session is in the submission stage. The user
 *     has submitted their checkout session which will
 *     be used to create a submitted order. It will soon
 *     move to completed or be reverted to review
 * * `:payment`
 *   - The session is in the payment stage. The user
 *     has submitted order, we already create draft submitted order and
 *     want to process payment on client. Depending on results we'll finalize
 *     process and will go to completed stage or we'll need to restart
 *     checkout process. Session is still alive and accessible.
 * * `:completed`
 *   - The session is completed. It will shortly be archived.
 */
export enum SessionStage {
  Checkout = 'CHECKOUT',
  Completed = 'COMPLETED',
  Payment = 'PAYMENT',
  Review = 'REVIEW',
  Submission = 'SUBMISSION'
}

export type SetCartManagedCustomerInput = {
  /** The ID of the managed customer to associate, or null */
  managedCustomerId?: InputMaybe<Scalars['UUID4']>;
};

export type SetupIntent = {
  __typename?: 'SetupIntent';
  clientSecret: Scalars['String'];
};

/** Shipping address used during checkout, fields do not get saved all at once */
export type ShippingAddress = {
  __typename?: 'ShippingAddress';
  /** This field indicates whether this address has a loading dock and accepts LTL (less than truckload) shipments. */
  acceptsLtl?: Maybe<Scalars['Boolean']>;
  addressId?: Maybe<Scalars['UUID4']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  isAddressValidated?: Maybe<Scalars['Boolean']>;
  /** When true, marks this address as the default shipping address */
  isDefault?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  phoneExtension?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  /** When true, saves this address to the user's account after checkout */
  saveForUserAccount?: Maybe<Scalars['Boolean']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type ShippingAddressRestrictionItem = {
  __typename?: 'ShippingAddressRestrictionItem';
  /** Cart item that is restricted */
  cartItemId: Scalars['UUID4'];
  variantId: Scalars['UUID4'];
};

export type ShippingAddressRestrictionValidationError = ValidationError & {
  __typename?: 'ShippingAddressRestrictionValidationError';
  allowedVariantTypes: Array<Scalars['String']>;
  items: Array<ShippingAddressRestrictionItem>;
  /** Validation error when items or variants are restricted by shipping address */
  reason: Scalars['String'];
  /** List of cart items that are restricted */
  states: Array<Scalars['String']>;
};

export type ShippingAddressValidationError = ValidationError & {
  __typename?: 'ShippingAddressValidationError';
  countryStateMapping: Scalars['Json'];
  reason: Scalars['String'];
};

export type ShippingConfig = {
  __typename?: 'ShippingConfig';
  fixedFeeShipping?: Maybe<Scalars['Int']>;
  freeShippingQuantityThreshold?: Maybe<Scalars['Int']>;
  freeShippingThreshold?: Maybe<Scalars['Int']>;
  maxDeliveryWindowInDays?: Maybe<Scalars['Int']>;
  nonContiguousStateMaxOffsetInDays?: Maybe<Scalars['Int']>;
  nonContiguousStateMinOffsetInDays?: Maybe<Scalars['Int']>;
};

/**
 * Selectable shipping methods representing static and dynamically
 *   fetched shipping locations for the previously input shipping address
 */
export type ShippingMethod = {
  __typename?: 'ShippingMethod';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID4']>;
  locationDescription?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
  rateType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** Configuration values for available shipping methods */
export type ShippingMethodConfig = {
  __typename?: 'ShippingMethodConfig';
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  name: Scalars['String'];
  rate: Scalars['Int'];
  rateType: Scalars['String'];
};

export type ShoppingBagConfig = {
  __typename?: 'ShoppingBagConfig';
  availableSubscriptionIntervalsInDays: Array<Scalars['Int']>;
  editSubscriptionsEnabled: Scalars['Boolean'];
  maxAmountForSelect: Scalars['Int'];
  minimumAllocationEligibleQty?: Maybe<Scalars['Int']>;
  minimumPurchaseAmount: Scalars['Int'];
  minimumPurchaseQty: Scalars['Int'];
  orderSubscriptionsEnabled: Scalars['Boolean'];
  subscriptionIntervalsInDays: Array<Scalars['Int']>;
};

export type SignedUrl = {
  __typename?: 'SignedUrl';
  uploadParameters: Array<UploadParameter>;
  uploadUrl: Scalars['String'];
};

export enum SignupChannelType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type SignupUserInput = {
  activationCode?: InputMaybe<Scalars['String']>;
  activationCodeRequired?: InputMaybe<Scalars['Boolean']>;
  botProtectionToken?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<SignupChannelType>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  email: Scalars['String'];
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  /** this field will contain fields specific for engagement implementations */
  engagementCustomData?: InputMaybe<Scalars['Json']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  preferredLocale?: InputMaybe<Scalars['String']>;
  preferredTimezone?: InputMaybe<Scalars['String']>;
};

export type SmsOfferAlertsInput = {
  /** Required when user is not logged in */
  emailHash?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  sourceId: Scalars['String'];
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Split payment entry representing a portion of the total payment */
export type SplitEntry = {
  __typename?: 'SplitEntry';
  paymentData?: Maybe<SplitEntryPaymentData>;
  processor?: Maybe<SplitPaymentMethodType>;
};

/** Payment data for split entry (either Stripe or Allocation) */
export type SplitEntryPaymentData = AllocatedCreditPaymentData | StripePaymentData;

/** Entry for split payment - combines amount with any existing payment type. */
export type SplitPaymentEntryInput = {
  /** Payment details - uses existing save_payment_input one_of type */
  payment: SavePaymentInput;
};

/**
 * Input for split payment - allows multiple payment methods in one transaction.
 * Example: part credit card + part allocated credit.
 */
export type SplitPaymentInput = {
  entries: Array<SplitPaymentEntryInput>;
};

/** Payment method types for split payment options */
export enum SplitPaymentMethodType {
  AllocatedCredit = 'ALLOCATED_CREDIT',
  Stripe = 'STRIPE'
}

/** A sport option for managed customer */
export type Sport = {
  __typename?: 'Sport';
  gender?: Maybe<SportGender>;
  sportKey: Scalars['String'];
  sportName: Scalars['String'];
};

/** Gender category for sports */
export enum SportGender {
  /** Co-ed */
  Coed = 'COED',
  /** Female */
  Female = 'FEMALE',
  /** Male */
  Male = 'MALE'
}

export type StackedDiscountBehavior = {
  __typename?: 'StackedDiscountBehavior';
  name: BehaviourEnum;
};

export type StatesConfig = {
  __typename?: 'StatesConfig';
  countryId: Scalars['String'];
  statesAllowed: Array<AllowedState>;
};

export enum StatusLabels {
  /** Canceled */
  Canceled = 'CANCELED',
  /** Complete */
  Complete = 'COMPLETE',
  /** NoChange */
  NoChange = 'NO_CHANGE',
  /** Unknown */
  Unknown = 'UNKNOWN'
}

export enum StatusType {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type StockNotificationInput = {
  email: Scalars['String'];
  gtin: Scalars['String'];
  sourceId: Scalars['String'];
};

/**
 * Input for saving stripe payment info.
 * This info is save into Session.Payment object. Here is some explanation for what those tokens are:
 * session.payment.token - payment_intent_client_secret used to initiate paymentForm with valid elements(blik/p24/card).
 *                         generated on BE and saved to the session during the call setupTransaction mutation.
 * session.payment.client_confirmation_token - confirmation token generated on FE, it sticks to concrete user’s data
 *                                             on stripe and saved using savePayment mutation.
 * so, both these tokens/secrets are in session.payment object and we can use them on the review step to
 * call stripe.confirmPayment and be sure that we process most recent PaymentIntent with a data that belongs
 * to the user through the ConfirmationToken object.
 * More details: https://docs.stripe.com/js/payment_intents/confirm_payment
 */
export type StripeInput = {
  clientConfirmationToken?: InputMaybe<Scalars['String']>;
  isBillingEqualShipping: Scalars['Boolean'];
  paymentMethodType: Scalars['String'];
  saveCardForLater?: InputMaybe<Scalars['Boolean']>;
};

/** Stripe payment data for split payment entries */
export type StripePaymentData = {
  __typename?: 'StripePaymentData';
  billingAddress?: Maybe<BillingAddress>;
  clientConfirmationToken?: Maybe<Scalars['String']>;
  isBillingEqualShipping?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<PaymentInfoPaymentMethod>;
  token?: Maybe<Scalars['String']>;
};

export type SubStore = {
  __typename?: 'SubStore';
  id: Scalars['UUID4'];
  key: Scalars['String'];
  name: Scalars['String'];
  /** When false, the variant-level minimum quantity is not enforced for this sub-store (e.g., ATD sub-stores). Storefronts should use this to decide whether to apply the variant's minQuantity to the PDP quantity selector. */
  validateVariantsMinQuantity: Scalars['Boolean'];
};

export type SubmitExpressOrderInput = {
  billingAddress?: InputMaybe<BillingAddressInput>;
  contactInfo: SaveEnteredContactInfoInput;
  /** Stripe payment method type. Defaults to 'card'. Ignored for PayPal */
  paymentMethodType?: InputMaybe<Scalars['String']>;
  /** PayPal express checkout payment nonce. Mutally exclusive with Stripe */
  paypalNonce?: InputMaybe<Scalars['String']>;
  /** Stripe payment intent confirmation token from Stripe Elements. Mutually exclusive with PayPal */
  stripeConfirmationToken?: InputMaybe<Scalars['String']>;
};

export type SubmitOrderInput = {
  paymentNonce?: InputMaybe<Scalars['String']>;
  preferredTimezone?: InputMaybe<Scalars['String']>;
};

export type SubmitScheduledOrderChangesInput = {
  /** Requested delivery date to apply to the source Scheduled Order. Omit it to preserve the existing date. */
  requestedDeliveryDate?: InputMaybe<Scalars['Date']>;
};

/** Retrieve Submitted Order */
export type SubmittedOrder = {
  __typename?: 'SubmittedOrder';
  appId?: Maybe<Scalars['UUID4']>;
  bazaarvoice?: Maybe<Bazaarvoice>;
  canCancel: Scalars['Boolean'];
  /** The customer-facing cancellation category, or null when the order is not canceled. */
  cancellationCategory?: Maybe<OrderCancellationCategory>;
  cartId?: Maybe<Scalars['UUID4']>;
  /**
   * @deprecated The display_name field now represents the user visible order identifier/label
   * which is either explicitly set in the record or computed via the composite
   * order id logic. This obviates the need for the composite_id field.
   *
   */
  compositeId?: Maybe<Scalars['String']>;
  contactInfo: ContactInfo;
  currencyCode?: Maybe<Scalars['String']>;
  customerInfo: CustomerInfo;
  /** User's own internal id for the order */
  customerPo?: Maybe<Scalars['String']>;
  /** The default bill-to invoiced address for the account associated with this order. */
  defaultBillToAddress?: Maybe<InvoicedAddress>;
  /**
   * The display name represents the user visible order label which identifies
   * the order to an end-user. This is either explicitly set in the
   * display_name_override column on the order or is computed as a composite of
   * the purchase order id (if any) and the internal order id.
   */
  displayName?: Maybe<Scalars['String']>;
  fulfillments: Array<Fulfillment>;
  gifteeEmail?: Maybe<Scalars['String']>;
  gifteeMessage?: Maybe<Scalars['String']>;
  giftorName?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  /**
   * Some orders are managed or "owned" by a different system. These orders are
   * sometimes imported into this system for tracking and reporting purposes but
   * don't have active workflows or fulfillment processes hooked up. This allows
   * these orders to be displayed with special notices in the UI.
   */
  isExternalOrder?: Maybe<Scalars['Boolean']>;
  isGift?: Maybe<Scalars['Boolean']>;
  /** Indicates the customization status of items in the order: no customizations, some customizations, or all customizations. */
  itemCustomizationStatus: ItemCustomizationsStatus;
  lockerCode?: Maybe<Scalars['String']>;
  lockerTitle?: Maybe<Scalars['String']>;
  managedCustomer?: Maybe<ManagedCustomer>;
  managedCustomerData?: Maybe<ManagedCustomerData>;
  orderId: Scalars['UUID4'];
  orderMessages: Array<OrderMessage>;
  /** Full name of the person who placed the order. Helpful for identifying who placed the order in multi-user account scenarios. */
  orderPlacedBy?: Maybe<Scalars['String']>;
  orderSubscriptionRelationship: OrderSubscriptionRelationshipNames;
  orderType?: Maybe<SubmittedOrderType>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentRequest?: Maybe<PaymentRequest>;
  price: Price;
  requestedDeliveryDate?: Maybe<Scalars['String']>;
  salesRepInfo?: Maybe<SalesRepInfo>;
  shippingMethodConfig?: Maybe<ShippingMethodConfig>;
  shippingMethodPhone?: Maybe<Scalars['String']>;
  /** Raw order lifecycle status. Credit-declined orders return `credit_declined`; customer-facing clients should display that status as canceled. */
  status?: Maybe<Scalars['String']>;
  submissionUid: Scalars['UUID4'];
  submittedAt?: Maybe<Scalars['DateTime']>;
  taxId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID4']>;
};

export type SubmittedOrderPayload = {
  __typename?: 'SubmittedOrderPayload';
  pagination: PaginationData;
  submittedOrders: Array<SubmittedOrder>;
};

export enum SubmittedOrderType {
  External = 'EXTERNAL',
  FreeOfCharge = 'FREE_OF_CHARGE',
  Internal = 'INTERNAL',
  MissingGasExchangeCylinder = 'MISSING_GAS_EXCHANGE_CYLINDER',
  OrderOnBehalf = 'ORDER_ON_BEHALF',
  ScheduledOrder = 'SCHEDULED_ORDER',
  Shop = 'SHOP',
  Subscription = 'SUBSCRIPTION'
}

/** Subscription metadata on an item */
export type SubscriptionMetadata = {
  __typename?: 'SubscriptionMetadata';
  /** OBSOLETE — always returns null. subscription discounts are no longer supported */
  discountAmount?: Maybe<Scalars['Int']>;
  /** OBSOLETE — always returns null. subscription discounts are no longer supported */
  discountType?: Maybe<DiscountType>;
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
  subscriptionPrice?: Maybe<Scalars['Int']>;
};

export enum SubscriptionOption {
  Allowed = 'ALLOWED',
  None = 'NONE',
  Only = 'ONLY'
}

export type SubscriptionsNotAllowedData = {
  __typename?: 'SubscriptionsNotAllowedData';
  itemId: Scalars['UUID4'];
};

export type SubscriptionsNotAllowedLocalizations = {
  __typename?: 'SubscriptionsNotAllowedLocalizations';
  cartText: Scalars['String'];
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type SubscriptionsNotAllowedValidationError = ValidationError & {
  __typename?: 'SubscriptionsNotAllowedValidationError';
  details: Array<SubscriptionsNotAllowedData>;
  reason: Scalars['String'];
};

export type Tag = {
  __typename?: 'Tag';
  insertedAt: Scalars['DateTime'];
  key: Scalars['String'];
  product?: Maybe<Product>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
  variant?: Maybe<Variant>;
};

export type TagInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Tax document information */
export type TaxDocument = {
  __typename?: 'TaxDocument';
  antivirusStatus?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['NaiveDateTime']>;
  documentUrl?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

/** Tax exemption information */
export type TaxExemption = {
  __typename?: 'TaxExemption';
  company?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['NaiveDateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  specialConsiderations?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  taxDocuments?: Maybe<Array<Maybe<TaxDocument>>>;
  taxExemptExpirationDate?: Maybe<Scalars['Date']>;
  taxExemptionRequestAddress?: Maybe<TaxExemptionRequestAddress>;
  tenantId?: Maybe<Scalars['ID']>;
};

/** Address information for tax exemption requests */
export type TaxExemptionRequestAddress = {
  __typename?: 'TaxExemptionRequestAddress';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** Address information for tax exemption requests */
export type TaxExemptionRequestAddressInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type TaxItem = {
  __typename?: 'TaxItem';
  amount?: Maybe<Scalars['Int']>;
  calculatedTax?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  exempt?: Maybe<Scalars['Int']>;
  impositionTypeId?: Maybe<Scalars['String']>;
  impositionValue?: Maybe<Scalars['String']>;
  jurisdiction?: Maybe<Scalars['String']>;
  jurisdictionType?: Maybe<Scalars['String']>;
  taxRuleId?: Maybe<Scalars['String']>;
  unclaimedTaxes?: Maybe<Scalars['Int']>;
};

/**
 * Type representing a tenant entity in the PepDirect DB.
 * The fields listed represent what is tenant configurable
 * within the PepDirect platform. These values are not yet
 * editable outside of the codebase.
 */
export type Tenant = {
  __typename?: 'Tenant';
  accountsConfig: AccountsConfig;
  analyticsConfig: AnalyticsConfig;
  /** @deprecated Deprecated in favor of `id`. */
  appId: Scalars['UUID4'];
  botProtection: BotProtection;
  brandConfig: BrandConfig;
  capabilities: Capabilities;
  checkout?: Maybe<Checkout>;
  contactConfig: ContactConfig;
  countryCode: Scalars['String'];
  domain: Scalars['String'];
  /** @deprecated Deprecated in favor of `store_url`. */
  fallbackUrl: Scalars['String'];
  generalConfig: GeneralConfig;
  giftCardConfig: GiftCardConfig;
  giftConfig: GiftConfig;
  id: Scalars['UUID4'];
  loyaltyConfig: LoyaltyConfig;
  oktaConfig: OktaConfig;
  paymentConfig: PaymentConfig;
  runtimeFlags: TenantRuntimeFlags;
  shippingConfig: ShippingConfig;
  shoppingBagConfig: ShoppingBagConfig;
  storeUrl: Scalars['String'];
  userExperience: UserExperience;
};

export type TenantPaymentOptions = {
  __typename?: 'TenantPaymentOptions';
  defaultCurrencyCode: Scalars['String'];
  merchantAccountId?: Maybe<Scalars['String']>;
};

/**
 * A subset of per-tenant runtime feature flags exposed to the frontend.
 * These flags gate in-progress features during rollout. By default each
 * flag delegates to the corresponding `RuntimeFlags` value on the tenant.
 * A flag may be deprecated and hardcoded to `true` while the API field is
 * cleaned up, allowing frontend code to transition without a flag check change.
 */
export type TenantRuntimeFlags = {
  __typename?: 'TenantRuntimeFlags';
  allowScheduledOrders: Scalars['Boolean'];
  bulkUploadEnabled: Scalars['Boolean'];
  dataDogRumEnabled: Scalars['Boolean'];
  editHsppScheduledOrdersEnabled: Scalars['Boolean'];
  editScheduledOrdersEnabled: Scalars['Boolean'];
  productCategoriesEnabled: Scalars['Boolean'];
  reorderEnabled: Scalars['Boolean'];
  typedCustomizations: Scalars['Boolean'];
  variantSubscriptionsEnabled: Scalars['Boolean'];
};

export type TenantShippingOptions = {
  __typename?: 'TenantShippingOptions';
  shippingMethodsEnabled?: Maybe<Scalars['Boolean']>;
};

export type Tier = {
  __typename?: 'Tier';
  amount: Scalars['Int'];
  minQty: Scalars['Int'];
  type: TierType;
};

export enum TierType {
  /** The tier discounts a flat amount */
  Flat = 'FLAT',
  /** the tier dicounts a percentage amount */
  Percent = 'PERCENT'
}

export type TieredAttributes = {
  __typename?: 'TieredAttributes';
  applyToAllEligibleItems?: Maybe<Scalars['Boolean']>;
  tiers: Array<Tier>;
  useQuantityPerPack?: Maybe<Scalars['Boolean']>;
};

export type TieredBehaviour = {
  __typename?: 'TieredBehaviour';
  attributes: TieredAttributes;
  name: BehaviourEnum;
};

/** web tokens are encoded with a particular type to prevent cross usage */
export enum TokenType {
  PasswordReset = 'PASSWORD_RESET',
  UserVerification = 'USER_VERIFICATION'
}

export type TrackingNumber = {
  __typename?: 'TrackingNumber';
  carrierName?: Maybe<Scalars['String']>;
  status?: Maybe<TrackingStatusLabels>;
  trackingNumber?: Maybe<Scalars['String']>;
  trackingServiceUpdatedAt?: Maybe<Scalars['NaiveDateTime']>;
  trackingUrl?: Maybe<Scalars['String']>;
};

export enum TrackingStatusLabels {
  /** AVAILABLE_FOR_PICKUP */
  AvailableForPickup = 'AVAILABLE_FOR_PICKUP',
  /** CANCELLED */
  Cancelled = 'CANCELLED',
  /** COMPLETE */
  Complete = 'COMPLETE',
  /** DELIVERED */
  Delivered = 'DELIVERED',
  /** FAILURE */
  Failure = 'FAILURE',
  /** IN_TRANSIT */
  InTransit = 'IN_TRANSIT',
  /** OUT_FOR_DELIVERY */
  OutForDelivery = 'OUT_FOR_DELIVERY',
  /** PRE_TRANSIT */
  PreTransit = 'PRE_TRANSIT',
  /** RETURNED */
  Returned = 'RETURNED',
  /** RETURN_TO_SENDER */
  ReturnToSender = 'RETURN_TO_SENDER',
  /** TRANSIT */
  Transit = 'TRANSIT',
  /** UNKNOWN */
  Unknown = 'UNKNOWN'
}

export type UnstructuredProductCategoryProperties = {
  __typename?: 'UnstructuredProductCategoryProperties';
  value: Scalars['Json'];
};

export type UnverifiedEmailValidationError = ValidationError & {
  __typename?: 'UnverifiedEmailValidationError';
  details: Scalars['String'];
  reason: Scalars['String'];
};

export type UpdateCreditCardDefaultInput = {
  default: Scalars['Boolean'];
  token: Scalars['String'];
};

export type UpdateHsppCartItemQuantityInput = {
  /** The ID of the HSPP kit cart item to update */
  cartItemId: Scalars['UUID4'];
  /** The new quantity (must be >= 1; use remove_cart_item to delete) */
  newQuantity: Scalars['Int'];
};

export type UpdateOrderSubscriptionAddressInput = {
  addressId: Scalars['UUID4'];
};

export type UpdateOrderSubscriptionInput = {
  intervalInDays?: InputMaybe<Scalars['Int']>;
  nextOrderCreationDate?: InputMaybe<Scalars['Date']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateOrderSubscriptionItemInput = {
  quantity?: InputMaybe<Scalars['Int']>;
};

export type UpdateOrderSubscriptionPaymentInput = {
  paymentOptions: PaymentOptionsInput;
};

export type UpdateOrderSubscriptionStatusInput = {
  status: OrderSubscriptionStatusNames;
  /** This field is required if status_reason_value is OTHER */
  statusReason?: InputMaybe<Scalars['String']>;
  /** This field is required if status is PAUSED or CANCELED */
  statusReasonValue?: InputMaybe<OrderSubscriptionStatusReasonValues>;
};

export type UpdateScheduledOrderInput = {
  /** Contact and shipping snapshot fields to store on the temporary Scheduled Order. */
  contactInfo?: InputMaybe<ScheduledOrderContactInfoInput>;
  /** Buyer purchase order reference to store on the temporary Scheduled Order. */
  customerPo?: InputMaybe<Scalars['String']>;
};

/** Inputs for updating user's first and last name. */
export type UpdateUserFirstLastNameInput = {
  firstName: Scalars['String'];
  id: Scalars['UUID4'];
  lastName: Scalars['String'];
};

export type UploadParameter = {
  __typename?: 'UploadParameter';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  addresses: Array<Address>;
  appId: Scalars['UUID4'];
  cart?: Maybe<Cart>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  hashedEmail: Scalars['String'];
  hfName?: Maybe<Scalars['String']>;
  hlName?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  insertedAt: Scalars['DateTime'];
  isVerified: Scalars['Boolean'];
  lastLoggedIn?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  orderMessages: Array<OrderMessage>;
  paymentMethods?: Maybe<PaymentMethods>;
  preferredLocale?: Maybe<Scalars['String']>;
  preferredTimezone?: Maybe<Scalars['String']>;
  registrationRecords: Array<RegistrationRecord>;
  tenant: Tenant;
  userString?: Maybe<Scalars['String']>;
};

export type UserAddressInput = {
  acceptsLtl?: InputMaybe<Scalars['Boolean']>;
  city: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  phoneExtension?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type UserAddressIsDefaultInput = {
  isDefault: Scalars['Boolean'];
};

export type UserAddressUpdateInput = {
  acceptsLtl?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  phoneExtension?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UserExperience = {
  __typename?: 'UserExperience';
  algoliaSearchActive: Scalars['Boolean'];
  /** @deprecated Use collect_requested_delivery_date on checkout session instead. */
  hasRequestedDeliveryDate: Scalars['Boolean'];
};

export type UserPreferencesInput = {
  preferredLocale: Scalars['String'];
  preferredTimezone: Scalars['String'];
};

export type UtmData = {
  __typename?: 'UtmData';
  campaign?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['String']>;
};

export type UtmDataInput = {
  campaign?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  medium?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['String']>;
};

export type V3AiDesign = {
  __typename?: 'V3AiDesign';
  appId: Scalars['UUID4'];
  colors: Array<Maybe<V3AiDesignColor>>;
  featuredWeight: Scalars['Int'];
  generatedByTenant: Scalars['Boolean'];
  id: Scalars['UUID4'];
  imageUrls: Scalars['Json'];
  insertedAt: Scalars['DateTime'];
  promptAiEnhanced?: Maybe<Scalars['String']>;
  promptUser?: Maybe<Scalars['String']>;
  traits: Array<Maybe<V3AiDesignTrait>>;
  userId?: Maybe<Scalars['UUID4']>;
  variant?: Maybe<Variant>;
};

export type V3AiDesignColor = {
  __typename?: 'V3AiDesignColor';
  hexValue: Scalars['String'];
  name: Scalars['String'];
};

export type V3AiDesignColorInput = {
  hexValue: Scalars['String'];
  name: Scalars['String'];
};

export type V3AiDesignFilterInput = {
  colors?: InputMaybe<Array<V3AiDesignColorInput>>;
  ids?: InputMaybe<Array<Scalars['UUID4']>>;
  /** Used to narrow down designs returned based on who created them. Defaults to [TENANT] */
  sources?: InputMaybe<Array<V3SourceTypes>>;
  traits?: InputMaybe<Array<V3AiDesignTraitInput>>;
};

export type V3AiDesignResult = {
  __typename?: 'V3AiDesignResult';
  items?: Maybe<Array<V3AiDesign>>;
  pagination: PaginationData;
};

export type V3AiDesignSortingInput = {
  sortBy: V3SortableFields;
  sortOrder: V3SortableMethods;
};

export type V3AiDesignTrait = {
  __typename?: 'V3AiDesignTrait';
  id: Scalars['String'];
};

export type V3AiDesignTraitInput = {
  /** ID of Dato trait record */
  id: Scalars['String'];
};

export enum V3SortableFields {
  FeaturedWeight = 'FEATURED_WEIGHT',
  Gtin = 'GTIN',
  InsertedAt = 'INSERTED_AT'
}

export enum V3SortableMethods {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum V3SourceTypes {
  /** All designs regardless of source */
  All = 'ALL',
  /** Designs created by users other than yourself, but not by the tenant */
  Others = 'OTHERS',
  /** Designs created by the requesting user */
  Self = 'SELF',
  /** Designs created by the tenant and marked and 'generatedByTenant' */
  Tenant = 'TENANT'
}

export type ValidationError = {
  reason: Scalars['String'];
};

export enum ValidationRequirement {
  Always = 'ALWAYS',
  Never = 'NEVER',
  Optional = 'OPTIONAL'
}

export type Variant = {
  __typename?: 'Variant';
  allowCartingAndCheckout: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  bulkOrderDefaultQuantity?: Maybe<Scalars['Int']>;
  bundle?: Maybe<DynamicBundle>;
  cartTitle?: Maybe<Scalars['String']>;
  compareAtPrice?: Maybe<Scalars['Int']>;
  discounts?: Maybe<Array<Maybe<Discount>>>;
  gtin: Scalars['String'];
  hsppKit?: Maybe<HsppKit>;
  id: Scalars['UUID4'];
  imgUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
  insertedAt: Scalars['DateTime'];
  inventoryQty?: Maybe<Scalars['Int']>;
  isOutOfStock?: Maybe<Scalars['Boolean']>;
  item?: Maybe<Item>;
  kit?: Maybe<Kit>;
  /** The configured maximum purchase quantity capped by available inventory. Null when no maximum purchase quantity is configured. */
  maxQuantity?: Maybe<Scalars['Int']>;
  maximumPurchaseQuantity?: Maybe<Scalars['Int']>;
  minQuantity?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  product: Product;
  slug?: Maybe<Scalars['String']>;
  subscribable: Scalars['Boolean'];
  subscriptionPrice?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  title: Scalars['String'];
  type: Scalars['String'];
  unavailableForAllocation: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  variantAttributes?: Maybe<Array<Maybe<VariantAttribute>>>;
  /** For item variants, returns all bundle variants that contain this item. Returns empty list for non-item variants. This is a way to find a specicic type of related discounts for a variant. */
  variantBundles?: Maybe<Array<Maybe<Variant>>>;
  webData?: Maybe<VariantWebData>;
};

export type VariantArchivedValidationError = ValidationError & {
  __typename?: 'VariantArchivedValidationError';
  cartItemId: Scalars['UUID4'];
  reason: Scalars['String'];
  variantId: Scalars['UUID4'];
};

export type VariantAttribute = {
  __typename?: 'VariantAttribute';
  id: Scalars['UUID4'];
  label: Scalars['String'];
  productAttribute: ProductAttribute;
  value: Scalars['String'];
  variant: Variant;
};

/**
 * A single product attribute value filter: the attribute name (`product_attributes.name`,
 * e.g. "flavor") and, optionally, the variant attribute value (`variant_attributes.value`,
 * e.g. "fruit-punch"). Omit `value` to match variants that have the attribute set to any value.
 */
export type VariantAttributeInput = {
  /** Product attribute name to filter by (e.g. "flavor", "size") */
  attribute: Scalars['String'];
  /** Variant attribute value to match (e.g. "fruit-punch"). Omit to match any value */
  value?: InputMaybe<Scalars['String']>;
};

export type VariantBelowMinQuantityValidationError = ValidationError & {
  __typename?: 'VariantBelowMinQuantityValidationError';
  cartItemId: Scalars['UUID4'];
  minQuantity: Scalars['Int'];
  reason: Scalars['String'];
  variantId: Scalars['UUID4'];
};

export type VariantCartingAndCheckoutDisallowedValidationError = ValidationError & {
  __typename?: 'VariantCartingAndCheckoutDisallowedValidationError';
  cartItemId: Scalars['UUID4'];
  reason: Scalars['String'];
  variantId: Scalars['UUID4'];
};

export type VariantExceedsMaximumQuantityValidationError = ValidationError & {
  __typename?: 'VariantExceedsMaximumQuantityValidationError';
  cartItemId: Scalars['UUID4'];
  currentQuantity: Scalars['Int'];
  maxQuantity: Scalars['Int'];
  reason: Scalars['String'];
  variantId: Scalars['UUID4'];
};

export type VariantInvalidSubscriptionValidationError = ValidationError & {
  __typename?: 'VariantInvalidSubscriptionValidationError';
  cartItemId: Scalars['UUID4'];
  reason: Scalars['String'];
  variantId: Scalars['UUID4'];
};

export type VariantInvalidValidationError = ValidationError & {
  __typename?: 'VariantInvalidValidationError';
  cartItemId: Scalars['UUID4'];
  reason: Scalars['String'];
  variantId: Scalars['UUID4'];
};

export type VariantLowStockValidationError = ValidationError & {
  __typename?: 'VariantLowStockValidationError';
  cartItemId: Scalars['UUID4'];
  inventory: Scalars['Int'];
  quantity: Scalars['Int'];
  reason: Scalars['String'];
  variantId: Scalars['UUID4'];
};

export type VariantOutOfStockValidationError = ValidationError & {
  __typename?: 'VariantOutOfStockValidationError';
  cartItemId: Scalars['UUID4'];
  inventory: Scalars['Int'];
  quantity: Scalars['Int'];
  reason: Scalars['String'];
  variantId: Scalars['UUID4'];
};

export type VariantRequiresTaxExemptAccountValidationError = ValidationError & {
  __typename?: 'VariantRequiresTaxExemptAccountValidationError';
  cartItemId: Scalars['UUID4'];
  reason: Scalars['String'];
  variantId: Scalars['UUID4'];
};

/**
 * Search input for variants.
 *
 * When multiple `tags` are provided, variants matching ANY of the tags will be returned (OR condition).
 * When multiple `productCategorySlugs` are provided, variants in ANY matching Product Category will be returned.
 * When multiple `attributes` are provided, variants matching ALL attribute names are returned (AND),
 * and variants match ANY of the values for a given attribute name (OR).
 * Omit `value` in an entry to match variants that have that attribute set to any value.
 * All other fields use AND logic when combined.
 */
export type VariantSearchInput = {
  /** List of {attribute, value} pairs to filter by product attribute values. Variants must match ALL attribute names (AND), and match ANY value per attribute name (OR). Omit value to match any value for that attribute */
  attributes?: InputMaybe<Array<InputMaybe<VariantAttributeInput>>>;
  /** List of GTINs to filter by */
  gtins?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** List of item GTINs to filter by. Returns variants where the item matches (item variants), or bundles/kits containing items with matching GTINs */
  itemGtins?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter variants by license ID */
  licenseId?: InputMaybe<Scalars['ID']>;
  /** Filter variants by license key (e.g. "psu" for Penn State) */
  licenseKey?: InputMaybe<Scalars['String']>;
  /** List of Product Category slugs to filter by. Returns variants whose parent Product matches ANY provided slug */
  productCategorySlugs?: InputMaybe<Array<Scalars['String']>>;
  /** Filter variants by whether the product requires no typed customization (required_customization_type IS NULL). true = only no-customization-required variants, false = only customization-required variants, omit = no filtering */
  requiresNoCustomization?: InputMaybe<Scalars['Boolean']>;
  /** Variant slug to filter by */
  slug?: InputMaybe<Scalars['String']>;
  /** Filter variants by subscribable status. true = only subscribable, false = only non-subscribable, omit = no filtering */
  subscribable?: InputMaybe<Scalars['Boolean']>;
  /** List of tags to filter by. Returns variants matching ANY of the provided tags (OR condition) */
  tags?: InputMaybe<Array<InputMaybe<TagInput>>>;
  /** Variant type (item, bundle, or kit) */
  type?: InputMaybe<Scalars['String']>;
};

export type VariantSubscriptionsNotAllowedValidationError = ValidationError & {
  __typename?: 'VariantSubscriptionsNotAllowedValidationError';
  cartItemId: Scalars['UUID4'];
  reason: Scalars['String'];
  variantId: Scalars['UUID4'];
};

/** Web-specific data for variants used for enhanced product display (when DatoCMS is not used) */
export type VariantWebData = {
  __typename?: 'VariantWebData';
  /** Product description (HTML) */
  description?: Maybe<Scalars['String']>;
  /** Designer, artist, or brand name (text) */
  designerArtistBrandName?: Maybe<Scalars['String']>;
  /** Product dimensions (text) */
  dimensions?: Maybe<Scalars['String']>;
  /** Product material (text) */
  material?: Maybe<Scalars['String']>;
  /** Returns policy (HTML) */
  returnsPolicy?: Maybe<Scalars['String']>;
};

export type VariantZipCodeRestrictionValidationError = ValidationError & {
  __typename?: 'VariantZipCodeRestrictionValidationError';
  cartItemId: Scalars['UUID4'];
  reason: Scalars['String'];
  variantId: Scalars['UUID4'];
};

export type VariantsPayload = {
  __typename?: 'VariantsPayload';
  facets?: Maybe<Array<Maybe<FacetPayload>>>;
  pagination: PaginationData;
  variants: Array<Variant>;
};

export type VerifyAddressInput = {
  city: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type VerifyAddressPayload = {
  __typename?: 'VerifyAddressPayload';
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type VerifyTokenPayload = {
  __typename?: 'VerifyTokenPayload';
  verified?: Maybe<Scalars['Boolean']>;
};

export type VerifyUserInput = {
  token: Scalars['String'];
};

export type VirtualItemsInCartData = {
  __typename?: 'VirtualItemsInCartData';
  cartItemId: Scalars['UUID4'];
};

export type VirtualItemsInCartValidationError = ValidationError & {
  __typename?: 'VirtualItemsInCartValidationError';
  details: Array<VirtualItemsInCartData>;
  reason: Scalars['String'];
};

export type ZipCodeRestrictionLocalizations = {
  __typename?: 'ZipCodeRestrictionLocalizations';
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type ZipCodeRestrictionOnItemsData = {
  __typename?: 'ZipCodeRestrictionOnItemsData';
  cartItemId: Scalars['UUID4'];
};

export type ZipCodeRestrictionOnItemsValidationError = ValidationError & {
  __typename?: 'ZipCodeRestrictionOnItemsValidationError';
  details: Array<ZipCodeRestrictionOnItemsData>;
  reason: Scalars['String'];
};

export type ZipCodeRestrictionOnTenantData = {
  __typename?: 'ZipCodeRestrictionOnTenantData';
  cartItemId: Scalars['UUID4'];
};

export type ZipCodeRestrictionOnTenantValidationError = ValidationError & {
  __typename?: 'ZipCodeRestrictionOnTenantValidationError';
  details: Array<ZipCodeRestrictionOnTenantData>;
  reason: Scalars['String'];
};

export type ActiveAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveAccountQuery = { __typename?: 'RootQueryType', activeAccount?: { __typename?: 'Account', tags?: Array<string> | null | undefined } | null | undefined };

export type AdjustCartItemVariantMutationVariables = Exact<{
  cartId?: InputMaybe<Scalars['UUID4']>;
  input: AdjustCartItemVariantInput;
}>;


export type AdjustCartItemVariantMutation = { __typename?: 'RootMutationType', adjustCartItemVariant?: { __typename?: 'Cart', id: any, shipping: number, subtotal: number, total: number, variantItems?: Array<{ __typename?: 'CartVariantItem', id: any, gtin: string, imgUrls?: Array<string | null | undefined> | null | undefined, inventoryQty: number, isOutOfStock: boolean, quantity: number, title: string, subscriptionIntervalInDays?: number | null | undefined, perUnitPrice: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, variant: { __typename?: 'Variant', id: any, gtin: string, title: string, slug?: string | null | undefined, imgUrls?: Array<string | null | undefined> | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice?: number | null | undefined, minQuantity?: number | null | undefined, maximumPurchaseQuantity?: number | null | undefined, subscribable: boolean, subscriptionPrice?: number | null | undefined, variantAttributes?: Array<{ __typename?: 'VariantAttribute', id: any, value: string, productAttribute: { __typename?: 'ProductAttribute', name: string } } | null | undefined> | null | undefined, product: { __typename?: 'Product', id: any, key: string, title: string, tags?: Array<{ __typename?: 'Tag', key: string, value: string } | null | undefined> | null | undefined }, discounts?: Array<{ __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined, type?: CampaignType | null | undefined } | null | undefined> | null | undefined, webData?: { __typename?: 'VariantWebData', description?: string | null | undefined, returnsPolicy?: string | null | undefined, designerArtistBrandName?: string | null | undefined, dimensions?: string | null | undefined, material?: string | null | undefined } | null | undefined } }> | null | undefined, validationErrors?: Array<{ __typename: 'ArchivedItemsInCartValidationError', details: Array<{ __typename?: 'ArchivedItemsInCartData', cartItemId: any }> } | { __typename: 'AssortmentExclusionValidationError' } | { __typename: 'AssortmentInclusionValidationError' } | { __typename: 'BundleItemWithoutBundleValidationError', details: Array<{ __typename?: 'BundleItemWithoutBundleData', cartItemId: any }> } | { __typename: 'BundleNotFoundValidationError' } | { __typename: 'BundleRequirementsNotSatisfiedValidationError' } | { __typename: 'GuestCartContainsSubscriptionValidationError' } | { __typename: 'HsppKitRequiresManagedCustomerValidationError' } | { __typename: 'HsppKitYearlyMaximumReachedValidationError' } | { __typename: 'HsppPurchaseWindowClosedValidationError' } | { __typename: 'IncompleteShippingAddressValidationError' } | { __typename: 'InvalidLoyaltyItemsValidationError' } | { __typename: 'InventoryValidationError' } | { __typename: 'ManagedCustomerRequiresHsppKitValidationError' } | { __typename: 'MinimumAllocationEligibleQuantityValidationError' } | { __typename: 'MinimumPurchaseAmountValidationError', amount: number } | { __typename: 'MinimumPurchaseQuantityValidationError', quantity: number } | { __typename: 'MissingItemTaxInfoValidationError' } | { __typename: 'PurchaseQtyLimitValidationError', details: Array<{ __typename?: 'PurchaseQtyLimitData', itemId: any, purchaseQtyLimit: number }> } | { __typename: 'ScheduledOrderOutOfStockValidationError' } | { __typename: 'ShippingAddressRestrictionValidationError' } | { __typename: 'ShippingAddressValidationError' } | { __typename: 'SubscriptionsNotAllowedValidationError', details: Array<{ __typename?: 'SubscriptionsNotAllowedData', itemId: any }> } | { __typename: 'UnverifiedEmailValidationError' } | { __typename: 'VariantArchivedValidationError', cartItemId: any } | { __typename: 'VariantBelowMinQuantityValidationError', cartItemId: any, minQuantity: number } | { __typename: 'VariantCartingAndCheckoutDisallowedValidationError' } | { __typename: 'VariantExceedsMaximumQuantityValidationError', cartItemId: any, maxQuantity: number } | { __typename: 'VariantInvalidSubscriptionValidationError', cartItemId: any } | { __typename: 'VariantInvalidValidationError', cartItemId: any } | { __typename: 'VariantLowStockValidationError', cartItemId: any, inventory: number } | { __typename: 'VariantOutOfStockValidationError', cartItemId: any, inventory: number } | { __typename: 'VariantRequiresTaxExemptAccountValidationError' } | { __typename: 'VariantSubscriptionsNotAllowedValidationError', cartItemId: any } | { __typename: 'VariantZipCodeRestrictionValidationError', cartItemId: any } | { __typename: 'VirtualItemsInCartValidationError', details: Array<{ __typename?: 'VirtualItemsInCartData', cartItemId: any }> } | { __typename: 'ZipCodeRestrictionOnItemsValidationError', details: Array<{ __typename?: 'ZipCodeRestrictionOnItemsData', cartItemId: any }> } | { __typename: 'ZipCodeRestrictionOnTenantValidationError', details: Array<{ __typename?: 'ZipCodeRestrictionOnTenantData', cartItemId: any }> }> | null | undefined } | null | undefined };

export type AdjustCartItemVariantSubscriptionMutationVariables = Exact<{
  cartId?: InputMaybe<Scalars['UUID4']>;
  variantGtin: Scalars['String'];
  quantity: Scalars['Int'];
  subscriptionIntervalInDays: Scalars['Int'];
}>;


export type AdjustCartItemVariantSubscriptionMutation = { __typename?: 'RootMutationType', adjustCartItemVariantSubscription?: { __typename?: 'Cart', id: any, shipping: number, subtotal: number, total: number, variantItems?: Array<{ __typename?: 'CartVariantItem', id: any, gtin: string, imgUrls?: Array<string | null | undefined> | null | undefined, inventoryQty: number, isOutOfStock: boolean, quantity: number, title: string, subscriptionIntervalInDays?: number | null | undefined, perUnitPrice: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, variant: { __typename?: 'Variant', id: any, gtin: string, title: string, slug?: string | null | undefined, imgUrls?: Array<string | null | undefined> | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice?: number | null | undefined, minQuantity?: number | null | undefined, maximumPurchaseQuantity?: number | null | undefined, subscribable: boolean, subscriptionPrice?: number | null | undefined, variantAttributes?: Array<{ __typename?: 'VariantAttribute', id: any, value: string, productAttribute: { __typename?: 'ProductAttribute', name: string } } | null | undefined> | null | undefined, product: { __typename?: 'Product', id: any, key: string, title: string, tags?: Array<{ __typename?: 'Tag', key: string, value: string } | null | undefined> | null | undefined }, discounts?: Array<{ __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined, type?: CampaignType | null | undefined } | null | undefined> | null | undefined, webData?: { __typename?: 'VariantWebData', description?: string | null | undefined, returnsPolicy?: string | null | undefined, designerArtistBrandName?: string | null | undefined, dimensions?: string | null | undefined, material?: string | null | undefined } | null | undefined } }> | null | undefined, validationErrors?: Array<{ __typename: 'ArchivedItemsInCartValidationError', details: Array<{ __typename?: 'ArchivedItemsInCartData', cartItemId: any }> } | { __typename: 'AssortmentExclusionValidationError' } | { __typename: 'AssortmentInclusionValidationError' } | { __typename: 'BundleItemWithoutBundleValidationError', details: Array<{ __typename?: 'BundleItemWithoutBundleData', cartItemId: any }> } | { __typename: 'BundleNotFoundValidationError' } | { __typename: 'BundleRequirementsNotSatisfiedValidationError' } | { __typename: 'GuestCartContainsSubscriptionValidationError' } | { __typename: 'HsppKitRequiresManagedCustomerValidationError' } | { __typename: 'HsppKitYearlyMaximumReachedValidationError' } | { __typename: 'HsppPurchaseWindowClosedValidationError' } | { __typename: 'IncompleteShippingAddressValidationError' } | { __typename: 'InvalidLoyaltyItemsValidationError' } | { __typename: 'InventoryValidationError' } | { __typename: 'ManagedCustomerRequiresHsppKitValidationError' } | { __typename: 'MinimumAllocationEligibleQuantityValidationError' } | { __typename: 'MinimumPurchaseAmountValidationError', amount: number } | { __typename: 'MinimumPurchaseQuantityValidationError', quantity: number } | { __typename: 'MissingItemTaxInfoValidationError' } | { __typename: 'PurchaseQtyLimitValidationError', details: Array<{ __typename?: 'PurchaseQtyLimitData', itemId: any, purchaseQtyLimit: number }> } | { __typename: 'ScheduledOrderOutOfStockValidationError' } | { __typename: 'ShippingAddressRestrictionValidationError' } | { __typename: 'ShippingAddressValidationError' } | { __typename: 'SubscriptionsNotAllowedValidationError', details: Array<{ __typename?: 'SubscriptionsNotAllowedData', itemId: any }> } | { __typename: 'UnverifiedEmailValidationError' } | { __typename: 'VariantArchivedValidationError', cartItemId: any } | { __typename: 'VariantBelowMinQuantityValidationError', cartItemId: any, minQuantity: number } | { __typename: 'VariantCartingAndCheckoutDisallowedValidationError' } | { __typename: 'VariantExceedsMaximumQuantityValidationError', cartItemId: any, maxQuantity: number } | { __typename: 'VariantInvalidSubscriptionValidationError', cartItemId: any } | { __typename: 'VariantInvalidValidationError', cartItemId: any } | { __typename: 'VariantLowStockValidationError', cartItemId: any, inventory: number } | { __typename: 'VariantOutOfStockValidationError', cartItemId: any, inventory: number } | { __typename: 'VariantRequiresTaxExemptAccountValidationError' } | { __typename: 'VariantSubscriptionsNotAllowedValidationError', cartItemId: any } | { __typename: 'VariantZipCodeRestrictionValidationError', cartItemId: any } | { __typename: 'VirtualItemsInCartValidationError', details: Array<{ __typename?: 'VirtualItemsInCartData', cartItemId: any }> } | { __typename: 'ZipCodeRestrictionOnItemsValidationError', details: Array<{ __typename?: 'ZipCodeRestrictionOnItemsData', cartItemId: any }> } | { __typename: 'ZipCodeRestrictionOnTenantValidationError', details: Array<{ __typename?: 'ZipCodeRestrictionOnTenantData', cartItemId: any }> }> | null | undefined } | null | undefined };

export type AdvancedVariantSearchQueryVariables = Exact<{
  term: Scalars['String'];
}>;


export type AdvancedVariantSearchQuery = { __typename?: 'RootQueryType', advancedVariantSearch?: Array<{ __typename?: 'AdvancedVariantSearchResult', hit: any, variant: { __typename?: 'Variant', id: any, gtin: string, title: string, slug?: string | null | undefined, imgUrls?: Array<string | null | undefined> | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice?: number | null | undefined, minQuantity?: number | null | undefined, maximumPurchaseQuantity?: number | null | undefined, subscribable: boolean, subscriptionPrice?: number | null | undefined, variantAttributes?: Array<{ __typename?: 'VariantAttribute', id: any, value: string, productAttribute: { __typename?: 'ProductAttribute', name: string } } | null | undefined> | null | undefined, product: { __typename?: 'Product', id: any, key: string, title: string, tags?: Array<{ __typename?: 'Tag', key: string, value: string } | null | undefined> | null | undefined }, discounts?: Array<{ __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined, type?: CampaignType | null | undefined } | null | undefined> | null | undefined, webData?: { __typename?: 'VariantWebData', description?: string | null | undefined, returnsPolicy?: string | null | undefined, designerArtistBrandName?: string | null | undefined, dimensions?: string | null | undefined, material?: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined };

export type CartFragment = { __typename?: 'Cart', id: any, shipping: number, subtotal: number, total: number, variantItems?: Array<{ __typename?: 'CartVariantItem', id: any, gtin: string, imgUrls?: Array<string | null | undefined> | null | undefined, inventoryQty: number, isOutOfStock: boolean, quantity: number, title: string, subscriptionIntervalInDays?: number | null | undefined, perUnitPrice: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, variant: { __typename?: 'Variant', id: any, gtin: string, title: string, slug?: string | null | undefined, imgUrls?: Array<string | null | undefined> | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice?: number | null | undefined, minQuantity?: number | null | undefined, maximumPurchaseQuantity?: number | null | undefined, subscribable: boolean, subscriptionPrice?: number | null | undefined, variantAttributes?: Array<{ __typename?: 'VariantAttribute', id: any, value: string, productAttribute: { __typename?: 'ProductAttribute', name: string } } | null | undefined> | null | undefined, product: { __typename?: 'Product', id: any, key: string, title: string, tags?: Array<{ __typename?: 'Tag', key: string, value: string } | null | undefined> | null | undefined }, discounts?: Array<{ __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined, type?: CampaignType | null | undefined } | null | undefined> | null | undefined, webData?: { __typename?: 'VariantWebData', description?: string | null | undefined, returnsPolicy?: string | null | undefined, designerArtistBrandName?: string | null | undefined, dimensions?: string | null | undefined, material?: string | null | undefined } | null | undefined } }> | null | undefined, validationErrors?: Array<{ __typename: 'ArchivedItemsInCartValidationError', details: Array<{ __typename?: 'ArchivedItemsInCartData', cartItemId: any }> } | { __typename: 'AssortmentExclusionValidationError' } | { __typename: 'AssortmentInclusionValidationError' } | { __typename: 'BundleItemWithoutBundleValidationError', details: Array<{ __typename?: 'BundleItemWithoutBundleData', cartItemId: any }> } | { __typename: 'BundleNotFoundValidationError' } | { __typename: 'BundleRequirementsNotSatisfiedValidationError' } | { __typename: 'GuestCartContainsSubscriptionValidationError' } | { __typename: 'HsppKitRequiresManagedCustomerValidationError' } | { __typename: 'HsppKitYearlyMaximumReachedValidationError' } | { __typename: 'HsppPurchaseWindowClosedValidationError' } | { __typename: 'IncompleteShippingAddressValidationError' } | { __typename: 'InvalidLoyaltyItemsValidationError' } | { __typename: 'InventoryValidationError' } | { __typename: 'ManagedCustomerRequiresHsppKitValidationError' } | { __typename: 'MinimumAllocationEligibleQuantityValidationError' } | { __typename: 'MinimumPurchaseAmountValidationError', amount: number } | { __typename: 'MinimumPurchaseQuantityValidationError', quantity: number } | { __typename: 'MissingItemTaxInfoValidationError' } | { __typename: 'PurchaseQtyLimitValidationError', details: Array<{ __typename?: 'PurchaseQtyLimitData', itemId: any, purchaseQtyLimit: number }> } | { __typename: 'ScheduledOrderOutOfStockValidationError' } | { __typename: 'ShippingAddressRestrictionValidationError' } | { __typename: 'ShippingAddressValidationError' } | { __typename: 'SubscriptionsNotAllowedValidationError', details: Array<{ __typename?: 'SubscriptionsNotAllowedData', itemId: any }> } | { __typename: 'UnverifiedEmailValidationError' } | { __typename: 'VariantArchivedValidationError', cartItemId: any } | { __typename: 'VariantBelowMinQuantityValidationError', cartItemId: any, minQuantity: number } | { __typename: 'VariantCartingAndCheckoutDisallowedValidationError' } | { __typename: 'VariantExceedsMaximumQuantityValidationError', cartItemId: any, maxQuantity: number } | { __typename: 'VariantInvalidSubscriptionValidationError', cartItemId: any } | { __typename: 'VariantInvalidValidationError', cartItemId: any } | { __typename: 'VariantLowStockValidationError', cartItemId: any, inventory: number } | { __typename: 'VariantOutOfStockValidationError', cartItemId: any, inventory: number } | { __typename: 'VariantRequiresTaxExemptAccountValidationError' } | { __typename: 'VariantSubscriptionsNotAllowedValidationError', cartItemId: any } | { __typename: 'VariantZipCodeRestrictionValidationError', cartItemId: any } | { __typename: 'VirtualItemsInCartValidationError', details: Array<{ __typename?: 'VirtualItemsInCartData', cartItemId: any }> } | { __typename: 'ZipCodeRestrictionOnItemsValidationError', details: Array<{ __typename?: 'ZipCodeRestrictionOnItemsData', cartItemId: any }> } | { __typename: 'ZipCodeRestrictionOnTenantValidationError', details: Array<{ __typename?: 'ZipCodeRestrictionOnTenantData', cartItemId: any }> }> | null | undefined };

export type CartQueryVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type CartQuery = { __typename?: 'RootQueryType', cart?: { __typename?: 'Cart', id: any, shipping: number, subtotal: number, total: number, variantItems?: Array<{ __typename?: 'CartVariantItem', id: any, gtin: string, imgUrls?: Array<string | null | undefined> | null | undefined, inventoryQty: number, isOutOfStock: boolean, quantity: number, title: string, subscriptionIntervalInDays?: number | null | undefined, perUnitPrice: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, variant: { __typename?: 'Variant', id: any, gtin: string, title: string, slug?: string | null | undefined, imgUrls?: Array<string | null | undefined> | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice?: number | null | undefined, minQuantity?: number | null | undefined, maximumPurchaseQuantity?: number | null | undefined, subscribable: boolean, subscriptionPrice?: number | null | undefined, variantAttributes?: Array<{ __typename?: 'VariantAttribute', id: any, value: string, productAttribute: { __typename?: 'ProductAttribute', name: string } } | null | undefined> | null | undefined, product: { __typename?: 'Product', id: any, key: string, title: string, tags?: Array<{ __typename?: 'Tag', key: string, value: string } | null | undefined> | null | undefined }, discounts?: Array<{ __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined, type?: CampaignType | null | undefined } | null | undefined> | null | undefined, webData?: { __typename?: 'VariantWebData', description?: string | null | undefined, returnsPolicy?: string | null | undefined, designerArtistBrandName?: string | null | undefined, dimensions?: string | null | undefined, material?: string | null | undefined } | null | undefined } }> | null | undefined, validationErrors?: Array<{ __typename: 'ArchivedItemsInCartValidationError', details: Array<{ __typename?: 'ArchivedItemsInCartData', cartItemId: any }> } | { __typename: 'AssortmentExclusionValidationError' } | { __typename: 'AssortmentInclusionValidationError' } | { __typename: 'BundleItemWithoutBundleValidationError', details: Array<{ __typename?: 'BundleItemWithoutBundleData', cartItemId: any }> } | { __typename: 'BundleNotFoundValidationError' } | { __typename: 'BundleRequirementsNotSatisfiedValidationError' } | { __typename: 'GuestCartContainsSubscriptionValidationError' } | { __typename: 'HsppKitRequiresManagedCustomerValidationError' } | { __typename: 'HsppKitYearlyMaximumReachedValidationError' } | { __typename: 'HsppPurchaseWindowClosedValidationError' } | { __typename: 'IncompleteShippingAddressValidationError' } | { __typename: 'InvalidLoyaltyItemsValidationError' } | { __typename: 'InventoryValidationError' } | { __typename: 'ManagedCustomerRequiresHsppKitValidationError' } | { __typename: 'MinimumAllocationEligibleQuantityValidationError' } | { __typename: 'MinimumPurchaseAmountValidationError', amount: number } | { __typename: 'MinimumPurchaseQuantityValidationError', quantity: number } | { __typename: 'MissingItemTaxInfoValidationError' } | { __typename: 'PurchaseQtyLimitValidationError', details: Array<{ __typename?: 'PurchaseQtyLimitData', itemId: any, purchaseQtyLimit: number }> } | { __typename: 'ScheduledOrderOutOfStockValidationError' } | { __typename: 'ShippingAddressRestrictionValidationError' } | { __typename: 'ShippingAddressValidationError' } | { __typename: 'SubscriptionsNotAllowedValidationError', details: Array<{ __typename?: 'SubscriptionsNotAllowedData', itemId: any }> } | { __typename: 'UnverifiedEmailValidationError' } | { __typename: 'VariantArchivedValidationError', cartItemId: any } | { __typename: 'VariantBelowMinQuantityValidationError', cartItemId: any, minQuantity: number } | { __typename: 'VariantCartingAndCheckoutDisallowedValidationError' } | { __typename: 'VariantExceedsMaximumQuantityValidationError', cartItemId: any, maxQuantity: number } | { __typename: 'VariantInvalidSubscriptionValidationError', cartItemId: any } | { __typename: 'VariantInvalidValidationError', cartItemId: any } | { __typename: 'VariantLowStockValidationError', cartItemId: any, inventory: number } | { __typename: 'VariantOutOfStockValidationError', cartItemId: any, inventory: number } | { __typename: 'VariantRequiresTaxExemptAccountValidationError' } | { __typename: 'VariantSubscriptionsNotAllowedValidationError', cartItemId: any } | { __typename: 'VariantZipCodeRestrictionValidationError', cartItemId: any } | { __typename: 'VirtualItemsInCartValidationError', details: Array<{ __typename?: 'VirtualItemsInCartData', cartItemId: any }> } | { __typename: 'ZipCodeRestrictionOnItemsValidationError', details: Array<{ __typename?: 'ZipCodeRestrictionOnItemsData', cartItemId: any }> } | { __typename: 'ZipCodeRestrictionOnTenantValidationError', details: Array<{ __typename?: 'ZipCodeRestrictionOnTenantData', cartItemId: any }> }> | null | undefined } | null | undefined };

export type CartVariantItemFragment = { __typename?: 'CartVariantItem', id: any, gtin: string, imgUrls?: Array<string | null | undefined> | null | undefined, inventoryQty: number, isOutOfStock: boolean, quantity: number, title: string, subscriptionIntervalInDays?: number | null | undefined, perUnitPrice: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, variant: { __typename?: 'Variant', id: any, gtin: string, title: string, slug?: string | null | undefined, imgUrls?: Array<string | null | undefined> | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice?: number | null | undefined, minQuantity?: number | null | undefined, maximumPurchaseQuantity?: number | null | undefined, subscribable: boolean, subscriptionPrice?: number | null | undefined, variantAttributes?: Array<{ __typename?: 'VariantAttribute', id: any, value: string, productAttribute: { __typename?: 'ProductAttribute', name: string } } | null | undefined> | null | undefined, product: { __typename?: 'Product', id: any, key: string, title: string, tags?: Array<{ __typename?: 'Tag', key: string, value: string } | null | undefined> | null | undefined }, discounts?: Array<{ __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined, type?: CampaignType | null | undefined } | null | undefined> | null | undefined, webData?: { __typename?: 'VariantWebData', description?: string | null | undefined, returnsPolicy?: string | null | undefined, designerArtistBrandName?: string | null | undefined, dimensions?: string | null | undefined, material?: string | null | undefined } | null | undefined } };

export type CollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CollectionsQuery = { __typename?: 'RootQueryType', collections: Array<{ __typename?: 'CollectionSummary', name: string }> };

export type CreateCartFromOrderMutationVariables = Exact<{
  orderId: Scalars['UUID4'];
}>;


export type CreateCartFromOrderMutation = { __typename?: 'RootMutationType', createTemporaryCartFromOrder?: { __typename?: 'Cart', id: any } | null | undefined };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: any } | null | undefined };

export type CurrentUserWithCartQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserWithCartQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: any, cart?: { __typename?: 'Cart', id: any } | null | undefined } | null | undefined };

export type GetCartFromUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartFromUserQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', cart?: { __typename?: 'Cart', id: any, shipping: number, subtotal: number, total: number, variantItems?: Array<{ __typename?: 'CartVariantItem', id: any, gtin: string, imgUrls?: Array<string | null | undefined> | null | undefined, inventoryQty: number, isOutOfStock: boolean, quantity: number, title: string, subscriptionIntervalInDays?: number | null | undefined, perUnitPrice: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, variant: { __typename?: 'Variant', id: any, gtin: string, title: string, slug?: string | null | undefined, imgUrls?: Array<string | null | undefined> | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice?: number | null | undefined, minQuantity?: number | null | undefined, maximumPurchaseQuantity?: number | null | undefined, subscribable: boolean, subscriptionPrice?: number | null | undefined, variantAttributes?: Array<{ __typename?: 'VariantAttribute', id: any, value: string, productAttribute: { __typename?: 'ProductAttribute', name: string } } | null | undefined> | null | undefined, product: { __typename?: 'Product', id: any, key: string, title: string, tags?: Array<{ __typename?: 'Tag', key: string, value: string } | null | undefined> | null | undefined }, discounts?: Array<{ __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined, type?: CampaignType | null | undefined } | null | undefined> | null | undefined, webData?: { __typename?: 'VariantWebData', description?: string | null | undefined, returnsPolicy?: string | null | undefined, designerArtistBrandName?: string | null | undefined, dimensions?: string | null | undefined, material?: string | null | undefined } | null | undefined } }> | null | undefined, validationErrors?: Array<{ __typename: 'ArchivedItemsInCartValidationError', details: Array<{ __typename?: 'ArchivedItemsInCartData', cartItemId: any }> } | { __typename: 'AssortmentExclusionValidationError' } | { __typename: 'AssortmentInclusionValidationError' } | { __typename: 'BundleItemWithoutBundleValidationError', details: Array<{ __typename?: 'BundleItemWithoutBundleData', cartItemId: any }> } | { __typename: 'BundleNotFoundValidationError' } | { __typename: 'BundleRequirementsNotSatisfiedValidationError' } | { __typename: 'GuestCartContainsSubscriptionValidationError' } | { __typename: 'HsppKitRequiresManagedCustomerValidationError' } | { __typename: 'HsppKitYearlyMaximumReachedValidationError' } | { __typename: 'HsppPurchaseWindowClosedValidationError' } | { __typename: 'IncompleteShippingAddressValidationError' } | { __typename: 'InvalidLoyaltyItemsValidationError' } | { __typename: 'InventoryValidationError' } | { __typename: 'ManagedCustomerRequiresHsppKitValidationError' } | { __typename: 'MinimumAllocationEligibleQuantityValidationError' } | { __typename: 'MinimumPurchaseAmountValidationError', amount: number } | { __typename: 'MinimumPurchaseQuantityValidationError', quantity: number } | { __typename: 'MissingItemTaxInfoValidationError' } | { __typename: 'PurchaseQtyLimitValidationError', details: Array<{ __typename?: 'PurchaseQtyLimitData', itemId: any, purchaseQtyLimit: number }> } | { __typename: 'ScheduledOrderOutOfStockValidationError' } | { __typename: 'ShippingAddressRestrictionValidationError' } | { __typename: 'ShippingAddressValidationError' } | { __typename: 'SubscriptionsNotAllowedValidationError', details: Array<{ __typename?: 'SubscriptionsNotAllowedData', itemId: any }> } | { __typename: 'UnverifiedEmailValidationError' } | { __typename: 'VariantArchivedValidationError', cartItemId: any } | { __typename: 'VariantBelowMinQuantityValidationError', cartItemId: any, minQuantity: number } | { __typename: 'VariantCartingAndCheckoutDisallowedValidationError' } | { __typename: 'VariantExceedsMaximumQuantityValidationError', cartItemId: any, maxQuantity: number } | { __typename: 'VariantInvalidSubscriptionValidationError', cartItemId: any } | { __typename: 'VariantInvalidValidationError', cartItemId: any } | { __typename: 'VariantLowStockValidationError', cartItemId: any, inventory: number } | { __typename: 'VariantOutOfStockValidationError', cartItemId: any, inventory: number } | { __typename: 'VariantRequiresTaxExemptAccountValidationError' } | { __typename: 'VariantSubscriptionsNotAllowedValidationError', cartItemId: any } | { __typename: 'VariantZipCodeRestrictionValidationError', cartItemId: any } | { __typename: 'VirtualItemsInCartValidationError', details: Array<{ __typename?: 'VirtualItemsInCartData', cartItemId: any }> } | { __typename: 'ZipCodeRestrictionOnItemsValidationError', details: Array<{ __typename?: 'ZipCodeRestrictionOnItemsData', cartItemId: any }> } | { __typename: 'ZipCodeRestrictionOnTenantValidationError', details: Array<{ __typename?: 'ZipCodeRestrictionOnTenantData', cartItemId: any }> }> | null | undefined } | null | undefined } | null | undefined };

export type GetItemsByGtinsQueryVariables = Exact<{
  gtins?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  pagination: PaginationInput;
}>;


export type GetItemsByGtinsQuery = { __typename?: 'RootQueryType', searchVariants: { __typename?: 'VariantsPayload', pagination: { __typename?: 'PaginationData', totalPages: number }, items: Array<{ __typename?: 'Variant', id: any, gtin: string, title: string, slug?: string | null | undefined, imgUrls?: Array<string | null | undefined> | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice?: number | null | undefined, minQuantity?: number | null | undefined, maximumPurchaseQuantity?: number | null | undefined, subscribable: boolean, subscriptionPrice?: number | null | undefined, variantAttributes?: Array<{ __typename?: 'VariantAttribute', id: any, value: string, productAttribute: { __typename?: 'ProductAttribute', name: string } } | null | undefined> | null | undefined, product: { __typename?: 'Product', id: any, key: string, title: string, tags?: Array<{ __typename?: 'Tag', key: string, value: string } | null | undefined> | null | undefined }, discounts?: Array<{ __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined, type?: CampaignType | null | undefined } | null | undefined> | null | undefined, webData?: { __typename?: 'VariantWebData', description?: string | null | undefined, returnsPolicy?: string | null | undefined, designerArtistBrandName?: string | null | undefined, dimensions?: string | null | undefined, material?: string | null | undefined } | null | undefined }> } };

export type GetVariantsByCollectionNameQueryVariables = Exact<{
  term: Scalars['String'];
  facetFilters?: InputMaybe<Array<Array<Scalars['String']> | Scalars['String']> | Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetVariantsByCollectionNameQuery = { __typename?: 'RootQueryType', advancedVariantSearch?: Array<{ __typename?: 'AdvancedVariantSearchResult', hit: any, variant: { __typename?: 'Variant', id: any, gtin: string, title: string, slug?: string | null | undefined, imgUrls?: Array<string | null | undefined> | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice?: number | null | undefined, minQuantity?: number | null | undefined, maximumPurchaseQuantity?: number | null | undefined, subscribable: boolean, subscriptionPrice?: number | null | undefined, variantAttributes?: Array<{ __typename?: 'VariantAttribute', id: any, value: string, productAttribute: { __typename?: 'ProductAttribute', name: string } } | null | undefined> | null | undefined, product: { __typename?: 'Product', id: any, key: string, title: string, tags?: Array<{ __typename?: 'Tag', key: string, value: string } | null | undefined> | null | undefined }, discounts?: Array<{ __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined, type?: CampaignType | null | undefined } | null | undefined> | null | undefined, webData?: { __typename?: 'VariantWebData', description?: string | null | undefined, returnsPolicy?: string | null | undefined, designerArtistBrandName?: string | null | undefined, dimensions?: string | null | undefined, material?: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined };

export type ItemFieldsForAnalyticsFragment = { __typename?: 'Item', id: any, title?: string | null | undefined, price?: number | null | undefined, brandName?: string | null | undefined, gtin: string };

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'RootMutationType', loginUser?: { __typename?: 'User', id: any, email: string } | null | undefined };

export type LogoutUserMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutUserMutation = { __typename?: 'RootMutationType', logoutUser?: { __typename?: 'User', id: any } | null | undefined };

export type MergeCartsMutationVariables = Exact<{
  srcCartId: Scalars['UUID4'];
  destCartId: Scalars['UUID4'];
}>;


export type MergeCartsMutation = { __typename?: 'RootMutationType', mergeCarts?: { __typename?: 'Cart', id: any, shipping: number, subtotal: number, total: number, variantItems?: Array<{ __typename?: 'CartVariantItem', id: any, gtin: string, imgUrls?: Array<string | null | undefined> | null | undefined, inventoryQty: number, isOutOfStock: boolean, quantity: number, title: string, subscriptionIntervalInDays?: number | null | undefined, perUnitPrice: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, variant: { __typename?: 'Variant', id: any, gtin: string, title: string, slug?: string | null | undefined, imgUrls?: Array<string | null | undefined> | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice?: number | null | undefined, minQuantity?: number | null | undefined, maximumPurchaseQuantity?: number | null | undefined, subscribable: boolean, subscriptionPrice?: number | null | undefined, variantAttributes?: Array<{ __typename?: 'VariantAttribute', id: any, value: string, productAttribute: { __typename?: 'ProductAttribute', name: string } } | null | undefined> | null | undefined, product: { __typename?: 'Product', id: any, key: string, title: string, tags?: Array<{ __typename?: 'Tag', key: string, value: string } | null | undefined> | null | undefined }, discounts?: Array<{ __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined, type?: CampaignType | null | undefined } | null | undefined> | null | undefined, webData?: { __typename?: 'VariantWebData', description?: string | null | undefined, returnsPolicy?: string | null | undefined, designerArtistBrandName?: string | null | undefined, dimensions?: string | null | undefined, material?: string | null | undefined } | null | undefined } }> | null | undefined, validationErrors?: Array<{ __typename: 'ArchivedItemsInCartValidationError', details: Array<{ __typename?: 'ArchivedItemsInCartData', cartItemId: any }> } | { __typename: 'AssortmentExclusionValidationError' } | { __typename: 'AssortmentInclusionValidationError' } | { __typename: 'BundleItemWithoutBundleValidationError', details: Array<{ __typename?: 'BundleItemWithoutBundleData', cartItemId: any }> } | { __typename: 'BundleNotFoundValidationError' } | { __typename: 'BundleRequirementsNotSatisfiedValidationError' } | { __typename: 'GuestCartContainsSubscriptionValidationError' } | { __typename: 'HsppKitRequiresManagedCustomerValidationError' } | { __typename: 'HsppKitYearlyMaximumReachedValidationError' } | { __typename: 'HsppPurchaseWindowClosedValidationError' } | { __typename: 'IncompleteShippingAddressValidationError' } | { __typename: 'InvalidLoyaltyItemsValidationError' } | { __typename: 'InventoryValidationError' } | { __typename: 'ManagedCustomerRequiresHsppKitValidationError' } | { __typename: 'MinimumAllocationEligibleQuantityValidationError' } | { __typename: 'MinimumPurchaseAmountValidationError', amount: number } | { __typename: 'MinimumPurchaseQuantityValidationError', quantity: number } | { __typename: 'MissingItemTaxInfoValidationError' } | { __typename: 'PurchaseQtyLimitValidationError', details: Array<{ __typename?: 'PurchaseQtyLimitData', itemId: any, purchaseQtyLimit: number }> } | { __typename: 'ScheduledOrderOutOfStockValidationError' } | { __typename: 'ShippingAddressRestrictionValidationError' } | { __typename: 'ShippingAddressValidationError' } | { __typename: 'SubscriptionsNotAllowedValidationError', details: Array<{ __typename?: 'SubscriptionsNotAllowedData', itemId: any }> } | { __typename: 'UnverifiedEmailValidationError' } | { __typename: 'VariantArchivedValidationError', cartItemId: any } | { __typename: 'VariantBelowMinQuantityValidationError', cartItemId: any, minQuantity: number } | { __typename: 'VariantCartingAndCheckoutDisallowedValidationError' } | { __typename: 'VariantExceedsMaximumQuantityValidationError', cartItemId: any, maxQuantity: number } | { __typename: 'VariantInvalidSubscriptionValidationError', cartItemId: any } | { __typename: 'VariantInvalidValidationError', cartItemId: any } | { __typename: 'VariantLowStockValidationError', cartItemId: any, inventory: number } | { __typename: 'VariantOutOfStockValidationError', cartItemId: any, inventory: number } | { __typename: 'VariantRequiresTaxExemptAccountValidationError' } | { __typename: 'VariantSubscriptionsNotAllowedValidationError', cartItemId: any } | { __typename: 'VariantZipCodeRestrictionValidationError', cartItemId: any } | { __typename: 'VirtualItemsInCartValidationError', details: Array<{ __typename?: 'VirtualItemsInCartData', cartItemId: any }> } | { __typename: 'ZipCodeRestrictionOnItemsValidationError', details: Array<{ __typename?: 'ZipCodeRestrictionOnItemsData', cartItemId: any }> } | { __typename: 'ZipCodeRestrictionOnTenantValidationError', details: Array<{ __typename?: 'ZipCodeRestrictionOnTenantData', cartItemId: any }> }> | null | undefined } | null | undefined };

export type OrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type OrdersQuery = { __typename?: 'RootQueryType', submittedOrders?: { __typename?: 'SubmittedOrderPayload', submittedOrders: Array<{ __typename?: 'SubmittedOrder', id: any, status?: string | null | undefined, price: { __typename?: 'Price', total: number, items: Array<{ __typename?: 'PriceItem', quantity?: number | null | undefined, item?: { __typename?: 'EmbeddedItem', id?: any | null | undefined, imgUrl?: string | null | undefined } | null | undefined }> }, contactInfo: { __typename?: 'ContactInfo', shippingAddress?: { __typename?: 'ShippingAddress', firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined } | null | undefined }, fulfillments: Array<{ __typename?: 'Fulfillment', items: Array<{ __typename?: 'FulfillmentItem', quantity?: number | null | undefined }> }>, user?: { __typename?: 'User', id: any } | null | undefined }> } | null | undefined };

export type RecommendedProductFragment = { __typename?: 'Item', id: any, title?: string | null | undefined, compareAtPrice: number, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, slug?: string | null | undefined, imgUrl?: string | null | undefined, inventoryQty?: number | null | undefined, minOrderQty?: number | null | undefined };

export type RequestPasswordResetForUserMutationVariables = Exact<{
  email: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
}>;


export type RequestPasswordResetForUserMutation = { __typename?: 'RootMutationType', requestPasswordResetForUser?: { __typename?: 'RequestPasswordResetForUserPayload', email: string } | null | undefined };

export type RestrictedItemsByZipCodeQueryVariables = Exact<{
  zip: Scalars['String'];
}>;


export type RestrictedItemsByZipCodeQuery = { __typename?: 'RootQueryType', restrictedItemsByZipCode?: { __typename?: 'RestrictedItemsByZipCodePayload', restrictedItems: Array<{ __typename?: 'Item', id: any }> } | null | undefined };

export type SearchProductByKeyQueryVariables = Exact<{
  key: Scalars['String'];
  pagination: PaginationInput;
}>;


export type SearchProductByKeyQuery = { __typename?: 'RootQueryType', searchProducts: { __typename?: 'ProductsPayload', pagination: { __typename?: 'PaginationData', totalPages: number, total: number, page: number, count: number }, products: Array<{ __typename?: 'Product', id: any, key: string, title: string, tags?: Array<{ __typename?: 'Tag', key: string, value: string } | null | undefined> | null | undefined, variants?: Array<{ __typename?: 'Variant', id: any, gtin: string, title: string, slug?: string | null | undefined, imgUrls?: Array<string | null | undefined> | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice?: number | null | undefined, minQuantity?: number | null | undefined, maximumPurchaseQuantity?: number | null | undefined, subscribable: boolean, subscriptionPrice?: number | null | undefined, variantAttributes?: Array<{ __typename?: 'VariantAttribute', id: any, value: string, productAttribute: { __typename?: 'ProductAttribute', name: string } } | null | undefined> | null | undefined, product: { __typename?: 'Product', id: any, key: string, title: string, tags?: Array<{ __typename?: 'Tag', key: string, value: string } | null | undefined> | null | undefined }, discounts?: Array<{ __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined, type?: CampaignType | null | undefined } | null | undefined> | null | undefined, webData?: { __typename?: 'VariantWebData', description?: string | null | undefined, returnsPolicy?: string | null | undefined, designerArtistBrandName?: string | null | undefined, dimensions?: string | null | undefined, material?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined }> } };

export type SearchVariantsBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  pagination: PaginationInput;
}>;


export type SearchVariantsBySlugQuery = { __typename?: 'RootQueryType', searchVariants: { __typename?: 'VariantsPayload', pagination: { __typename?: 'PaginationData', totalPages: number, total: number, page: number, count: number }, variants: Array<{ __typename?: 'Variant', id: any, gtin: string, title: string, slug?: string | null | undefined, imgUrls?: Array<string | null | undefined> | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice?: number | null | undefined, minQuantity?: number | null | undefined, maximumPurchaseQuantity?: number | null | undefined, subscribable: boolean, subscriptionPrice?: number | null | undefined, tags?: Array<{ __typename?: 'Tag', key: string, value: string } | null | undefined> | null | undefined, variantAttributes?: Array<{ __typename?: 'VariantAttribute', id: any, value: string, productAttribute: { __typename?: 'ProductAttribute', name: string } } | null | undefined> | null | undefined, product: { __typename?: 'Product', id: any, key: string, title: string, tags?: Array<{ __typename?: 'Tag', key: string, value: string } | null | undefined> | null | undefined }, discounts?: Array<{ __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined, type?: CampaignType | null | undefined } | null | undefined> | null | undefined, webData?: { __typename?: 'VariantWebData', description?: string | null | undefined, returnsPolicy?: string | null | undefined, designerArtistBrandName?: string | null | undefined, dimensions?: string | null | undefined, material?: string | null | undefined } | null | undefined }> } };

export type SearchVariantsWithTagsQueryVariables = Exact<{
  tags?: InputMaybe<Array<TagInput> | TagInput>;
  pagination: PaginationInput;
}>;


export type SearchVariantsWithTagsQuery = { __typename?: 'RootQueryType', searchVariants: { __typename?: 'VariantsPayload', pagination: { __typename?: 'PaginationData', totalPages: number, total: number, page: number, count: number }, variants: Array<{ __typename?: 'Variant', id: any, gtin: string, title: string, slug?: string | null | undefined, imgUrls?: Array<string | null | undefined> | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice?: number | null | undefined, minQuantity?: number | null | undefined, maximumPurchaseQuantity?: number | null | undefined, subscribable: boolean, subscriptionPrice?: number | null | undefined, tags?: Array<{ __typename?: 'Tag', key: string, value: string } | null | undefined> | null | undefined, variantAttributes?: Array<{ __typename?: 'VariantAttribute', id: any, value: string, productAttribute: { __typename?: 'ProductAttribute', name: string } } | null | undefined> | null | undefined, product: { __typename?: 'Product', id: any, key: string, title: string, tags?: Array<{ __typename?: 'Tag', key: string, value: string } | null | undefined> | null | undefined }, discounts?: Array<{ __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined, type?: CampaignType | null | undefined } | null | undefined> | null | undefined, webData?: { __typename?: 'VariantWebData', description?: string | null | undefined, returnsPolicy?: string | null | undefined, designerArtistBrandName?: string | null | undefined, dimensions?: string | null | undefined, material?: string | null | undefined } | null | undefined }> } };

export type SignUpUserMutationVariables = Exact<{
  input: SignupUserInput;
}>;


export type SignUpUserMutation = { __typename?: 'RootMutationType', signupUser?: { __typename?: 'User', id: any, email: string, hashedEmail: string } | null | undefined };

export type SubmittedOrderFragment = { __typename?: 'SubmittedOrder', id: any, status?: string | null | undefined, price: { __typename?: 'Price', total: number, items: Array<{ __typename?: 'PriceItem', quantity?: number | null | undefined, item?: { __typename?: 'EmbeddedItem', id?: any | null | undefined, imgUrl?: string | null | undefined } | null | undefined }> }, contactInfo: { __typename?: 'ContactInfo', shippingAddress?: { __typename?: 'ShippingAddress', firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined } | null | undefined }, fulfillments: Array<{ __typename?: 'Fulfillment', items: Array<{ __typename?: 'FulfillmentItem', quantity?: number | null | undefined }> }>, user?: { __typename?: 'User', id: any } | null | undefined };

export type TenantQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantQuery = { __typename?: 'RootQueryType', tenant?: { __typename?: 'Tenant', id: any, brandConfig: { __typename?: 'BrandConfig', title: string, copyright: string, customizations: { __typename?: 'BrandConfigCustomizations', contacts: Array<{ __typename?: 'BrandConfigCustomizationsContact', city?: string | null | undefined, countryCode?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, phoneNumber?: string | null | undefined, state?: string | null | undefined, type: string, zip?: string | null | undefined }>, fonts: Array<{ __typename?: 'BrandConfigCustomizationsFont', name: string, style?: string | null | undefined, weight?: string | null | undefined, urls: Array<{ __typename?: 'BrandConfigCustomizationsFontSources', format?: string | null | undefined, local?: string | null | undefined, url?: string | null | undefined }>, meta?: Array<{ __typename?: 'BrandConfigCustomizationsFontMeta', key: string, value: string }> | null | undefined }>, images: Array<{ __typename?: 'BrandConfigCustomizationsImage', name: string, src: string, alt?: string | null | undefined }>, links: Array<{ __typename?: 'BrandConfigCustomizationsLink', location: string, position: number, title: string, url: string, newTab: boolean }> }, customTexts: Array<{ __typename?: 'CustomText', body: Array<string>, location: string, position?: number | null | undefined, type: string, links: Array<{ __typename?: 'CustomTextLink', type: string, key: string, linkValue: string, displayValue: string }> }>, trackingFonts?: Array<{ __typename?: 'BrandConfigTrackingFonts', isTrackingRequired: boolean, resource: string }> | null | undefined }, shoppingBagConfig: { __typename?: 'ShoppingBagConfig', maxAmountForSelect: number, minimumPurchaseAmount: number, minimumPurchaseQty: number, availableSubscriptionIntervalsInDays: Array<number>, orderSubscriptionsEnabled: boolean, subscriptionIntervalsInDays: Array<number> }, shippingConfig: { __typename?: 'ShippingConfig', fixedFeeShipping?: number | null | undefined, freeShippingThreshold?: number | null | undefined }, checkout?: { __typename?: 'Checkout', version?: string | null | undefined } | null | undefined, userExperience: { __typename?: 'UserExperience', algoliaSearchActive: boolean } } | null | undefined };

export type ValidatePasswordQueryVariables = Exact<{
  password: Scalars['String'];
}>;


export type ValidatePasswordQuery = { __typename?: 'RootQueryType', validatePassword: Array<{ __typename?: 'PasswordRequirement', msg: string, satisfied: boolean }> };

export type VariantFragment = { __typename?: 'Variant', id: any, gtin: string, title: string, slug?: string | null | undefined, imgUrls?: Array<string | null | undefined> | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice?: number | null | undefined, minQuantity?: number | null | undefined, maximumPurchaseQuantity?: number | null | undefined, subscribable: boolean, subscriptionPrice?: number | null | undefined, variantAttributes?: Array<{ __typename?: 'VariantAttribute', id: any, value: string, productAttribute: { __typename?: 'ProductAttribute', name: string } } | null | undefined> | null | undefined, product: { __typename?: 'Product', id: any, key: string, title: string, tags?: Array<{ __typename?: 'Tag', key: string, value: string } | null | undefined> | null | undefined }, discounts?: Array<{ __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined, type?: CampaignType | null | undefined } | null | undefined> | null | undefined, webData?: { __typename?: 'VariantWebData', description?: string | null | undefined, returnsPolicy?: string | null | undefined, designerArtistBrandName?: string | null | undefined, dimensions?: string | null | undefined, material?: string | null | undefined } | null | undefined };

export type V3CartFragment = { __typename?: 'Cart', id: any, shipping: number, subtotal: number, total: number, variantItems?: Array<{ __typename?: 'CartVariantItem', gtin: string, id: any, imgUrls?: Array<string | null | undefined> | null | undefined, inventoryQty: number, isOutOfStock: boolean, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, variant: { __typename?: 'Variant', gtin: string, id: any, imgUrls?: Array<string | null | undefined> | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minQuantity?: number | null | undefined, maximumPurchaseQuantity?: number | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title: string, discounts?: Array<{ __typename?: 'Discount', amount?: number | null | undefined, isPercent?: boolean | null | undefined, type?: CampaignType | null | undefined } | null | undefined> | null | undefined } }> | null | undefined };

type V3ValidationError_ArchivedItemsInCartValidationError_Fragment = { __typename: 'ArchivedItemsInCartValidationError', details: Array<{ __typename?: 'ArchivedItemsInCartData', cartItemId: any }> };

type V3ValidationError_AssortmentExclusionValidationError_Fragment = { __typename: 'AssortmentExclusionValidationError' };

type V3ValidationError_AssortmentInclusionValidationError_Fragment = { __typename: 'AssortmentInclusionValidationError' };

type V3ValidationError_BundleItemWithoutBundleValidationError_Fragment = { __typename: 'BundleItemWithoutBundleValidationError', details: Array<{ __typename?: 'BundleItemWithoutBundleData', cartItemId: any }> };

type V3ValidationError_BundleNotFoundValidationError_Fragment = { __typename: 'BundleNotFoundValidationError' };

type V3ValidationError_BundleRequirementsNotSatisfiedValidationError_Fragment = { __typename: 'BundleRequirementsNotSatisfiedValidationError' };

type V3ValidationError_GuestCartContainsSubscriptionValidationError_Fragment = { __typename: 'GuestCartContainsSubscriptionValidationError' };

type V3ValidationError_HsppKitRequiresManagedCustomerValidationError_Fragment = { __typename: 'HsppKitRequiresManagedCustomerValidationError' };

type V3ValidationError_HsppKitYearlyMaximumReachedValidationError_Fragment = { __typename: 'HsppKitYearlyMaximumReachedValidationError' };

type V3ValidationError_HsppPurchaseWindowClosedValidationError_Fragment = { __typename: 'HsppPurchaseWindowClosedValidationError' };

type V3ValidationError_IncompleteShippingAddressValidationError_Fragment = { __typename: 'IncompleteShippingAddressValidationError' };

type V3ValidationError_InvalidLoyaltyItemsValidationError_Fragment = { __typename: 'InvalidLoyaltyItemsValidationError' };

type V3ValidationError_InventoryValidationError_Fragment = { __typename: 'InventoryValidationError' };

type V3ValidationError_ManagedCustomerRequiresHsppKitValidationError_Fragment = { __typename: 'ManagedCustomerRequiresHsppKitValidationError' };

type V3ValidationError_MinimumAllocationEligibleQuantityValidationError_Fragment = { __typename: 'MinimumAllocationEligibleQuantityValidationError' };

type V3ValidationError_MinimumPurchaseAmountValidationError_Fragment = { __typename: 'MinimumPurchaseAmountValidationError', amount: number };

type V3ValidationError_MinimumPurchaseQuantityValidationError_Fragment = { __typename: 'MinimumPurchaseQuantityValidationError', quantity: number };

type V3ValidationError_MissingItemTaxInfoValidationError_Fragment = { __typename: 'MissingItemTaxInfoValidationError' };

type V3ValidationError_PurchaseQtyLimitValidationError_Fragment = { __typename: 'PurchaseQtyLimitValidationError', details: Array<{ __typename?: 'PurchaseQtyLimitData', itemId: any, purchaseQtyLimit: number }> };

type V3ValidationError_ScheduledOrderOutOfStockValidationError_Fragment = { __typename: 'ScheduledOrderOutOfStockValidationError' };

type V3ValidationError_ShippingAddressRestrictionValidationError_Fragment = { __typename: 'ShippingAddressRestrictionValidationError' };

type V3ValidationError_ShippingAddressValidationError_Fragment = { __typename: 'ShippingAddressValidationError' };

type V3ValidationError_SubscriptionsNotAllowedValidationError_Fragment = { __typename: 'SubscriptionsNotAllowedValidationError', details: Array<{ __typename?: 'SubscriptionsNotAllowedData', itemId: any }> };

type V3ValidationError_UnverifiedEmailValidationError_Fragment = { __typename: 'UnverifiedEmailValidationError' };

type V3ValidationError_VariantArchivedValidationError_Fragment = { __typename: 'VariantArchivedValidationError', cartItemId: any };

type V3ValidationError_VariantBelowMinQuantityValidationError_Fragment = { __typename: 'VariantBelowMinQuantityValidationError', cartItemId: any, minQuantity: number };

type V3ValidationError_VariantCartingAndCheckoutDisallowedValidationError_Fragment = { __typename: 'VariantCartingAndCheckoutDisallowedValidationError' };

type V3ValidationError_VariantExceedsMaximumQuantityValidationError_Fragment = { __typename: 'VariantExceedsMaximumQuantityValidationError', cartItemId: any, maxQuantity: number };

type V3ValidationError_VariantInvalidSubscriptionValidationError_Fragment = { __typename: 'VariantInvalidSubscriptionValidationError', cartItemId: any };

type V3ValidationError_VariantInvalidValidationError_Fragment = { __typename: 'VariantInvalidValidationError', cartItemId: any };

type V3ValidationError_VariantLowStockValidationError_Fragment = { __typename: 'VariantLowStockValidationError', cartItemId: any, inventory: number };

type V3ValidationError_VariantOutOfStockValidationError_Fragment = { __typename: 'VariantOutOfStockValidationError', cartItemId: any, inventory: number };

type V3ValidationError_VariantRequiresTaxExemptAccountValidationError_Fragment = { __typename: 'VariantRequiresTaxExemptAccountValidationError' };

type V3ValidationError_VariantSubscriptionsNotAllowedValidationError_Fragment = { __typename: 'VariantSubscriptionsNotAllowedValidationError', cartItemId: any };

type V3ValidationError_VariantZipCodeRestrictionValidationError_Fragment = { __typename: 'VariantZipCodeRestrictionValidationError', cartItemId: any };

type V3ValidationError_VirtualItemsInCartValidationError_Fragment = { __typename: 'VirtualItemsInCartValidationError', details: Array<{ __typename?: 'VirtualItemsInCartData', cartItemId: any }> };

type V3ValidationError_ZipCodeRestrictionOnItemsValidationError_Fragment = { __typename: 'ZipCodeRestrictionOnItemsValidationError', details: Array<{ __typename?: 'ZipCodeRestrictionOnItemsData', cartItemId: any }> };

type V3ValidationError_ZipCodeRestrictionOnTenantValidationError_Fragment = { __typename: 'ZipCodeRestrictionOnTenantValidationError', details: Array<{ __typename?: 'ZipCodeRestrictionOnTenantData', cartItemId: any }> };

export type V3ValidationErrorFragment = V3ValidationError_ArchivedItemsInCartValidationError_Fragment | V3ValidationError_AssortmentExclusionValidationError_Fragment | V3ValidationError_AssortmentInclusionValidationError_Fragment | V3ValidationError_BundleItemWithoutBundleValidationError_Fragment | V3ValidationError_BundleNotFoundValidationError_Fragment | V3ValidationError_BundleRequirementsNotSatisfiedValidationError_Fragment | V3ValidationError_GuestCartContainsSubscriptionValidationError_Fragment | V3ValidationError_HsppKitRequiresManagedCustomerValidationError_Fragment | V3ValidationError_HsppKitYearlyMaximumReachedValidationError_Fragment | V3ValidationError_HsppPurchaseWindowClosedValidationError_Fragment | V3ValidationError_IncompleteShippingAddressValidationError_Fragment | V3ValidationError_InvalidLoyaltyItemsValidationError_Fragment | V3ValidationError_InventoryValidationError_Fragment | V3ValidationError_ManagedCustomerRequiresHsppKitValidationError_Fragment | V3ValidationError_MinimumAllocationEligibleQuantityValidationError_Fragment | V3ValidationError_MinimumPurchaseAmountValidationError_Fragment | V3ValidationError_MinimumPurchaseQuantityValidationError_Fragment | V3ValidationError_MissingItemTaxInfoValidationError_Fragment | V3ValidationError_PurchaseQtyLimitValidationError_Fragment | V3ValidationError_ScheduledOrderOutOfStockValidationError_Fragment | V3ValidationError_ShippingAddressRestrictionValidationError_Fragment | V3ValidationError_ShippingAddressValidationError_Fragment | V3ValidationError_SubscriptionsNotAllowedValidationError_Fragment | V3ValidationError_UnverifiedEmailValidationError_Fragment | V3ValidationError_VariantArchivedValidationError_Fragment | V3ValidationError_VariantBelowMinQuantityValidationError_Fragment | V3ValidationError_VariantCartingAndCheckoutDisallowedValidationError_Fragment | V3ValidationError_VariantExceedsMaximumQuantityValidationError_Fragment | V3ValidationError_VariantInvalidSubscriptionValidationError_Fragment | V3ValidationError_VariantInvalidValidationError_Fragment | V3ValidationError_VariantLowStockValidationError_Fragment | V3ValidationError_VariantOutOfStockValidationError_Fragment | V3ValidationError_VariantRequiresTaxExemptAccountValidationError_Fragment | V3ValidationError_VariantSubscriptionsNotAllowedValidationError_Fragment | V3ValidationError_VariantZipCodeRestrictionValidationError_Fragment | V3ValidationError_VirtualItemsInCartValidationError_Fragment | V3ValidationError_ZipCodeRestrictionOnItemsValidationError_Fragment | V3ValidationError_ZipCodeRestrictionOnTenantValidationError_Fragment;

export type V3VariantFragment = { __typename?: 'Variant', gtin: string, id: any, imgUrls?: Array<string | null | undefined> | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minQuantity?: number | null | undefined, maximumPurchaseQuantity?: number | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title: string, discounts?: Array<{ __typename?: 'Discount', amount?: number | null | undefined, isPercent?: boolean | null | undefined, type?: CampaignType | null | undefined } | null | undefined> | null | undefined };

export type V3VariantForProductFragment = { __typename?: 'Variant', compareAtPrice?: number | null | undefined, gtin: string, id: any, imgUrls?: Array<string | null | undefined> | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title: string, variantAttributes?: Array<{ __typename?: 'VariantAttribute', id: any, value: string, productAttribute: { __typename?: 'ProductAttribute', name: string } } | null | undefined> | null | undefined };

export const VariantFragmentDoc = gql`
    fragment Variant on Variant {
  id
  gtin
  title
  slug
  imgUrls
  price
  isOutOfStock
  inventoryQty
  compareAtPrice
  minQuantity
  maximumPurchaseQuantity
  subscribable
  subscriptionPrice
  variantAttributes {
    id
    value
    productAttribute {
      name
    }
  }
  product {
    id
    key
    title
    tags {
      key
      value
    }
  }
  discounts {
    id
    activeFrom
    amount
    isPercent
    type
  }
  webData {
    description
    returnsPolicy
    designerArtistBrandName
    dimensions
    material
  }
}
    `;
export const CartVariantItemFragmentDoc = gql`
    fragment CartVariantItem on CartVariantItem {
  id
  gtin
  imgUrls
  inventoryQty
  isOutOfStock
  quantity
  title
  subscriptionIntervalInDays
  perUnitPrice
  strikethroughUnitPrice
  subtotal
  variant {
    ...Variant
  }
}
    ${VariantFragmentDoc}`;
export const V3ValidationErrorFragmentDoc = gql`
    fragment V3ValidationError on ValidationError {
  __typename
  ... on ArchivedItemsInCartValidationError {
    details {
      cartItemId
    }
  }
  ... on BundleItemWithoutBundleValidationError {
    details {
      cartItemId
    }
  }
  ... on MinimumPurchaseAmountValidationError {
    amount
  }
  ... on MinimumPurchaseQuantityValidationError {
    quantity
  }
  ... on PurchaseQtyLimitValidationError {
    details {
      itemId
      purchaseQtyLimit
    }
  }
  ... on IncompleteShippingAddressValidationError {
    __typename
  }
  ... on ScheduledOrderOutOfStockValidationError {
    __typename
  }
  ... on ShippingAddressValidationError {
    __typename
  }
  ... on SubscriptionsNotAllowedValidationError {
    details {
      itemId
    }
  }
  ... on UnverifiedEmailValidationError {
    __typename
  }
  ... on VariantArchivedValidationError {
    cartItemId
  }
  ... on VariantBelowMinQuantityValidationError {
    cartItemId
    minQuantity
  }
  ... on VariantExceedsMaximumQuantityValidationError {
    cartItemId
    maxQuantity
  }
  ... on VariantInvalidSubscriptionValidationError {
    cartItemId
  }
  ... on VariantInvalidValidationError {
    cartItemId
  }
  ... on VariantLowStockValidationError {
    cartItemId
    inventory
  }
  ... on VariantOutOfStockValidationError {
    cartItemId
    inventory
  }
  ... on VariantSubscriptionsNotAllowedValidationError {
    cartItemId
  }
  ... on VariantZipCodeRestrictionValidationError {
    cartItemId
  }
  ... on VirtualItemsInCartValidationError {
    details {
      cartItemId
    }
  }
  ... on ZipCodeRestrictionOnItemsValidationError {
    details {
      cartItemId
    }
  }
  ... on ZipCodeRestrictionOnTenantValidationError {
    details {
      cartItemId
    }
  }
}
    `;
export const CartFragmentDoc = gql`
    fragment Cart on Cart {
  id
  variantItems {
    ...CartVariantItem
  }
  shipping
  subtotal
  total
  validationErrors {
    ...V3ValidationError
  }
}
    ${CartVariantItemFragmentDoc}
${V3ValidationErrorFragmentDoc}`;
export const ItemFieldsForAnalyticsFragmentDoc = gql`
    fragment ItemFieldsForAnalytics on Item {
  id
  title
  price
  brandName
  gtin
}
    `;
export const RecommendedProductFragmentDoc = gql`
    fragment RecommendedProduct on Item {
  id
  title
  compareAtPrice
  price
  isOutOfStock
  slug
  imgUrl
  inventoryQty
  minOrderQty
}
    `;
export const SubmittedOrderFragmentDoc = gql`
    fragment SubmittedOrder on SubmittedOrder {
  id
  status
  price {
    total
    items {
      item {
        id
        imgUrl
      }
      quantity
    }
  }
  contactInfo {
    shippingAddress {
      firstName
      lastName
      line1
      line2
      city
      state
    }
  }
  fulfillments {
    items {
      quantity
    }
  }
  user {
    id
  }
}
    `;
export const V3VariantFragmentDoc = gql`
    fragment V3Variant on Variant {
  discounts {
    amount
    isPercent
    type
  }
  gtin
  id
  imgUrls
  inventoryQty
  isOutOfStock
  minQuantity
  maximumPurchaseQuantity
  price
  slug
  title
}
    `;
export const V3CartFragmentDoc = gql`
    fragment V3Cart on Cart {
  id
  shipping
  subtotal
  total
  variantItems {
    gtin
    id
    imgUrls
    inventoryQty
    isOutOfStock
    perUnitPrice
    quantity
    strikethroughUnitPrice
    subscriptionIntervalInDays
    subtotal
    title
    variant {
      ...V3Variant
    }
  }
}
    ${V3VariantFragmentDoc}`;
export const V3VariantForProductFragmentDoc = gql`
    fragment V3VariantForProduct on Variant {
  compareAtPrice
  gtin
  id
  imgUrls
  inventoryQty
  isOutOfStock
  price
  slug
  title
  variantAttributes {
    id
    productAttribute {
      name
    }
    value
  }
}
    `;
export const ActiveAccountDocument = gql`
    query ActiveAccount {
  activeAccount {
    tags
  }
}
    `;

/**
 * __useActiveAccountQuery__
 *
 * To run a query within a React component, call `useActiveAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActiveAccountQuery, ActiveAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActiveAccountQuery, ActiveAccountQueryVariables>(ActiveAccountDocument, options);
      }
export function useActiveAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveAccountQuery, ActiveAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActiveAccountQuery, ActiveAccountQueryVariables>(ActiveAccountDocument, options);
        }
export type ActiveAccountQueryHookResult = ReturnType<typeof useActiveAccountQuery>;
export type ActiveAccountLazyQueryHookResult = ReturnType<typeof useActiveAccountLazyQuery>;
export type ActiveAccountQueryResult = Apollo.QueryResult<ActiveAccountQuery, ActiveAccountQueryVariables>;
export const AdjustCartItemVariantDocument = gql`
    mutation AdjustCartItemVariant($cartId: UUID4, $input: AdjustCartItemVariantInput!) {
  adjustCartItemVariant(cartId: $cartId, input: $input) {
    ...Cart
  }
}
    ${CartFragmentDoc}`;
export type AdjustCartItemVariantMutationFn = Apollo.MutationFunction<AdjustCartItemVariantMutation, AdjustCartItemVariantMutationVariables>;

/**
 * __useAdjustCartItemVariantMutation__
 *
 * To run a mutation, you first call `useAdjustCartItemVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdjustCartItemVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adjustCartItemVariantMutation, { data, loading, error }] = useAdjustCartItemVariantMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdjustCartItemVariantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdjustCartItemVariantMutation, AdjustCartItemVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdjustCartItemVariantMutation, AdjustCartItemVariantMutationVariables>(AdjustCartItemVariantDocument, options);
      }
export type AdjustCartItemVariantMutationHookResult = ReturnType<typeof useAdjustCartItemVariantMutation>;
export type AdjustCartItemVariantMutationResult = Apollo.MutationResult<AdjustCartItemVariantMutation>;
export type AdjustCartItemVariantMutationOptions = Apollo.BaseMutationOptions<AdjustCartItemVariantMutation, AdjustCartItemVariantMutationVariables>;
export const AdjustCartItemVariantSubscriptionDocument = gql`
    mutation AdjustCartItemVariantSubscription($cartId: UUID4, $variantGtin: String!, $quantity: Int!, $subscriptionIntervalInDays: Int!) {
  adjustCartItemVariantSubscription(
    cartId: $cartId
    input: {variantGtin: $variantGtin, quantity: $quantity, subscriptionIntervalInDays: $subscriptionIntervalInDays}
  ) {
    ...Cart
  }
}
    ${CartFragmentDoc}`;
export type AdjustCartItemVariantSubscriptionMutationFn = Apollo.MutationFunction<AdjustCartItemVariantSubscriptionMutation, AdjustCartItemVariantSubscriptionMutationVariables>;

/**
 * __useAdjustCartItemVariantSubscriptionMutation__
 *
 * To run a mutation, you first call `useAdjustCartItemVariantSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdjustCartItemVariantSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adjustCartItemVariantSubscriptionMutation, { data, loading, error }] = useAdjustCartItemVariantSubscriptionMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      variantGtin: // value for 'variantGtin'
 *      quantity: // value for 'quantity'
 *      subscriptionIntervalInDays: // value for 'subscriptionIntervalInDays'
 *   },
 * });
 */
export function useAdjustCartItemVariantSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdjustCartItemVariantSubscriptionMutation, AdjustCartItemVariantSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdjustCartItemVariantSubscriptionMutation, AdjustCartItemVariantSubscriptionMutationVariables>(AdjustCartItemVariantSubscriptionDocument, options);
      }
export type AdjustCartItemVariantSubscriptionMutationHookResult = ReturnType<typeof useAdjustCartItemVariantSubscriptionMutation>;
export type AdjustCartItemVariantSubscriptionMutationResult = Apollo.MutationResult<AdjustCartItemVariantSubscriptionMutation>;
export type AdjustCartItemVariantSubscriptionMutationOptions = Apollo.BaseMutationOptions<AdjustCartItemVariantSubscriptionMutation, AdjustCartItemVariantSubscriptionMutationVariables>;
export const AdvancedVariantSearchDocument = gql`
    query AdvancedVariantSearch($term: String!) {
  advancedVariantSearch(term: $term) {
    variant {
      ...Variant
    }
    hit
  }
}
    ${VariantFragmentDoc}`;

/**
 * __useAdvancedVariantSearchQuery__
 *
 * To run a query within a React component, call `useAdvancedVariantSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvancedVariantSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvancedVariantSearchQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useAdvancedVariantSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdvancedVariantSearchQuery, AdvancedVariantSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdvancedVariantSearchQuery, AdvancedVariantSearchQueryVariables>(AdvancedVariantSearchDocument, options);
      }
export function useAdvancedVariantSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdvancedVariantSearchQuery, AdvancedVariantSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdvancedVariantSearchQuery, AdvancedVariantSearchQueryVariables>(AdvancedVariantSearchDocument, options);
        }
export type AdvancedVariantSearchQueryHookResult = ReturnType<typeof useAdvancedVariantSearchQuery>;
export type AdvancedVariantSearchLazyQueryHookResult = ReturnType<typeof useAdvancedVariantSearchLazyQuery>;
export type AdvancedVariantSearchQueryResult = Apollo.QueryResult<AdvancedVariantSearchQuery, AdvancedVariantSearchQueryVariables>;
export const CartDocument = gql`
    query Cart($id: UUID4!) {
  cart(id: $id) {
    ...Cart
  }
}
    ${CartFragmentDoc}`;

/**
 * __useCartQuery__
 *
 * To run a query within a React component, call `useCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCartQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CartQuery, CartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CartQuery, CartQueryVariables>(CartDocument, options);
      }
export function useCartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CartQuery, CartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CartQuery, CartQueryVariables>(CartDocument, options);
        }
export type CartQueryHookResult = ReturnType<typeof useCartQuery>;
export type CartLazyQueryHookResult = ReturnType<typeof useCartLazyQuery>;
export type CartQueryResult = Apollo.QueryResult<CartQuery, CartQueryVariables>;
export const CollectionsDocument = gql`
    query Collections {
  collections {
    name
  }
}
    `;

/**
 * __useCollectionsQuery__
 *
 * To run a query within a React component, call `useCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCollectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CollectionsQuery, CollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CollectionsQuery, CollectionsQueryVariables>(CollectionsDocument, options);
      }
export function useCollectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CollectionsQuery, CollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CollectionsQuery, CollectionsQueryVariables>(CollectionsDocument, options);
        }
export type CollectionsQueryHookResult = ReturnType<typeof useCollectionsQuery>;
export type CollectionsLazyQueryHookResult = ReturnType<typeof useCollectionsLazyQuery>;
export type CollectionsQueryResult = Apollo.QueryResult<CollectionsQuery, CollectionsQueryVariables>;
export const CreateCartFromOrderDocument = gql`
    mutation CreateCartFromOrder($orderId: UUID4!) {
  createTemporaryCartFromOrder(orderId: $orderId) {
    id
  }
}
    `;
export type CreateCartFromOrderMutationFn = Apollo.MutationFunction<CreateCartFromOrderMutation, CreateCartFromOrderMutationVariables>;

/**
 * __useCreateCartFromOrderMutation__
 *
 * To run a mutation, you first call `useCreateCartFromOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCartFromOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCartFromOrderMutation, { data, loading, error }] = useCreateCartFromOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCreateCartFromOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCartFromOrderMutation, CreateCartFromOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCartFromOrderMutation, CreateCartFromOrderMutationVariables>(CreateCartFromOrderDocument, options);
      }
export type CreateCartFromOrderMutationHookResult = ReturnType<typeof useCreateCartFromOrderMutation>;
export type CreateCartFromOrderMutationResult = Apollo.MutationResult<CreateCartFromOrderMutation>;
export type CreateCartFromOrderMutationOptions = Apollo.BaseMutationOptions<CreateCartFromOrderMutation, CreateCartFromOrderMutationVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    id
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const CurrentUserWithCartDocument = gql`
    query CurrentUserWithCart {
  currentUser {
    cart {
      id
    }
    id
  }
}
    `;

/**
 * __useCurrentUserWithCartQuery__
 *
 * To run a query within a React component, call `useCurrentUserWithCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserWithCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserWithCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserWithCartQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserWithCartQuery, CurrentUserWithCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserWithCartQuery, CurrentUserWithCartQueryVariables>(CurrentUserWithCartDocument, options);
      }
export function useCurrentUserWithCartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserWithCartQuery, CurrentUserWithCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserWithCartQuery, CurrentUserWithCartQueryVariables>(CurrentUserWithCartDocument, options);
        }
export type CurrentUserWithCartQueryHookResult = ReturnType<typeof useCurrentUserWithCartQuery>;
export type CurrentUserWithCartLazyQueryHookResult = ReturnType<typeof useCurrentUserWithCartLazyQuery>;
export type CurrentUserWithCartQueryResult = Apollo.QueryResult<CurrentUserWithCartQuery, CurrentUserWithCartQueryVariables>;
export const GetCartFromUserDocument = gql`
    query GetCartFromUser {
  currentUser {
    cart {
      ...Cart
    }
  }
}
    ${CartFragmentDoc}`;

/**
 * __useGetCartFromUserQuery__
 *
 * To run a query within a React component, call `useGetCartFromUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartFromUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartFromUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartFromUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCartFromUserQuery, GetCartFromUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCartFromUserQuery, GetCartFromUserQueryVariables>(GetCartFromUserDocument, options);
      }
export function useGetCartFromUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCartFromUserQuery, GetCartFromUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCartFromUserQuery, GetCartFromUserQueryVariables>(GetCartFromUserDocument, options);
        }
export type GetCartFromUserQueryHookResult = ReturnType<typeof useGetCartFromUserQuery>;
export type GetCartFromUserLazyQueryHookResult = ReturnType<typeof useGetCartFromUserLazyQuery>;
export type GetCartFromUserQueryResult = Apollo.QueryResult<GetCartFromUserQuery, GetCartFromUserQueryVariables>;
export const GetItemsByGtinsDocument = gql`
    query getItemsByGtins($gtins: [String!], $pagination: PaginationInput!) {
  searchVariants(pagination: $pagination, search: {gtins: $gtins}) {
    pagination {
      totalPages
    }
    items: variants {
      ...Variant
    }
  }
}
    ${VariantFragmentDoc}`;

/**
 * __useGetItemsByGtinsQuery__
 *
 * To run a query within a React component, call `useGetItemsByGtinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemsByGtinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemsByGtinsQuery({
 *   variables: {
 *      gtins: // value for 'gtins'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetItemsByGtinsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetItemsByGtinsQuery, GetItemsByGtinsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetItemsByGtinsQuery, GetItemsByGtinsQueryVariables>(GetItemsByGtinsDocument, options);
      }
export function useGetItemsByGtinsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetItemsByGtinsQuery, GetItemsByGtinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetItemsByGtinsQuery, GetItemsByGtinsQueryVariables>(GetItemsByGtinsDocument, options);
        }
export type GetItemsByGtinsQueryHookResult = ReturnType<typeof useGetItemsByGtinsQuery>;
export type GetItemsByGtinsLazyQueryHookResult = ReturnType<typeof useGetItemsByGtinsLazyQuery>;
export type GetItemsByGtinsQueryResult = Apollo.QueryResult<GetItemsByGtinsQuery, GetItemsByGtinsQueryVariables>;
export const GetVariantsByCollectionNameDocument = gql`
    query GetVariantsByCollectionName($term: String!, $facetFilters: [[String!]!]) {
  advancedVariantSearch(term: $term, facetFilters: $facetFilters) {
    variant {
      ...Variant
    }
    hit
  }
}
    ${VariantFragmentDoc}`;

/**
 * __useGetVariantsByCollectionNameQuery__
 *
 * To run a query within a React component, call `useGetVariantsByCollectionNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVariantsByCollectionNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVariantsByCollectionNameQuery({
 *   variables: {
 *      term: // value for 'term'
 *      facetFilters: // value for 'facetFilters'
 *   },
 * });
 */
export function useGetVariantsByCollectionNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVariantsByCollectionNameQuery, GetVariantsByCollectionNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVariantsByCollectionNameQuery, GetVariantsByCollectionNameQueryVariables>(GetVariantsByCollectionNameDocument, options);
      }
export function useGetVariantsByCollectionNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVariantsByCollectionNameQuery, GetVariantsByCollectionNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVariantsByCollectionNameQuery, GetVariantsByCollectionNameQueryVariables>(GetVariantsByCollectionNameDocument, options);
        }
export type GetVariantsByCollectionNameQueryHookResult = ReturnType<typeof useGetVariantsByCollectionNameQuery>;
export type GetVariantsByCollectionNameLazyQueryHookResult = ReturnType<typeof useGetVariantsByCollectionNameLazyQuery>;
export type GetVariantsByCollectionNameQueryResult = Apollo.QueryResult<GetVariantsByCollectionNameQuery, GetVariantsByCollectionNameQueryVariables>;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  loginUser(input: {email: $email, password: $password}) {
    id
    email
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutUserDocument = gql`
    mutation logoutUser {
  logoutUser {
    id
  }
}
    `;
export type LogoutUserMutationFn = Apollo.MutationFunction<LogoutUserMutation, LogoutUserMutationVariables>;

/**
 * __useLogoutUserMutation__
 *
 * To run a mutation, you first call `useLogoutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutUserMutation, { data, loading, error }] = useLogoutUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogoutUserMutation, LogoutUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LogoutUserMutation, LogoutUserMutationVariables>(LogoutUserDocument, options);
      }
export type LogoutUserMutationHookResult = ReturnType<typeof useLogoutUserMutation>;
export type LogoutUserMutationResult = Apollo.MutationResult<LogoutUserMutation>;
export type LogoutUserMutationOptions = Apollo.BaseMutationOptions<LogoutUserMutation, LogoutUserMutationVariables>;
export const MergeCartsDocument = gql`
    mutation MergeCarts($srcCartId: UUID4!, $destCartId: UUID4!) {
  mergeCarts(srcCartId: $srcCartId, destCartId: $destCartId) {
    ...Cart
  }
}
    ${CartFragmentDoc}`;
export type MergeCartsMutationFn = Apollo.MutationFunction<MergeCartsMutation, MergeCartsMutationVariables>;

/**
 * __useMergeCartsMutation__
 *
 * To run a mutation, you first call `useMergeCartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeCartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeCartsMutation, { data, loading, error }] = useMergeCartsMutation({
 *   variables: {
 *      srcCartId: // value for 'srcCartId'
 *      destCartId: // value for 'destCartId'
 *   },
 * });
 */
export function useMergeCartsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MergeCartsMutation, MergeCartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MergeCartsMutation, MergeCartsMutationVariables>(MergeCartsDocument, options);
      }
export type MergeCartsMutationHookResult = ReturnType<typeof useMergeCartsMutation>;
export type MergeCartsMutationResult = Apollo.MutationResult<MergeCartsMutation>;
export type MergeCartsMutationOptions = Apollo.BaseMutationOptions<MergeCartsMutation, MergeCartsMutationVariables>;
export const OrdersDocument = gql`
    query Orders {
  submittedOrders(pagination: {page: 1, limit: 10}) {
    submittedOrders {
      ...SubmittedOrder
    }
  }
}
    ${SubmittedOrderFragmentDoc}`;

/**
 * __useOrdersQuery__
 *
 * To run a query within a React component, call `useOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
      }
export function useOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
        }
export type OrdersQueryHookResult = ReturnType<typeof useOrdersQuery>;
export type OrdersLazyQueryHookResult = ReturnType<typeof useOrdersLazyQuery>;
export type OrdersQueryResult = Apollo.QueryResult<OrdersQuery, OrdersQueryVariables>;
export const RequestPasswordResetForUserDocument = gql`
    mutation requestPasswordResetForUser($email: String!, $state: String) {
  requestPasswordResetForUser(input: {email: $email, state: $state}) {
    email
  }
}
    `;
export type RequestPasswordResetForUserMutationFn = Apollo.MutationFunction<RequestPasswordResetForUserMutation, RequestPasswordResetForUserMutationVariables>;

/**
 * __useRequestPasswordResetForUserMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetForUserMutation, { data, loading, error }] = useRequestPasswordResetForUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useRequestPasswordResetForUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestPasswordResetForUserMutation, RequestPasswordResetForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestPasswordResetForUserMutation, RequestPasswordResetForUserMutationVariables>(RequestPasswordResetForUserDocument, options);
      }
export type RequestPasswordResetForUserMutationHookResult = ReturnType<typeof useRequestPasswordResetForUserMutation>;
export type RequestPasswordResetForUserMutationResult = Apollo.MutationResult<RequestPasswordResetForUserMutation>;
export type RequestPasswordResetForUserMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetForUserMutation, RequestPasswordResetForUserMutationVariables>;
export const RestrictedItemsByZipCodeDocument = gql`
    query RestrictedItemsByZipCode($zip: String!) {
  restrictedItemsByZipCode(zip: $zip) {
    restrictedItems {
      id
    }
  }
}
    `;

/**
 * __useRestrictedItemsByZipCodeQuery__
 *
 * To run a query within a React component, call `useRestrictedItemsByZipCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestrictedItemsByZipCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestrictedItemsByZipCodeQuery({
 *   variables: {
 *      zip: // value for 'zip'
 *   },
 * });
 */
export function useRestrictedItemsByZipCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>(RestrictedItemsByZipCodeDocument, options);
      }
export function useRestrictedItemsByZipCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>(RestrictedItemsByZipCodeDocument, options);
        }
export type RestrictedItemsByZipCodeQueryHookResult = ReturnType<typeof useRestrictedItemsByZipCodeQuery>;
export type RestrictedItemsByZipCodeLazyQueryHookResult = ReturnType<typeof useRestrictedItemsByZipCodeLazyQuery>;
export type RestrictedItemsByZipCodeQueryResult = Apollo.QueryResult<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>;
export const SearchProductByKeyDocument = gql`
    query searchProductByKey($key: String!, $pagination: PaginationInput!) {
  searchProducts(pagination: $pagination, search: {keys: [$key]}) {
    pagination {
      totalPages
      total
      page
      count
    }
    products {
      id
      key
      title
      tags {
        key
        value
      }
      variants {
        ...Variant
      }
    }
  }
}
    ${VariantFragmentDoc}`;

/**
 * __useSearchProductByKeyQuery__
 *
 * To run a query within a React component, call `useSearchProductByKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProductByKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProductByKeyQuery({
 *   variables: {
 *      key: // value for 'key'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSearchProductByKeyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchProductByKeyQuery, SearchProductByKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchProductByKeyQuery, SearchProductByKeyQueryVariables>(SearchProductByKeyDocument, options);
      }
export function useSearchProductByKeyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchProductByKeyQuery, SearchProductByKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchProductByKeyQuery, SearchProductByKeyQueryVariables>(SearchProductByKeyDocument, options);
        }
export type SearchProductByKeyQueryHookResult = ReturnType<typeof useSearchProductByKeyQuery>;
export type SearchProductByKeyLazyQueryHookResult = ReturnType<typeof useSearchProductByKeyLazyQuery>;
export type SearchProductByKeyQueryResult = Apollo.QueryResult<SearchProductByKeyQuery, SearchProductByKeyQueryVariables>;
export const SearchVariantsBySlugDocument = gql`
    query searchVariantsBySlug($slug: String!, $pagination: PaginationInput!) {
  searchVariants(pagination: $pagination, search: {slug: $slug}) {
    pagination {
      totalPages
      total
      page
      count
    }
    variants {
      ...Variant
      tags {
        key
        value
      }
    }
  }
}
    ${VariantFragmentDoc}`;

/**
 * __useSearchVariantsBySlugQuery__
 *
 * To run a query within a React component, call `useSearchVariantsBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVariantsBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVariantsBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSearchVariantsBySlugQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchVariantsBySlugQuery, SearchVariantsBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchVariantsBySlugQuery, SearchVariantsBySlugQueryVariables>(SearchVariantsBySlugDocument, options);
      }
export function useSearchVariantsBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchVariantsBySlugQuery, SearchVariantsBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchVariantsBySlugQuery, SearchVariantsBySlugQueryVariables>(SearchVariantsBySlugDocument, options);
        }
export type SearchVariantsBySlugQueryHookResult = ReturnType<typeof useSearchVariantsBySlugQuery>;
export type SearchVariantsBySlugLazyQueryHookResult = ReturnType<typeof useSearchVariantsBySlugLazyQuery>;
export type SearchVariantsBySlugQueryResult = Apollo.QueryResult<SearchVariantsBySlugQuery, SearchVariantsBySlugQueryVariables>;
export const SearchVariantsWithTagsDocument = gql`
    query searchVariantsWithTags($tags: [TagInput!], $pagination: PaginationInput!) {
  searchVariants(pagination: $pagination, search: {tags: $tags}) {
    pagination {
      totalPages
      total
      page
      count
    }
    variants {
      ...Variant
      tags {
        key
        value
      }
    }
  }
}
    ${VariantFragmentDoc}`;

/**
 * __useSearchVariantsWithTagsQuery__
 *
 * To run a query within a React component, call `useSearchVariantsWithTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVariantsWithTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVariantsWithTagsQuery({
 *   variables: {
 *      tags: // value for 'tags'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSearchVariantsWithTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchVariantsWithTagsQuery, SearchVariantsWithTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchVariantsWithTagsQuery, SearchVariantsWithTagsQueryVariables>(SearchVariantsWithTagsDocument, options);
      }
export function useSearchVariantsWithTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchVariantsWithTagsQuery, SearchVariantsWithTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchVariantsWithTagsQuery, SearchVariantsWithTagsQueryVariables>(SearchVariantsWithTagsDocument, options);
        }
export type SearchVariantsWithTagsQueryHookResult = ReturnType<typeof useSearchVariantsWithTagsQuery>;
export type SearchVariantsWithTagsLazyQueryHookResult = ReturnType<typeof useSearchVariantsWithTagsLazyQuery>;
export type SearchVariantsWithTagsQueryResult = Apollo.QueryResult<SearchVariantsWithTagsQuery, SearchVariantsWithTagsQueryVariables>;
export const SignUpUserDocument = gql`
    mutation SignUpUser($input: SignupUserInput!) {
  signupUser(input: $input) {
    id
    email
    hashedEmail
  }
}
    `;
export type SignUpUserMutationFn = Apollo.MutationFunction<SignUpUserMutation, SignUpUserMutationVariables>;

/**
 * __useSignUpUserMutation__
 *
 * To run a mutation, you first call `useSignUpUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpUserMutation, { data, loading, error }] = useSignUpUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SignUpUserMutation, SignUpUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SignUpUserMutation, SignUpUserMutationVariables>(SignUpUserDocument, options);
      }
export type SignUpUserMutationHookResult = ReturnType<typeof useSignUpUserMutation>;
export type SignUpUserMutationResult = Apollo.MutationResult<SignUpUserMutation>;
export type SignUpUserMutationOptions = Apollo.BaseMutationOptions<SignUpUserMutation, SignUpUserMutationVariables>;
export const TenantDocument = gql`
    query Tenant {
  tenant {
    id
    brandConfig {
      title
      copyright
      customizations {
        contacts {
          city
          countryCode
          line1
          line2
          phoneNumber
          state
          type
          zip
        }
        fonts {
          name
          style
          urls {
            format
            local
            url
          }
          weight
          meta {
            key
            value
          }
        }
        images {
          name
          src
          alt
        }
        links {
          location
          position
          title
          url
          newTab
        }
      }
      customTexts {
        body
        links {
          type
          key
          linkValue
          displayValue
        }
        location
        position
        type
      }
      trackingFonts {
        isTrackingRequired
        resource
      }
    }
    shoppingBagConfig {
      maxAmountForSelect
      minimumPurchaseAmount
      minimumPurchaseQty
      availableSubscriptionIntervalsInDays
      orderSubscriptionsEnabled
      subscriptionIntervalsInDays
    }
    shippingConfig {
      fixedFeeShipping
      freeShippingThreshold
    }
    checkout {
      version
    }
    userExperience {
      algoliaSearchActive
    }
  }
}
    `;

/**
 * __useTenantQuery__
 *
 * To run a query within a React component, call `useTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantQuery({
 *   variables: {
 *   },
 * });
 */
export function useTenantQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TenantQuery, TenantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TenantQuery, TenantQueryVariables>(TenantDocument, options);
      }
export function useTenantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TenantQuery, TenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TenantQuery, TenantQueryVariables>(TenantDocument, options);
        }
export type TenantQueryHookResult = ReturnType<typeof useTenantQuery>;
export type TenantLazyQueryHookResult = ReturnType<typeof useTenantLazyQuery>;
export type TenantQueryResult = Apollo.QueryResult<TenantQuery, TenantQueryVariables>;
export const ValidatePasswordDocument = gql`
    query ValidatePassword($password: String!) {
  validatePassword(password: $password) {
    msg
    satisfied
  }
}
    `;

/**
 * __useValidatePasswordQuery__
 *
 * To run a query within a React component, call `useValidatePasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePasswordQuery({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useValidatePasswordQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ValidatePasswordQuery, ValidatePasswordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ValidatePasswordQuery, ValidatePasswordQueryVariables>(ValidatePasswordDocument, options);
      }
export function useValidatePasswordLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValidatePasswordQuery, ValidatePasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ValidatePasswordQuery, ValidatePasswordQueryVariables>(ValidatePasswordDocument, options);
        }
export type ValidatePasswordQueryHookResult = ReturnType<typeof useValidatePasswordQuery>;
export type ValidatePasswordLazyQueryHookResult = ReturnType<typeof useValidatePasswordLazyQuery>;
export type ValidatePasswordQueryResult = Apollo.QueryResult<ValidatePasswordQuery, ValidatePasswordQueryVariables>;